// @ts-nocheck
import { AuthService } from "./../../../common/services/auth.service";
import { MemberListCacheService } from '../members/member-list-cache.service';
import { buildActivityLogPayload } from "common/services/activity-log-payload.util";
import { buildUpdateCustomerVitalsPayload } from "common/services/customer-vitals-payload.util";
import { buildAddSubscriptionPayload } from "common/services/subscription-payload.util";
import {
    addFreezingFeeAndDaysUrl,
    buildDeleteFeePayload,
    canDeleteFeeLifo,
    deleteFeeUrl,
    formatFeeBillingPeriod as formatFeeBillingPeriodLabel,
    formatFeeInvoicePeriodStart,
    formatFeeInvoicePeriodEnd,
    formatPaidThroughLabel,
    getFeeDeleteConfirmationMessage,
    getFeeTypeDisplay as getFeeTypeDisplayLabel,
    getMinAllowedManualDueDate,
    isManualDueDateBeforePaidPeriod,
} from "common/services/customer-fees-payload.util";
import {
    prepareFeeInvoiceForPrint,
    parseSplitPaymentModeLines,
    getReceiptPaymentModeHeader,
    isMultiPaymentModeReceipt,
    getSplitPartLabel,
    SplitPaymentModeLine,
    PaymentSplitRow,
    createEmptySplitRow,
    applyTaxSettingsToRow,
    recalculateRowTax,
    calculateSplitRowTotal,
    sumSplitTax,
    sumSplitPays,
    getSplitAllocationTarget,
    isSplitAllocationValid,
    hasDuplicateSplitPaymentModes,
    getFirstUnusedSplitPaymentMode,
    getSplitPaymentOptionsForRow,
    getSplitGroupFees,
    normalizeSplitGroupId,
    convertNetSplitsToGross,
    proportionalLineDiscount,
    calculateSplitGrandTotal,
    buildSplitPaymentModeLabelFromFees,
    buildSubscriptionSplitReceiptPaymentMode,
    formatSubscriptionPaymentModesDisplay,
} from "common/services/split-payment.util";
import { collectFbrInvoiceIds, fbrDiLogoAbsoluteUrl, fbrQrItems, FbrReceiptItem } from "common/services/fbr-receipt.util";
import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { IMember, IFreezeRequest } from "app/shared/Domains/member";
import { IMemberContact } from "app/shared/Domains/memberContact";
import { IAddress } from "app/shared/Domains/address";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { HttpClient } from "@angular/common/http";
import { Configuration } from "config/config";
import { IMemberFeeDetails } from "app/shared/Domains/feeDetail";
import { ICompany } from "app/shared/Domains/company";
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { WebcamImage, WebcamInitError, WebcamUtil } from "ngx-webcam";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { IMemberFreezeDetail } from "app/shared/Domains/memberFreezeDetail";
import { DatePipe } from "@angular/common";
import { IUser } from "app/shared/Domains/IUser";
import { IRole } from "app/shared/Domains/role";
import { MemberService } from "common/services/member.service";
import { IPackageBuider } from "app/shared/Domains/packageBuilder";
import globalVariable from "../../../globalVariable/globalVariable.json";
import { IEmailFields } from "app/shared/Domains/emailFields";
import { NgxSpinnerService } from "ngx-spinner";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { DataService } from "app/shared/data.service";
import { IBranch } from "app/shared/Domains/branch";
import { AppUtils } from 'common/services/app.util';
import {
    asDateString,
    buildCancelFreezeSchedulePayload,
    buildCancelFreezePayload,
    buildCreateFreezeSchedulePayload,
    buildCustomerTrainerPayload,
    buildDefreezeMemberPayload,
    buildFreezeMemberPayload,
    buildMemberUpdatePayload,
    customerActivateMemberUrl,
    customerCancelFreezeScheduleUrl,
    customerCancelFreezeUrl,
    customerCreateFreezeScheduleUrl,
    customerDefreezeMemberUrl,
    customerFreezeMemberUrl,
    customerIsSyncedUrl,
    customerCreateOnlineBookingInviteUrl,
    customerOnlineBookingInviteStatusUrl,
    customerUpdateUrl,
    buildUpdateWalletAmountPayload,
    walletUpdateAmountUrl,
} from 'common/services/member-update-payload.util';
import moment from "moment";
import { Observable } from "rxjs";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IService } from "app/services/models/service";
import { ISubscription } from "app/services/models/subscription";
import { IFeeDetailPrint } from "app/shared/Domains/feeDetailPrint";
import { SingleReceiptPrintComponent } from "app/shared/receipt/single-receipt-print/single-receipt-print.component";
import { SingleReceiptEmailComponent } from "app/shared/receipt/single-receipt-email/single-receipt-email.component";
import { ISubscriptionFee } from "app/services/models/subscriptionFee";
import { TabView } from "primeng/tabview";
@Component({
    selector: "app-add-members",
    templateUrl: "./add-members.component.html",
    host: { "(window:keyup)": "hotkeysMemberDetails($event)" },
    styleUrls: ["./add-members.component.css"],
})
export class AddMembersComponent implements OnInit {
    public Editor = ClassicEditor;
    memberConfirmVisible = false;
    memberConfirmVariant: 'secondary' = 'secondary';
    memberConfirmHeading = '';
    memberConfirmMessage = '';
    memberConfirmIconClass = '';
    memberConfirmSlideText = 'Slide to confirm';
    memberConfirmDoneText = 'Confirmed';
    memberConfirmCancelText = 'Cancel';
    memberConfirmSlideIconClass = 'pi pi-angle-double-right';
    memberConfirmCancelIconClass = 'pi pi-times';
    memberConfirmConfirmText = 'Yes';
    memberConfirmConfirmIconClass = 'pi pi-check';
    private pendingMemberConfirmation: (() => void | Promise<void>) | null = null;
    @ViewChild("memberTabView") memberTabView: TabView;
    @ViewChild(SingleReceiptPrintComponent) singleReceiptPrintComponent: SingleReceiptPrintComponent;
    @ViewChild(SingleReceiptEmailComponent) singleReceiptEmailComponent: SingleReceiptEmailComponent;
    @ViewChild("memberAccessQrBox") memberAccessQrBox: ElementRef;
    servicesPackageName:string = "";
    trainerPackageId: string;
    passwordType1: string = "password";
    passwordType2: string = "password";
    passwordType3: string = "password";
    addProfileImage: any;
    nPassword: string = "";
    cPassword: string = "";
    member: IMember;
    referralOptions: any[];
    referralOther:any;
    paymentMode: any;
    errorExempleNumber: any;
    company: ICompany;
    branch: IBranch;
    mode: string;
    branchName: string;
    subscription: any;
    options: any[];
    statusOptions: any[];
    trainerOptions: any[];
    loading: boolean;
    Trainers: any[];
    fund: IMemberFeeDetails;
    subscriptionFeeSinglePrint: IFeeDetailPrint;
    fundInvoice: IMemberFeeDetails;
    fbrLogoUrl = '';
    fbrItems: FbrReceiptItem[] = [];

    /** Subscription receipt: all FBR ids from the parent fee, blanks dropped. */
    private setSubscriptionFbrIds(fee: { FBRInvoiceID?: string; FBRInvoiceIDs?: string[] }): void {
        const ids = collectFbrInvoiceIds(fee);
        this.subscriptionFeeSinglePrint.FBRInvoiceID = fee.FBRInvoiceID || '';
        this.subscriptionFeeSinglePrint.FBRInvoiceIDs = ids;
    }
    fundCollectiveInvoice: IMemberFeeDetails[] = [];
    memberID: any;
    feeDetailsSource: any;
    printAllFeeTotal: any = {};
    uploadProfile: any;
    uploadProfilePath: any;
    dialogVisibility: boolean;
    extendFreezeDaysDialog: boolean = false;
    complimentaryFreezeDialogVisible: boolean = false;
    complimentaryFreezeStartDate: Date | null = null;
    complimentaryFreezeEndDate: Date | null = null;
    complimentaryFreezeSelectedDays: number = 0;
    complimentaryFreezeSubmitting: boolean = false;
    minComplimentaryFreezeDate: Date = new Date();
    freezeAmount:number;
    freezeDays:number;
    freezeFeeDescription:string;
    feeTotal: number;
    feeTotalTax: number;
    remainingBalance: any;
    selectedOption: any;
    date: any;
    dialogVisible: boolean;
    seletedStatus: any;
    public webcamImage: WebcamImage = null;
    months: any[];
    years: any[];
    array: any[];
    freezeMemberDetails: any[];
    difference: number;
    feegreater: Boolean;
    feealreadypaid: Boolean;
    trainerNotSelected = false;
    memeberSetting: boolean = true;
    sessionCountChanged: boolean = false;
    role: IRole;
    user: IUser;
    packageName: any;
    packageNameUpdate: any;
    oldPassword: any;
    newPassword: any = '';
    index: any = '';
    confirmPass: any;
    newConfirmPassword: any;
    packages: IPackageBuider[] = [];
    packagesDropDown: any[] = [];
    isShowAddProfileImage: boolean;
    showEmailReceiptConfirmationBox: boolean = false;
    showEmailSingleReceiptConfirmationBox: boolean = false;
    showCommentBox: boolean = false;

    htmlToPdf: any;
    showActiceFreezeBox: boolean = false;
    isFeeRecord: boolean = false;
    email: IEmailFields = new IEmailFields();
    isGymShareMoreThanTrainerFee: boolean = false;
    isEmailExist: boolean = false;
    isEmailLoader: boolean = false;
    timer: any;
    dbEmailIfCustomerHAve: any;
    currentUser = '';
    companySessionStorage = '';
    branchSessionStorage = '';
    oldMemberImage: any;
    numOfMonths: number;
    previousDueDate: Date;
    firstInvoice: string;
    memberTrainer: any;
    openFeeDialog: any;
    imgPreview: boolean = false;
    imgPreviewImg: any;
    allowDialog: boolean;
    isDialogVisible: boolean;
    isFeeMessageVisible: boolean = true;
    currentUserData: any;
    packageToShowName: any;
    updateMemberSettingFlag: boolean = false;
    private memberDueDateSnapshotAtLoad: Date | null = null;
    private operatorDueDateEdited = false;
    minManualDueDate: Date | null = null;
    dueDateBillingError: string | null = null;
    showCommentDialog: boolean = false;
    dialogDescription: any = '';
    registrationPaid = false;
    monthlyPaid = false;
    trainerPaid = false;
    discountAmount: number = 0;
    feeTotalDiscount: number;
    packageFee: any;
    packageRegistrationFee: any;
    showMonthlyFeeError: boolean = false;
    showRegistrationFeeError: boolean = false;
    showTrainerFeeError: boolean = false;
    numberOfMembers: any;
    confirmationBoxMessage: any;
    paymentOptions: any;
    allPaymentOptions: any;
    sessionCount: any;
    selectedFile: File;
    selectedFileName: string;
    modifiedFileName: string;
    trainerSessions: any;
    activityLogsResult: any[] = [];
    memberPortalInviteSendCount = 0;
    from: any;
    to: any;
    welcomeMsg:boolean;
    taxType :string;
    taxRate: number;
    feeInvoiceDialog: boolean = false;
    feeInvoiceDialogCheck: boolean = false;
    canAddSubscription: boolean = true;
    subscriptionTabActive: boolean = false;
    /** New trainer module: mount book-trainer only after tab click (no API on member open). */
    bookTrainerTabOpened: boolean = false;
    addSubscriptionPopupVisible: boolean = false;
    countries: any[];
    selectedSubscription: any;
    selectedTrainerInSubscriptionDb: any;
    selectedTrainerFee: any;
    subscriptionFee: number;
    subscriptionDiscount: number;
    subscriptionTax: number;
    taxRemovalOnSubscription: boolean = false;
    isDiscountFormulaReverse: boolean = false;
    SubscriptionPopupLoading: boolean = true;
    subscriptionMultiplePaymentModesEnabled: boolean = false;
    subscriptionCascadeOverlayOptions = { autoZIndex: true, baseZIndex: 12000 };
    subscriptionPaymentSplits: PaymentSplitRow[] = [];
    subscriptionSplitValidationMessage: string = '';

    allSubscriptions: any[];
    selectedTrainerInSubscription: SelectItem;
    trainersInSubscription: SelectItem[];
    services: IService[];
    subscribedServices: IService[];
    serviceInDetailView: IService[];
    serviceSubscriptions: ISubscription[];
    subscriptions: ISubscription[];
    groupedSubscriptions: any[] = [];
    allSubscriptionsFee:ISubscriptionFee[];
    subFee:any;
    subscriptionDetail: any;
    activeSubscriptionSessionsList = [];
    private subscriptionAttendanceLoadId = 0;
    selectedServiceForSubscription: IService;
    hideTaxInfo: boolean=false;
    sessionsStartDate: Date;
    sessionsEndDate: Date;
    subscriptionsDetailView: boolean = false;
    isActiveSubscriptionAvailable: boolean = false;
    whatsAppCommunityLink: any;
    isPackageUpdated: boolean = false;
    whatsAppCommunityLinkMessage: string;
    description: any;
    serviceType: string;
    invoiceData: any;
    invoiceMessage: any;
    customerPackageId = '';
    formattedNumber: string = '';
    isPackageDialogVisible: boolean = false;
    isWalletDialogVisible: boolean = false;
    isChangePaymentModeDialogVisible: boolean = false;
    paymentModeEditTarget: 'memberFee' | 'subscriptionFee' = 'memberFee';
    splitInvoiceDateGroupCount = 0;
    selectedPaymentMode: String;
    currentSelectedFee:any;
    paymentModeReceiptFile: File = null;
    paymentModeReceiptFileName: string = '';
    isUpdatingPaymentModeReceipt: boolean = false;
    selectedPackageId: string | undefined;
    selectedSecondaryToAdd: string = null;
    secondaryPackageSaving = false;
    customerFees: any;
    customerCardTemplate: any;
    dateOfBirthError: boolean = false;
    selectedIdentityType: string = 'CNIC';
    errorMessage: string = '';
    trainerFeeErrorDialogVisible: boolean = false;
    trainerFeeErrorDialogMessage: string = '';
    showBodySpecPopup = false;
    getBodySpecs :[] = [];
    selectedBodySpec: any = null
    addVitalsDialog: boolean = false;
    updateBodySpecDialogVisible = false;
    memberProfileImage:string;
    bloodGroupOptions: any[] = [];
    updateWalletAmount: number;
    walletDetails: any;
    walletAmount: number;
    newWalletAmount:number;
    isWalletAllowed: boolean;
    bodySpec = {
        totalBodyWater: 0,
        protein: 0,
        mineral: 0,
        bodyFatMass: 0,
        weight: 0,
        sMM: 0,
        bMI: 0,
        pBF: 0,
        waistHipRatio: 0,
        visceralFatLevel: 0,
        height: 0,
        _id: 0,
    };
    hideMemberSettingFromOp: boolean=false;
    hideSubFeeBtnFromOp: boolean=false;
    trainerSharePercentage: number;
    gymSharePercentage: number;
    isChangeInvoiceDateDialogVisible: boolean = false;
    selectedInvoiceDate: Date;
    invoiceDateEditTarget: 'memberFee' | 'subscriptionFee' = 'memberFee';
    relatedMembersGroup: any = null;
    relatedMembersLoading: boolean = false;
    addRelatedMemberDialogVisible: boolean = false;
    addRelatedMemberOptionsLoading: boolean = false;
    memebrsOfBranchWithRelatedPackage: any[] = [];
    branchMembersOptions: any[] = [];
    branchMembersOptionsPackageId: string | null = null;
    selectedMemberToAddId: string = '';
    selectedMemberPackage:IPackageBuider;
    memberAccessQrLoading: boolean = false;
    memberAccessQrStatus: string = '';
    private qrCodeLibPromise: Promise<any> = null;
    private originalMemberSnapshot: any = null;
    constructor(
        private LanguageService: LanguageService,
        private memberService: MemberService,
        private route: ActivatedRoute,
        private router: Router,
        private loader: NgxSpinnerService,
        private confirmationService: ConfirmationService,
        private datePipe: DatePipe,
        private _http: HttpClient,
        public config: Configuration,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private dataService: DataService,
        private memberListCache: MemberListCacheService
    ) {
        route.params.subscribe((params) => {
            const routeMemberId = params["id"];
            if (this.memberID === undefined) {
                this.memberID = routeMemberId;
            } else if (this.memberID !== routeMemberId) {
                this.memberID = routeMemberId;
                this.bookTrainerTabOpened = false;
                this.clearBranchMembersOptionsCache();
                this.relatedMembersGroup = null;
                this.getCustomerByID();
                this.getCustomerFees();
            }
            if (params && params.subscription == "true") {
                this.index = 2;
                this.subscriptionTabActive = true;
            } else if (params && params.defaulter == "true"
                || params && params.fee == "true") {
                this.index = 1;
                this.getCustomerFees();
            } else {
                this.index = 0;
            }
        });
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddMembersComponent", label);
      }
    ngOnInit() {
        this.route.queryParams.subscribe((queryParams) => {
            if (queryParams['openFeeDialog']) {
                this.openFeeDialog = queryParams['openFeeDialog'];
            }
        });
        this.bloodGroupOptions = [
            { label: 'Select Blood Group', value: '' },
            { label: 'A+', value: 'A+' },
            { label: 'A-', value: 'A-' },
            { label: 'B+', value: 'B+' },
            { label: 'B-', value: 'B-' },
            { label: 'AB+', value: 'AB+' },
            { label: 'AB-', value: 'AB-' },
            { label: 'O+', value: 'O+' },
            { label: 'O-', value: 'O-' }
        ]
        this.discountAmount = 0;
        this.subscriptionFeeSinglePrint = new IFeeDetailPrint();
        this.subscriptionFeeSinglePrint.invoice = "";
        this.subscriptionFeeSinglePrint.createdDate = new Date();
        this.subscriptionFeeSinglePrint.startDate = new Date();
        this.subscriptionFeeSinglePrint.endDate = new Date();
        this.subscriptionFeeSinglePrint.membershipNumber = "";
        this.subscriptionFeeSinglePrint.memberName = "";
        this.subscriptionFeeSinglePrint.feeType = "";
        this.subscriptionFeeSinglePrint.fee = "";
        this.subscriptionFeeSinglePrint.tax = "";
        this.subscriptionFeeSinglePrint.discount = "";
        this.freezeFeeDescription = "";
        this.subscriptionFeeSinglePrint.taxRate = 0;
        this.subscriptionFeeSinglePrint.taxCalculationType = "";
        this.subscriptionFeeSinglePrint.paymentMode = "";
        this.subscribedServices = [];
        this.subscriptionDiscount = 0;
        this.sessionsStartDate = new Date();
        this.sessionsEndDate = new Date();
        this.subscriptionTax = 0;
        this.paymentOptions = [
            { label: 'Cash - Reception', value: 'Cash-Reception' },
        ];
        this.isDialogVisible = true;
        this.currentUser = localStorage.getItem('currentUser');
        const currentUseroBJ = JSON.parse(this.currentUser);
        this.currentUserData = currentUseroBJ;
        this.companySessionStorage = currentUseroBJ.company;
        this.branchSessionStorage = currentUseroBJ.branch;
        this.paymentMode = "Cash-Reception";
        this.getBranchById();
        this.addProfileImage = "Cam"; // Upload | Cam
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        if (this.role.name === "Admin" || this.role.name === "Super Admin") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.initObjects();
        this.loading = false;
        this.dialogVisibility = false;
        this.dialogVisible = false;
        this.member.contactDetail.address.country = "Pakistan";
        // this.member.contactDetail.address.city = "Islamabad";
        var date = new Date();
        this.from = new Date(date.getFullYear(), date.getMonth(), 1);
        this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from.setHours(0, 0, 0, 0);
        this.to.setHours(23, 59, 59, 999);
        this.getCompany();
        this.getBranch();
        this.getTrainers();
        this.getPackages();
        if (this.memberID) {
            this.getWalletByMemberId(this.memberID);
        }
        this.getBodySpecification();
        this.minComplimentaryFreezeDate = new Date();
        this.minComplimentaryFreezeDate.setHours(0, 0, 0, 0);
        this.date = new Date();
        this.email = new IEmailFields();
        if (this.memberID !== null && this.memberID !== undefined) {
            this.mode = "edit";
            this.getCustomerByID();

            this.getCustomerFees();
        } else {
            this.mode = "add";
            this.breadcrumbService.setItems([
                { label: "Member Management" },
                { label: "All Members", routerLink: "/members" },
                { label: "Add New member" },
            ]);
        }
    }

    get isBiometricRegistered(): boolean {
        return this.member?.Biometrics?.fingerprint === true;
    }

    get isFaceRegistered(): boolean {
        return this.member?.Biometrics?.face === true;
    }

    showRelatedMembersTab(): boolean {
        return this.selectedMemberPackage?.noOfMembers > 1 && this.selectedMemberPackage?.groupFeePayByOnePerson === true;
        // this.selectedMemberPackage.packageType === 'Person Wise Package' &&
        // this.selectedMemberPackage?.groupFeePayByOnePerson === true &&
    }

    isSameHistoryActive(): boolean {
        const pkg = this.selectedMemberPackage;
        return !!(
            pkg?.groupFeePayByOnePerson &&
            (pkg?.noOfMembers ?? 0) > 1 &&
            pkg?.sameHistory === true
        );
    }

    private startOfDayTime(value: unknown): number | null {
        if (value == null || value === '') {
            return null;
        }
        const d = value instanceof Date ? new Date(value) : new Date(String(value));
        if (Number.isNaN(d.getTime())) {
            return null;
        }
        d.setHours(0, 0, 0, 0);
        return d.getTime();
    }

    private dueDatesMatch(a: unknown, b: unknown): boolean {
        const ta = this.startOfDayTime(a);
        const tb = this.startOfDayTime(b);
        return ta != null && tb != null && ta === tb;
    }

    private isMemberDueDateChanging(): boolean {
        return !this.isSameMemberDueDate(
            this.member.settings?.dueDate,
            this.memberDueDateSnapshotAtLoad,
        );
    }

    private getSameHistoryGroupConfirmMessage(
        action:
            | 'freeze'
            | 'defreeze'
            | 'cancelFreeze'
            | 'scheduleFreeze'
            | 'cancelScheduleFreeze'
            | 'dueDate',
    ): string | null {
        if (!this.isSameHistoryActive() || !this.member?.relatedMembersId) {
            return null;
        }
        if (action === 'freeze') {
            return 'Same history is enabled. This will freeze all related group members. Are you sure?';
        }
        if (action === 'defreeze') {
            return 'Same history is enabled. This will defreeze all related group members. Are you sure?';
        }
        if (action === 'cancelFreeze') {
            return 'Same history is enabled. This will cancel freeze for all related group members. Are you sure?';
        }
        if (action === 'scheduleFreeze') {
            return 'Same history is enabled. This will schedule freeze for all related group members. Are you sure?';
        }
        if (action === 'cancelScheduleFreeze') {
            return 'Same history is enabled. This will cancel the scheduled freeze for all related group members. Are you sure?';
        }
        return 'Same history is enabled. This will update the due date for all related group members. Are you sure?';
    }


    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if (this.branch) {
            this.applyBranchSideEffects(this.branch);
        }
        // Always refresh from API — login cache misses trainerModule.enabled after settings save
        const branchId = this.user?.branch || AuthService.getLoggedInBranch();
        if (!branchId) {
            if (!this.branch) {
                this.branch = new IBranch();
            }
            return;
        }
        this.appServiceManager.get('branches/' + branchId).subscribe(
            (res) => {
                if (res) {
                    this.branch = res;
                    localStorage.setItem('currentBranch', JSON.stringify(res));
                    this.applyBranchSideEffects(res);
                } else if (!this.branch) {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: 'Info Message',
                        detail: 'Something Went Wrong',
                    });
                }
            },
            (error) => {
                if (!this.branch) {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: error,
                    });
                }
            },
        );
    }

    private applyBranchSideEffects(branch: IBranch) {
        this.invoiceData = branch.invoiceData;
        this.taxRemovalOnSubscription = branch.permissions?.taxRemovalOnSubscription;
        this.isDiscountFormulaReverse = !!branch.permissions?.isDiscountFormulaReverse;
        this.invoiceMessage = branch.invoiceData?.invoiceMessage;
        this.hideMemberSettingFromOp = branch.permissions?.hideMemberSettingFromOp;
        this.hideSubFeeBtnFromOp = branch.permissions?.hideSubFeeBtnFromOp;
        if (this.user.role === 'Super Admin' || this.user.role === 'Admin') {
            this.hideMemberSettingFromOp = false;
            this.hideSubFeeBtnFromOp = false;
        }
        if (Array.isArray(branch.payments) && branch.payments.length) {
            const length = branch.payments.length;
            this.taxType = branch.payments[length - 1].taxSettings.taxCalculationType;
            this.taxRate = branch.payments[length - 1].taxSettings.taxRate;
            const paymentModes = branch.payments.filter(
                (x) => x.taxSettings.taxCalculationType == 'NO_TAX',
            );
            this.hideTaxInfo = paymentModes.length == branch.payments.length;
        }
    }

    getActivityLogs() {
        this.loading = true;
        const formatDate = (date: Date) => {
            return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
          };
          const formattedFrom = formatDate(new Date(this.from));
          const formattedTo = formatDate(new Date(this.to));
        if (this.from <= this.to) {
          const apiUrl = `system/branches/${AuthService.getLoggedInBranch()}/activity-logs/members/${this.member._id}?dateFrom=${formattedFrom}&dateTo=${formattedTo}`;

          this.appServiceManager.get(apiUrl).subscribe(
            (requests) => {
              if (requests.length === 0) {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'NoActivity Log Record Found' });
              }
              this.activityLogsResult = requests.response;
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          );
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
        }
      }

    showChangePaymentModeDialog(
        fee,
        target: 'memberFee' | 'subscriptionFee' = 'memberFee',
    ) {
        this.paymentModeEditTarget = target;
        this.currentSelectedFee = fee;
        this.clearPaymentModeReceiptSelection();
        this.isChangePaymentModeDialogVisible = true;
        this.selectedPaymentMode = fee?.paymentMode || 'Cash-Reception';
    }

    onPaymentModeDialogUpdate() {
        if (this.paymentModeEditTarget === 'subscriptionFee') {
            this.updateSubscriptionPaymentMode(this.selectedPaymentMode);
        } else {
            this.updatePaymentMode(this.selectedPaymentMode);
        }
    }

    clearPaymentModeReceiptSelection(): void {
        this.paymentModeReceiptFile = null;
        this.paymentModeReceiptFileName = '';
        const fileInput = document.getElementById(
            'paymentModeReceiptFileInput',
        ) as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    onPaymentModeDialogSelectionChange(): void {
        if (!this.paymentModeNeedsReceipt(this.selectedPaymentMode)) {
            this.clearPaymentModeReceiptSelection();
        }
    }

    private paymentModeNeedsReceipt(mode: any): boolean {
        const value = String(mode || '');
        return value.includes('Online-') || value.includes('Check-');
    }

    private canManageFeeReceipt(): boolean {
        const roleName =
            this.role?.name || this.user?.role || this.currentUserData?.role;
        return roleName === 'Admin' || roleName === 'Super Admin';
    }

    shouldShowPaymentModeReceiptUpload(): boolean {
        return (
            this.paymentModeEditTarget === 'memberFee' &&
            this.canManageFeeReceipt() &&
            this.paymentModeNeedsReceipt(this.selectedPaymentMode)
        );
    }

    onPaymentModeReceiptUploadClick(): void {
        if (!this.shouldShowPaymentModeReceiptUpload()) {
            return;
        }
        const fileInput = document.getElementById(
            'paymentModeReceiptFileInput',
        ) as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
            fileInput.click();
        }
    }

    onPaymentModeReceiptFileSelected(event: any): void {
        const file: File = event?.target?.files?.[0];
        if (!file) {
            this.clearPaymentModeReceiptSelection();
            return;
        }
        this.paymentModeReceiptFileName = file.name;
        const modifiedFileName =
            file.name + ':' + this.user.company + ':' + this.user.branch;
        this.paymentModeReceiptFile = new File([file], modifiedFileName, {
            type: file.type,
        });
    }

    private async uploadAndSavePaymentModeReceipt(feeId: string): Promise<void> {
        if (!this.paymentModeReceiptFile || !feeId) {
            return;
        }
        const formData = new FormData();
        formData.append(
            'feeReceiptImage',
            this.paymentModeReceiptFile,
            this.paymentModeReceiptFile.name,
        );

        const uploadRes: any = await this.appServiceManager
            .post(
                'branches/' +
                    this.user.branch +
                    '/customers/upload/fee-receipt-only',
                formData,
            )
            .toPromise();

        const feeReceiptImageUrl = uploadRes?.data?.feeReceiptImageUrl;
        if (!uploadRes?.status || !feeReceiptImageUrl) {
            throw new Error(uploadRes?.message || 'Failed to upload receipt');
        }

        const updateRes: any = await this.appServiceManager
            .patch(
                `branches/${this.user.branch}/customer-fees/actions/update-fee-receipt`,
                {
                    id: feeId,
                    feeReceiptImageUrl,
                },
            )
            .toPromise();

        if (updateRes?.status === false) {
            throw new Error(
                updateRes?.error || 'Failed to update fee receipt',
            );
        }
    }

    private getMemberFeeDetailsList(): any[] {
        if (!this.feeDetailsSource) {
            return [];
        }
        try {
            return JSON.parse(this.feeDetailsSource) ?? [];
        } catch {
            return [];
        }
    }

    private isSplitFeeRow(fee: any): boolean {
        return (
            fee?.isSplitPayment === true &&
            normalizeSplitGroupId(fee?.splitGroupId) != null
        );
    }

    canEditCollectedFeePaymentMode(fee: any): boolean {
        if (
            !fee ||
            isMultiPaymentModeReceipt(fee.paymentMode) ||
            (Array.isArray(fee.splits) && fee.splits.length >= 2) ||
            String(fee.paymentMode || '').toLowerCase() === 'split'
        ) {
            return false;
        }
        if (fee.isSplitPayment === true && !this.isSplitFeeRow(fee)) {
            return false;
        }
        if (this.role?.name === 'Super Admin') {
            return true;
        }
        return (
            this.role?.name === "Admin" &&
            this.branch?.permissions?.allowToEditPaymentMode === true
        );
    }

    getSubscriptionPaymentModeDisplay(subscription: any): string {
        return formatSubscriptionPaymentModesDisplay(subscription);
    }

    private applySubscriptionFeeDisplayFields(subscription: any, fee: any): void {
        if (!subscription || !fee) return;
        subscription.pay = fee.pay;
        subscription.tax = fee.tax;
        subscription.paymentMode = fee.paymentMode;
        subscription.discount = fee.discount;
        subscription.description = fee.description;
        subscription.splits = fee.splits;
        subscription.isSplitPayment = fee.isSplitPayment;
    }

    canEditInvoiceDate(): boolean {
        return (
            this.role?.name === "Super Admin" ||
            (this.role?.name === "Admin" &&
                this.branch?.permissions?.allowToEditInvoiceDate === true)
        );
    }

    canDeleteSubscription(): boolean {
        const roleName = (this.user?.role || this.role?.name || "").toString();
        return roleName === "Admin" || roleName === "Super Admin";
    }

    showChangeInvoiceDateDialog(fee){
        this.invoiceDateEditTarget = 'memberFee';
        this.currentSelectedFee=fee;
        this.splitInvoiceDateGroupCount = getSplitGroupFees(
            this.getMemberFeeDetailsList(),
            fee,
        ).length;
        this.isChangeInvoiceDateDialogVisible = true;
        this.selectedInvoiceDate = fee && fee.date ? new Date(fee.date) : null;
    }

    getSplitInvoiceDateSyncNoteLine1(): string {
        const template = this.setLabel('splitInvoiceDateSyncNoteLine1Label');
        return template.replace(/\{count\}/g, String(this.splitInvoiceDateGroupCount));
    }

    showChangeSubscriptionInvoiceDateDialog(subscription) {
        this.invoiceDateEditTarget = 'subscriptionFee';
        this.splitInvoiceDateGroupCount = 0;
        this.currentSelectedFee = subscription;
        this.isChangeInvoiceDateDialogVisible = true;
        const currentDate =
            subscription?.createdDate || subscription?.date || null;
        this.selectedInvoiceDate = currentDate ? new Date(currentDate) : null;
    }

    private isSameInvoiceDate(
        current: Date | string | null | undefined,
        selected: Date,
    ): boolean {
        if (!current || !selected) {
            return false;
        }
        return new Date(current).getTime() === new Date(selected).getTime();
    }

    subscribeService() {
        if (this.selectedServiceForSubscription === null || this.selectedServiceForSubscription === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }
        if (this.selectedTrainerInSubscriptionDb === null || this.selectedTrainerInSubscriptionDb === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }
        if (this.selectedTrainerFee === null || this.selectedTrainerFee === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }

        if (this.subscriptionMultiplePaymentModesEnabled) {
            this.recalculateSubscriptionSplitRows();
            const splitValidationError = this.getSubscriptionSplitValidationMessage();
            if (splitValidationError) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: splitValidationError,
                });
                return;
            }
        }

        const feeObj = this.subscriptionMultiplePaymentModesEnabled
            ? this.buildSubscriptionSplitFeePayload()
            : {
                paymentMode: this.paymentMode,
                taxType: this.taxType,
                taxRate: this.taxRate,
                tax: this.subscriptionTax,
                fee: this.subscriptionFee,
                discount: this.subscriptionDiscount,
                description : this.description,
            };

        const subscriptionObj = buildAddSubscriptionPayload({
            service: this.selectedServiceForSubscription,
            trainer: this.selectedTrainerInSubscriptionDb,
            trainerPackage: this.selectedTrainerFee,
            fee: feeObj,
            currentUserData: this.currentUserData,
            subscriberType: "Member",
            initiatedFrom: "Member",
            type: "Subscription",
            subscriberId: this.memberID,
            startDate: this.sessionsStartDate,
            endDate: this.sessionsEndDate,
            sessionsFrequency: 0,
            subscriberName: this.member.name,
            subscriberMembership: this.member.tagNumber,
            createdBy: this.currentUserData.name,
            description: this.description,
            profile: this.memberProfileImage,
        });

        this.SubscriptionPopupLoading = true;
        this.appServiceManager.post(`branches/${this.user.branch}/subscriptions`, subscriptionObj)
            .subscribe(
                (res) => {
                    const apiResponse = res?.response;
                    const newSubscription = apiResponse?.subscription ?? apiResponse;
                    if (newSubscription?._id) {
                        if (this.serviceType === 'selfService' && this.selectedTrainerFee) {
                            newSubscription.trainerPackageId = this.selectedTrainerFee._id;
                            newSubscription.servicePackageNames = [this.selectedTrainerFee.name || this.selectedTrainerFee.packageName || this.selectedTrainerFee.title];
                        } else if (this.serviceType !== 'selfService' && this.selectedTrainerInSubscriptionDb) {
                            newSubscription.name = this.selectedTrainerInSubscriptionDb.name;
                            if (this.selectedTrainerFee) {
                                newSubscription.trainerPackageId = this.selectedTrainerFee._id;
                            }
                        }
                    }
                    this.getAllSubscriptions();
                    this.getAllSubscriptionFee();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Subscription added successfully.",
                    });
                    if (apiResponse?.subscriptionFee) {
                        this.subscriptionFeePrint(apiResponse.subscriptionFee, apiResponse.subscription);
                    }
                    this.SubscriptionPopupLoading = false;
                    this.addSubscriptionPopupVisible = false;
                },
                (error) => {
                    this.SubscriptionPopupLoading = false;
                    console.log(error);
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: "Add Subscription failed.",
                    });
                });
    }

    subscriptionFeePrint(subscriptionFee, subscription?){
        const fee = subscriptionFee;
                    this.subscriptionFeeSinglePrint.invoice = this.formatSubscriptionInvoice(fee.invoice);
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(subscription?.startDate || fee.start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(subscription?.dueDate || fee.end);
                    this.subscriptionFeeSinglePrint.showSubscriptionPeriod = true;
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.addedBy = fee.createdBy || '';
                    const isTrainingService = this.serviceType === 'trainingService';
this.subscriptionFeeSinglePrint.showTrainerBookingDetails = isTrainingService;
this.subscriptionFeeSinglePrint.trainerName = isTrainingService
    ? this.selectedTrainerInSubscriptionDb?.name || ''
    : '';
                   this.subscriptionFeeSinglePrint.feeType = this.resolveSubscriptionReceiptFeeType(fee, this.serviceType);
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    this.subscriptionFeeSinglePrint.paymentMode = buildSubscriptionSplitReceiptPaymentMode(fee);
                    this.subscriptionFeeSinglePrint.SRBInvoiceID = fee.SRBInvoiceID || '';
                    this.subscriptionFeeSinglePrint.SRBInvoiceIDs = Array.isArray(fee.SRBInvoiceIDs)
                        ? fee.SRBInvoiceIDs.filter((id) => !!id)
                        : (fee.SRBInvoiceID ? [fee.SRBInvoiceID] : []);
                    this.setSubscriptionFbrIds(fee);
                    setTimeout(() => {
                        this.singleReceiptPrintComponent.initiatePrintInvoice(this.subscriptionFeeSinglePrint);
                    }, 300);
    }

    private buildSubscriptionReceiptPaymentMode(fee: any): string {
        return buildSubscriptionSplitReceiptPaymentMode(fee);
    }

    /** Receipt Type column: DB stores status "Paid"; show full fee type label. */
    private resolveSubscriptionReceiptFeeType(fee: any, serviceType?: string): string {
    const status = String(fee?.status || '').trim();

    if (serviceType === 'trainingService') {
        return `Trainer Fee - ${!status || status === 'Paid' ? 'Paid' : status}`;
    }

    if (!status || status === 'Paid') {
        return 'Subscription Fee - Paid';
    }

    if (status.toLowerCase().includes('subscription')) {
        return status;
    }

    return `Subscription Fee - ${status}`;
}

    formatSubscriptionInvoice(invoice: string): string {
        if (!invoice) {
            return invoice;
        }
        const subscriptionPrefix = "Subscription-";
        const rawInvoice = invoice.startsWith(subscriptionPrefix)
            ? invoice.slice(subscriptionPrefix.length)
            : invoice;
        let normalizedInvoice = rawInvoice.replace(/^Inv%/, "Inv#");
        const invoiceParts = this.parseInvoiceParts(normalizedInvoice);
        if (invoiceParts) {
            normalizedInvoice = `Inv#-${invoiceParts.year}-${invoiceParts.month}-${invoiceParts.counter}`;
        }
        return `${subscriptionPrefix}${normalizedInvoice}`;
    }

    private parseInvoiceParts(invoice: string): { year: string; month: string; counter: number } | null {
        const parts = invoice.trim().split("-");
        if (parts.length < 4) {
            return null;
        }
        const counterPart = parts[parts.length - 1];
        const monthPart = parts[parts.length - 2];
        const yearPart = parts[parts.length - 3];
        const counter = parseInt(counterPart, 10);
        const month = parseInt(monthPart, 10);
        const year = parseInt(yearPart, 10);
        if (isNaN(counter) || isNaN(month) || isNaN(year)) {
            return null;
        }
        return {
            year: year.toString(),
            month: month.toString().padStart(2, "0"),
            counter,
        };
    }

    getNthTypeDay(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    }

    handleChange(e) {
        if (e.index === 1) {
            if (this.member.settings.dueDate) {
                if (
                    this.member.isDelete == false &&
                    this.member.freezeDetail.isFreeze == false
                ) {
                    let dueDate = new Date(this.member.settings.dueDate).getDate();
                    if (dueDate >= 20 && dueDate <= 31) {
                        this.appServiceManager
                            .get('branches/' + this.user.branch + '/customers/actions/fee-check-month/' + this.member._id)
                            .subscribe(
                                (res: Date) => {
                                    this.fund.month =
                                        new Date(res).getMonth() + 1;
                                },
                                (error: any) => {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail: error,
                                    });
                                }
                            );
                    } else {
                        var date = new Date();
                        this.fund.month = date.getMonth() + 1;
                    }
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Due Date is not Selected!",
                });
            }
        }
        if (e.index === 2) {
            this.subscriptionTabActive = true;
        }
        else {
            this.subscriptionTabActive = false;
        }
        const activeTab = this.memberTabView?.tabs?.[e.index];
        if (activeTab?.headerStyleClass === "related-members-tab") {
            this.getRelatedMembersGroup();
        }
        if (activeTab?.headerStyleClass === "book-trainer-tab") {
            this.bookTrainerTabOpened = true;
        }
    }

    subscriptionSelectionChanged() {
        this.selectedServiceForSubscription = this.services.filter(t => t._id === this.selectedSubscription.serviceId)[0];
        this.serviceType = this.selectedServiceForSubscription.type;
        if(this.selectedServiceForSubscription.type === 'selfService'){
            this.selectedTrainerInSubscriptionDb = this.selectedServiceForSubscription.packages.filter(t => t._id === this.selectedSubscription.feeId);
            this.selectedTrainerFee = this.selectedTrainerInSubscriptionDb[0];
            this.subscriptionFee   = parseInt(this.selectedTrainerFee.packageFee);
        }else{
        this.selectedTrainerInSubscriptionDb = this.Trainers.filter(t => t._id === this.selectedSubscription.trainerId)[0];
        this.selectedTrainerFee = this.selectedTrainerInSubscriptionDb.fees.filter(t => t._id === this.selectedSubscription.feeId)[0];
        this.subscriptionFee = this.selectedTrainerFee.totalFee;
        }
        this.updateSubscriptionDatesByPackageType();
        this.onPaymentModeChange(this.paymentMode);
        this.recalculateSubscriptionSplitRows();
    }

    onSubscriptionStartDateChange() {
        this.updateSubscriptionDatesByPackageType();
    }

    getSelectedSubscriptionPackageType(): string {
        const rawPackageType = (
            this.selectedTrainerFee?.subscriptionExpiry ||
            this.selectedTrainerFee?.packageType ||
            ''
        ).toString().trim();
        if (rawPackageType) {
            return rawPackageType;
        }

        // Training fees may not always include packageType; infer from title/name when possible.
        const fallbackText = (
            this.selectedTrainerFee?.title ||
            this.selectedTrainerFee?.name ||
            this.selectedSubscription?.feeName ||
            ''
        ).toString().toLowerCase();

        if (fallbackText.includes('hybrid')) {
            return 'Hybrid';
        }
        if (fallbackText.includes('one time') || fallbackText.includes('onetime')) {
            return 'One Time';
        }
        if (fallbackText.includes('month')) {
            return 'Month Wise';
        }
        if (fallbackText.includes('session')) {
            return 'Session Wise';
        }
        return '';
    }

    shouldShowSubscriptionEndDate(): boolean {
        const packageType = this.getSelectedSubscriptionPackageType();
        return packageType !== '' && packageType !== 'One Time';
    }

    isAutoCalculatedSubscriptionEndDate(): boolean {
        const packageType = this.getSelectedSubscriptionPackageType();
        return packageType === 'Month Wise' || packageType === 'Session Wise' || packageType === 'Hybrid';
    }

    shouldShowNumberOfMonthsInSubscriptionPopup(): boolean {
        const packageType = this.getSelectedSubscriptionPackageType();
        return packageType === 'Month Wise' || packageType === 'Hybrid';
    }

    shouldShowNumberOfSessionsInSubscriptionPopup(): boolean {
        const packageType = this.getSelectedSubscriptionPackageType();
        return packageType === 'Session Wise' || packageType === 'Hybrid';
    }

    getSubscriptionDurationCount(): number | string {
        if (!this.selectedTrainerFee) {
            return "Subscription not selected";
        }

        if (this.shouldShowNumberOfMonthsInSubscriptionPopup() && !this.shouldShowNumberOfSessionsInSubscriptionPopup()) {
            return this.getSubscriptionMonthsCount();
        }

        return this.getSubscriptionSessionsCount();
    }

    getSubscriptionMonthsCount(): number | string {
        if (!this.selectedTrainerFee) {
            return "Subscription not selected";
        }
        return this.selectedTrainerFee?.numberOfMonths
            || this.selectedTrainerFee?.numOfMonths
            || this.selectedTrainerFee?.months
            || 0;
    }

    getSubscriptionSessionsCount(): number | string {
        if (!this.selectedTrainerFee) {
            return "Subscription not selected";
        }
        return this.selectedTrainerFee?.numberOfSessions || 0;
    }

    private updateSubscriptionDatesByPackageType() {
        const packageType = this.getSelectedSubscriptionPackageType();
        if (!packageType) {
            return;
        }

        if (packageType === 'One Time') {
            this.sessionsStartDate = null;
            this.sessionsEndDate = null;
            return;
        }

        const startDate = this.sessionsStartDate ? new Date(this.sessionsStartDate) : new Date();
        this.sessionsStartDate = startDate;

        if (packageType === 'Month Wise' || packageType === 'Hybrid') {
            const numberOfMonths = Number(
                this.selectedTrainerFee?.numberOfMonths
                || this.selectedTrainerFee?.numOfMonths
                || this.selectedTrainerFee?.months
                || (packageType === 'Hybrid' ? 0 : this.selectedTrainerFee?.numberOfSessions)
                || 1
            );
            const endDate = new Date(startDate.getTime());
            endDate.setMonth(endDate.getMonth() + (numberOfMonths > 0 ? numberOfMonths : 1));
            this.sessionsEndDate = endDate;
            return;
        }

        if (packageType === 'Session Wise') {
            const numberOfSessions = this.selectedTrainerFee?.numberOfSessions || 0;
            const endDate = new Date(startDate.getTime());
            endDate.setDate(endDate.getDate() + numberOfSessions);
            this.sessionsEndDate = endDate;
            return;
        }

        this.sessionsEndDate = this.sessionsEndDate || new Date(startDate.getTime());
    }

    openAddSubscriptionDialog() {
        this.addSubscriptionPopupVisible = true;
        this.getAllServices();
        this.resetSubscriptionForm();
    }

    resetSubscriptionForm() {
        this.selectedSubscription = null;
        this.selectedTrainerInSubscriptionDb = null;
        this.selectedTrainerFee = null;
        this.selectedServiceForSubscription = null;
        this.subscriptionFee = 0;
        this.subscriptionDiscount = 0;
        this.subscriptionTax = 0;
        this.sessionsStartDate = new Date();
        this.sessionsEndDate = new Date();
        this.description = '';
        this.serviceType = '';
        this.subscriptionMultiplePaymentModesEnabled = false;
        this.subscriptionPaymentSplits = [];
        this.subscriptionSplitValidationMessage = '';
    }

    getAllSubscriptions() {
        this.appServiceManager.get(`branches/${this.user.branch}/subscriptions/members/${this.memberID}`).subscribe(
            (res) => {
                if (res) {
                    this.subscriptions = res.response;
                    this.getAllServices();
                    this.getAllSubscriptionFee();
                    // Refresh grouped subscriptions if a service detail view is currently active
                    if (this.subscriptionsDetailView && this.serviceInDetailView) {
                        this.refreshGroupedSubscriptions();
                    }
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }
    getAllSubscriptionFee() {
        this.appServiceManager.get(`branches/${this.user.branch}/subscription-fees/members/${this.memberID}`).subscribe(
            (res) => {
                if (res) {
                    this.allSubscriptionsFee = res.response;
                    if (this.subscriptionsDetailView && this.serviceInDetailView) {
                        const service: any = Array.isArray(this.serviceInDetailView) ? this.serviceInDetailView[0] : this.serviceInDetailView;
                        if (service?.type === 'selfService') {
                            this.prepareSelfServiceDetailData(service);
                        } else if (service) {
                            this.prepareServiceDetailData(service);
                        }
                    }
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshGroupedSubscriptions() {
        // Update serviceSubscriptions with the newly fetched subscriptions
        if (this.serviceInDetailView) {
            const service = Array.isArray(this.serviceInDetailView) ? this.serviceInDetailView[0] : this.serviceInDetailView;
            this.serviceSubscriptions = this.subscriptions.filter(s => s.serviceId == service._id);

            // Update subscription details with fee information
            this.serviceSubscriptions.forEach(ss => {
                this.subFee = this.allSubscriptionsFee.filter(x => x.subscriptionId == ss._id);
                if (this.subFee && this.subFee.length > 0) {
                    this.applySubscriptionFeeDisplayFields(ss, this.subFee[0]);
                }
            });

            // Re-sort subscriptions
            this.serviceSubscriptions = this.serviceSubscriptions.sort((a: any, b: any) => Date.parse(b.dueDate) - Date.parse(a.dueDate));

            // Recalculate grouped subscriptions for display
            this.groupedSubscriptions = this.getGroupedSubscriptionsByService();
            this.loadSubscriptionAttendanceCounts();
        }
    }

    getServiceStatus(serviceId){
        let servicesSubscriptions = this.subscriptions.filter(ss => ss.serviceId == serviceId);
        let check = false;
        servicesSubscriptions.forEach(s => {
            let status = this.getSubscriptionStatus(s.dueDate);
            if(status == "Active") {
                check = true;
            }
        });
        if(check) {
            return "Active";
        }
        return "Expired";
    }

    getSubscriptionType(type) {
        if(type === "trainingService") {
            return "Training Service";
        }else if(type === "selfService"){
            return "Self Service"
        }
    }

    getSubscriptionPackageType(subscription: any) {
        if (!subscription) {
            return '';
        }

        // For self services, get the package type from the matching package
        if (subscription.type === 'selfService' && this.serviceInDetailView) {
            const service: any = Array.isArray(this.serviceInDetailView) ? this.serviceInDetailView[0] : this.serviceInDetailView;
            if (service && service.packages) {
                const matchingPackage = service.packages.find(
                    pkg => pkg._id === subscription.trainerPackageId
                );
                const packageType = this.getPackageTypeFromFeeOrPackage(matchingPackage);
                if (packageType) {
                    return packageType;
                }
            }
        }

        // For training services, get the package type from the trainer's fee
        if (subscription.type === 'trainingService' && subscription.trainerId && this.Trainers) {
            const trainer = this.Trainers.find(t => t._id === subscription.trainerId);
            if (trainer && trainer.fees) {
                // Try to find by trainerPackageId first
                let matchingFee = trainer.fees.find(f => f._id === subscription.trainerPackageId);

                // If not found by trainerPackageId, try by feeId
                if (!matchingFee && subscription.feeId) {
                    matchingFee = trainer.fees.find(f => f._id === subscription.feeId);
                }

                const packageType = this.getPackageTypeFromFeeOrPackage(matchingFee);
                if (packageType) {
                    return packageType;
                }

                // Fallback when subscriptionExpiry is missing: treat as session-wise if numberOfSessions is set
                if (matchingFee?.numberOfSessions != null) {
                    return 'Session Wise';
                }
            }
        }

        // Secondary fallback: infer from subscription display fields.
        const inferredTypeFromSubscription = this.inferPackageTypeFromText(
            subscription?.feeName || subscription?.title || subscription?.name || ''
        );
        if (inferredTypeFromSubscription) {
            return inferredTypeFromSubscription;
        }

        if (subscription.type === 'trainingService' && subscription.numberOfSessions != null) {
            return 'Session Wise';
        }

        // For training services or if package not found, return subscription type
        return this.getSubscriptionType(subscription.type);
    }

    private getPackageTypeFromFeeOrPackage(feeOrPackage: any): string {
        if (!feeOrPackage) {
            return '';
        }

        const rawPackageType = (feeOrPackage.subscriptionExpiry || feeOrPackage.packageType || '').toString().trim();
        if (rawPackageType) {
            return rawPackageType;
        }

        return this.inferPackageTypeFromText(feeOrPackage?.title || feeOrPackage?.name || '');
    }

    private inferPackageTypeFromText(rawText: string): string {
        const text = (rawText || '').toString().toLowerCase();
        if (!text) {
            return '';
        }
        if (text.includes('hybrid')) {
            return 'Hybrid';
        }
        if (text.includes('session')) {
            return 'Session Wise';
        }
        if (text.includes('month')) {
            return 'Month Wise';
        }
        if (text.includes('one time') || text.includes('onetime')) {
            return 'One Time';
        }
        return '';
    }

    getSubscriptionTrainer(trainerId) {
        return this.Trainers.filter(t => t._id == trainerId)[0]?.name || 'Deleted Trainer';
    }

    showSubscriptionDetails(services) {
        if(services.type === 'selfService'){
        this.prepareSelfServiceDetailData(services);
    }else{
        this.prepareServiceDetailData(services);
    }
        this.subscriptionsDetailView = true;
    }

    prepareServiceDetailData(services) {
        this.isActiveSubscriptionAvailable = false;
        this.serviceSubscriptions = [];
        this.activeSubscriptionSessionsList = [];
        this.serviceSubscriptions = this.subscriptions.filter(s => s.serviceId == services._id);
        this.serviceInDetailView = services;
        let activeTrainers = "";
        let activeTrainersList = [];
        let totalActiveSessions = 0;
        let totalActiveConductedSessions = 0;
        let activeSessionsStartDate = new Date();
        activeSessionsStartDate.setDate(activeSessionsStartDate.getDate() + 5)
        let activeSessionsDueDate = new Date();
        this.serviceSubscriptions.forEach(ss => {
            let check = this.getSubscriptionStatus(ss.dueDate);
            if(check == "Active") {
                this.isActiveSubscriptionAvailable = true;
                let trainerCheck = activeTrainersList.filter(x => x == ss.trainerId);
                if(trainerCheck.length == 0) {
                    let trainerName = this.getSubscriptionTrainer(ss.trainerId);
                    if(activeTrainers.length != 0) {
                        trainerName = ", "+ trainerName;
                    }
                    activeTrainers += trainerName;
                    activeTrainersList.push(ss.trainerId);
                }
                totalActiveSessions += this.getSubscriptionDisplayedSessionCount(ss);
                totalActiveConductedSessions += 0;
                if(this.getOlderDateInLoopOfSubscriptions(activeSessionsStartDate, ss.startDate)) {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                else {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                if(this.getDueDateInLoopOfSubscriptions(activeSessionsDueDate, ss.dueDate)) {
                    activeSessionsDueDate = new Date(ss.dueDate);
                }
            }
            this.subFee = this.allSubscriptionsFee.filter(x=>x.subscriptionId == ss._id);
            if (this.subFee && this.subFee.length > 0) {
                this.applySubscriptionFeeDisplayFields(ss, this.subFee[0]);
            }
        });
        this.subscriptionDetail = {};
        this.subscriptionDetail.trainers = activeTrainers;
        this.subscriptionDetail.totalSessions = totalActiveSessions;
        this.subscriptionDetail.totalConductedSessions = totalActiveConductedSessions;
        this.subscriptionDetail.startDate = activeSessionsStartDate;
        this.subscriptionDetail.dueDate = activeSessionsDueDate;
        this.subscriptionDetail.totalNoShowSessions = 0;
        this.subscriptionDetail.remainingSessions = totalActiveSessions - totalActiveConductedSessions;

        this.serviceSubscriptions = this.serviceSubscriptions.sort((a:any, b:any) => Date.parse(b.dueDate) - Date.parse(a.dueDate));

        // Cache the grouped subscriptions to avoid repeated calculations in template
        this.groupedSubscriptions = this.getGroupedSubscriptionsByService();
        this.loadSubscriptionAttendanceCounts();
    }

    prepareSelfServiceDetailData(services) {
        this.isActiveSubscriptionAvailable = false;
        this.serviceSubscriptions = [];
        this.activeSubscriptionSessionsList = [];
        this.serviceSubscriptions = this.subscriptions.filter(s => s.serviceId == services._id);
        this.serviceInDetailView = services;
        let activeTrainers = "";
        let activeTrainersList = [];
        let totalActiveSessions = 0;
        let totalActiveConductedSessions = 0;
        let activeSessionsStartDate = new Date();
        activeSessionsStartDate.setDate(activeSessionsStartDate.getDate() + 5)
        let activeSessionsDueDate = new Date();
        this.serviceSubscriptions.forEach(subscription => {
            // Only initialize if not already set
            if (!subscription.servicePackageNames || subscription.servicePackageNames.length === 0) {
                subscription.servicePackageNames = []; // Initialize as an empty array

                services?.packages.forEach(pkg => {
                    if (subscription.trainerPackageId === pkg._id) {
                        subscription.servicePackageNames.push(pkg.name); // Store all matching package names
                    }
                });

                if (subscription.servicePackageNames.length === 0) {
                    subscription.servicePackageNames.push('Deleted Package');
                }
            }
        });

        this.serviceSubscriptions.forEach(ss => {
            let check = this.getSubscriptionStatus(ss.dueDate);
            if(check == "Active") {
                this.isActiveSubscriptionAvailable = true;
                totalActiveSessions += this.getSubscriptionDisplayedSessionCount(ss);
                totalActiveConductedSessions += 0;
                if(this.getOlderDateInLoopOfSubscriptions(activeSessionsStartDate, ss.startDate)) {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                else {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                if(this.getDueDateInLoopOfSubscriptions(activeSessionsDueDate, ss.dueDate)) {
                    activeSessionsDueDate = new Date(ss.dueDate);
                }
            }
            this.subFee = this.allSubscriptionsFee.filter(x=>x.subscriptionId == ss._id);
            if (this.subFee && this.subFee.length > 0) {
                this.applySubscriptionFeeDisplayFields(ss, this.subFee[0]);
            }
        });
        this.subscriptionDetail = {};
        this.subscriptionDetail.trainers = activeTrainers;
        this.subscriptionDetail.totalSessions = totalActiveSessions;
        this.subscriptionDetail.totalConductedSessions = totalActiveConductedSessions;
        this.subscriptionDetail.startDate = activeSessionsStartDate;
        this.subscriptionDetail.dueDate = activeSessionsDueDate;
        this.subscriptionDetail.totalNoShowSessions = 0;
        this.subscriptionDetail.remainingSessions = totalActiveSessions - totalActiveConductedSessions;

        this.serviceSubscriptions = this.serviceSubscriptions.sort((a:any, b:any) => Date.parse(b.dueDate) - Date.parse(a.dueDate));

        // Cache the grouped subscriptions to avoid repeated calculations in template
        this.groupedSubscriptions = this.getGroupedSubscriptionsByService();
        this.loadSubscriptionAttendanceCounts();
    }

    /**
     * Session attendance is stored in two places:
     * - legacy trainingSessions (ATTENDED / NO–SHOW)
     * - trainer_bookings from Session Attendance (Present / Absent)
     * View details must count both so remaining/conducted update after marking.
     */
    loadSubscriptionAttendanceCounts() {
        const subscriptions = this.serviceSubscriptions || [];
        subscriptions.forEach((subscription) => {
            subscription.totalConductedSessions = 0;
            subscription.totalNoShowSessions = 0;
        });

        if (!this.user?.branch || !subscriptions.length) {
            this.applySubscriptionAttendanceSummary();
            return;
        }

        const loadId = ++this.subscriptionAttendanceLoadId;
        let pending = subscriptions.length + 1;
        const finish = () => {
            pending -= 1;
            if (pending > 0 || loadId !== this.subscriptionAttendanceLoadId) {
                return;
            }
            this.applySubscriptionAttendanceSummary();
        };

        subscriptions.forEach((subscription) => {
            this.appServiceManager.get(`branches/${this.user.branch}/subscriptions/${subscription._id}/sessions`).subscribe(
                (res) => {
                    if (loadId === this.subscriptionAttendanceLoadId) {
                        const sessions = Array.isArray(res?.response) ? res.response : (Array.isArray(res) ? res : []);
                        if (sessions.length) {
                            this.activeSubscriptionSessionsList = this.activeSubscriptionSessionsList.concat(sessions);
                        }
                        this.addAttendanceCountsToSubscription(
                            subscription,
                            sessions.filter((session) => this.isSessionAttendedStatus(session?.status)).length,
                            sessions.filter((session) => this.isSessionNoShowStatus(session?.status)).length,
                        );
                    }
                    finish();
                },
                () => finish(),
            );
        });

        if (!this.memberID) {
            finish();
            return;
        }

        this.appServiceManager.get(`branches/${this.user.branch}/trainer-bookings?customerId=${this.memberID}`).subscribe(
            (res) => {
                if (loadId === this.subscriptionAttendanceLoadId) {
                    const bookings = Array.isArray(res) ? res : (Array.isArray(res?.response) ? res.response : []);
                    this.applyTrainerBookingAttendance(bookings);
                }
                finish();
            },
            () => finish(),
        );
    }

    applyTrainerBookingAttendance(bookings: any[]) {
        (bookings || []).forEach((booking) => {
            const isPresent = this.isSessionAttendedStatus(booking?.status);
            const isAbsent = this.isSessionNoShowStatus(booking?.status);
            if (!isPresent && !isAbsent) {
                return;
            }
            const subscription = this.findSubscriptionForTrainerBooking(booking);
            if (!subscription) {
                return;
            }
            this.addAttendanceCountsToSubscription(
                subscription,
                isPresent ? 1 : 0,
                isAbsent ? 1 : 0,
            );
        });
    }

    findSubscriptionForTrainerBooking(booking: any) {
        const subscriptions = this.serviceSubscriptions || [];
        if (!subscriptions.length) {
            return null;
        }

        const trainerId = this.normalizeId(booking?.trainerId);
        const packageId = this.normalizeId(booking?.packageId);
        const bookingDate = this.parseAttendanceDate(booking?.createdAt || booking?.updatedAt);

        let pool = subscriptions;
        if (trainerId) {
            const sameTrainer = subscriptions.filter((s) => this.normalizeId(s.trainerId) === trainerId);
            if (!sameTrainer.length) {
                return null;
            }
            pool = sameTrainer;
        }
        if (packageId) {
            const samePackage = pool.filter((s) => this.normalizeId(s.trainerPackageId) === packageId);
            if (samePackage.length) {
                pool = samePackage;
            }
        }

        if (bookingDate) {
            const inRange = pool.filter((s) => this.isDateInSubscriptionRange(bookingDate, s.startDate, s.dueDate));
            if (inRange.length === 1) {
                return inRange[0];
            }
            if (inRange.length > 1) {
                return this.pickLatestSubscription(inRange);
            }
        }

        const active = pool.filter((s) => this.getSubscriptionStatus(s.dueDate) === 'Active');
        if (active.length) {
            return this.pickLatestSubscription(active);
        }
        return this.pickLatestSubscription(pool);
    }

    pickLatestSubscription(subscriptions: any[]) {
        if (!subscriptions?.length) {
            return null;
        }
        return [...subscriptions].sort((a, b) => Date.parse(b.dueDate) - Date.parse(a.dueDate))[0];
    }

    isDateInSubscriptionRange(date: Date, startDate: any, dueDate: any) {
        const start = startDate ? new Date(startDate) : null;
        const end = dueDate ? new Date(dueDate) : null;
        if (start && !isNaN(start.getTime())) {
            start.setHours(0, 0, 0, 0);
            if (date < start) {
                return false;
            }
        }
        if (end && !isNaN(end.getTime())) {
            end.setHours(23, 59, 59, 999);
            if (date > end) {
                return false;
            }
        }
        return true;
    }

    parseAttendanceDate(value: any): Date | null {
        if (!value) {
            return null;
        }
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }

    normalizeId(value: any): string {
        if (value == null) {
            return '';
        }
        if (typeof value === 'object' && value._id != null) {
            return String(value._id);
        }
        return String(value);
    }

    isSessionAttendedStatus(status: string): boolean {
        const normalized = String(status || '').trim().toLowerCase();
        return normalized === 'attended' || normalized === 'present';
    }

    isSessionNoShowStatus(status: string): boolean {
        const normalized = String(status || '').trim().toLowerCase().replace(/[–—]/g, '-');
        return normalized === 'no-show' || normalized === 'no_show' || normalized === 'noshow' || normalized === 'absent';
    }

    addAttendanceCountsToSubscription(subscription: any, conducted: number, noShow: number) {
        if (!subscription) {
            return;
        }
        subscription.totalConductedSessions = (Number(subscription.totalConductedSessions) || 0) + (conducted || 0);
        subscription.totalNoShowSessions = (Number(subscription.totalNoShowSessions) || 0) + (noShow || 0);
    }

    applySubscriptionAttendanceSummary() {
        const subscriptions = this.serviceSubscriptions || [];
        subscriptions.forEach((subscription) => {
            const total = this.getSubscriptionDisplayedSessionCount(subscription);
            const conducted = Number(subscription.totalConductedSessions) || 0;
            const noShow = Number(subscription.totalNoShowSessions) || 0;
            subscription.remainingSessions = Math.max(0, total - conducted - noShow);
        });

        let totalSessions = 0;
        let conductedSessions = 0;
        let noShowSessions = 0;
        subscriptions.forEach((subscription) => {
            if (this.getSubscriptionStatus(subscription.dueDate) !== 'Active') {
                return;
            }
            totalSessions += this.getSubscriptionDisplayedSessionCount(subscription);
            conductedSessions += Number(subscription.totalConductedSessions) || 0;
            noShowSessions += Number(subscription.totalNoShowSessions) || 0;
        });

        if (!this.subscriptionDetail) {
            this.subscriptionDetail = {};
        }
        this.subscriptionDetail.totalSessions = totalSessions;
        this.subscriptionDetail.totalConductedSessions = conductedSessions;
        this.subscriptionDetail.totalNoShowSessions = noShowSessions;
        this.subscriptionDetail.remainingSessions = Math.max(0, totalSessions - conductedSessions - noShowSessions);
        this.groupedSubscriptions = this.getGroupedSubscriptionsByService();
    }
getSingleSubscriptionFeePrint(id, start, end, serviceType?: string) {
        this.appServiceManager.get(`branches/${this.user.branch}/subscription-fees/subscriptions/${id}`).subscribe(
            (res) => {
                if (res) {
                    const fee = res.response[0];
                    this.subscriptionFeeSinglePrint.invoice = this.formatSubscriptionInvoice(fee.invoice);
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(end);
                    this.subscriptionFeeSinglePrint.showSubscriptionPeriod = true;
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.addedBy = fee.createdBy || '';
                    const isTrainingService = serviceType === 'trainingService';
const subscription = this.subscriptions?.find(s => s._id === id);
const trainerId = subscription?.trainerId || fee.trainerId;
const trainer = this.Trainers?.find(t => t._id === trainerId);

this.subscriptionFeeSinglePrint.showTrainerBookingDetails = isTrainingService;
this.subscriptionFeeSinglePrint.trainerName = isTrainingService
    ? trainer?.name || ''
    : '';
                   this.subscriptionFeeSinglePrint.feeType = this.resolveSubscriptionReceiptFeeType(fee, serviceType);
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    this.subscriptionFeeSinglePrint.paymentMode = this.buildSubscriptionReceiptPaymentMode(fee);
                    this.subscriptionFeeSinglePrint.SRBInvoiceID = fee.SRBInvoiceID || '';
                    this.subscriptionFeeSinglePrint.SRBInvoiceIDs = Array.isArray(fee.SRBInvoiceIDs)
                        ? fee.SRBInvoiceIDs.filter((id) => !!id)
                        : (fee.SRBInvoiceID ? [fee.SRBInvoiceID] : []);
                    this.setSubscriptionFbrIds(fee);
                    setTimeout(() => {
                        this.singleReceiptPrintComponent.initiatePrintInvoice(this.subscriptionFeeSinglePrint);
                    }, 300);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getSingleSubscriptionFeeEmail(id, start, due) {
        this.appServiceManager.get(`branches/${this.user.branch}/subscription-fees/subscriptions/${id}`).subscribe(
            (res) => {
                if (res) {
                    const fee = res.response[0];
                    this.subscriptionFeeSinglePrint.invoice = this.formatSubscriptionInvoice(fee.invoice);
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(due);
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.feeType = this.resolveSubscriptionReceiptFeeType(fee);
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    this.subscriptionFeeSinglePrint.paymentMode = this.buildSubscriptionReceiptPaymentMode(fee);
                    this.subscriptionFeeSinglePrint.SRBInvoiceID = fee.SRBInvoiceID || '';
                    this.subscriptionFeeSinglePrint.SRBInvoiceIDs = Array.isArray(fee.SRBInvoiceIDs)
                        ? fee.SRBInvoiceIDs.filter((id) => !!id)
                        : (fee.SRBInvoiceID ? [fee.SRBInvoiceID] : []);
                    this.setSubscriptionFbrIds(fee);
                    setTimeout(() => {
                        this.singleReceiptEmailComponent.openSingleReceiptEmailConfirmation(this.subscriptionFeeSinglePrint, due);
                    }, 300);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }
    
getSingleSubscriptionFeeWhatsapp(id, due) {
    const receiver = this.member?.contactDetail?.contact;

    if (!receiver) {
        this.messageService.clear();
        this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'This user does not have a phone number'
        });
        return;
    }

    this.appServiceManager
        .get(`branches/${this.user.branch}/subscription-fees/subscriptions/${id}`)
        .subscribe(
            (res: any) => {
                const fee = res?.response?.[0];

                if (!fee) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: 'Subscription invoice not found'
                    });
                    return;
                }

                const invoice = this.formatSubscriptionInvoice(fee.invoice);
                const date = new Date(fee.date);
                const monthName = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();
                const day = date.getDate();

                let pay = Number(fee.pay) || 0;
                const tax = Number(fee.tax) || 0;
                const discount = Number(fee.discount) || 0;

                if (fee.taxType === 'WITH_TAX') {
                    pay += tax;
                }

                pay = Math.max(0, pay - discount);

                const dueDate = due
                    ? new Date(due).toLocaleDateString('en-US', {
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric'
                    })
                    : '';

                const subscription = this.subscriptions.find(
    (s: any) => String(s._id) === String(fee.subscriptionId)
);

const trainerName = subscription?.trainerId
    ? this.getSubscriptionTrainer(subscription.trainerId)
    : 'N/A';
                    let msg = this.config.subscriptionInvoiceMessage;

                const paidDate = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
});

const values: { [key: string]: string } = {
    '{0}': fee.subscriberName || this.member.name,
    '{1}': paidDate,
    '{2}': String(fee.subscriberMembership || this.member.tagNumber),
    '{3}': invoice,
    '{4}': pay.toString(),
    '{5}': trainerName,
    '{6}': dueDate,
    '{7}': this.branchName || ''
};

                Object.keys(values).forEach(key => {
                    msg = msg.split(key).join(values[key]);
                });

                const message = encodeURIComponent(msg);
                const link = document.createElement('a');
                link.href = `https://wa.me/${receiver}?text=${message}`;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.click();
            },
            (error) => {
                console.log(error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Could not load subscription invoice'
                });
            }
        );
}


    getOlderDateInLoopOfSubscriptions(previous, current) {
        let previousDateObj = new Date(previous);
        previousDateObj.setHours(0,0,0,0);
        let currentDate = new Date(current);
        currentDate.setHours(0,0,0,0);
        if(currentDate < previousDateObj) {
            return true;
        }
        return false;
    }

    getDueDateInLoopOfSubscriptions(previous, current) {
        let previousDateObj = new Date(previous);
        previousDateObj.setHours(0,0,0,0);
        let currentDate = new Date(current);
        currentDate.setHours(0,0,0,0);
        if(currentDate > previousDateObj) {
            return true;
        }
        return false;
    }

    closeAddSubscriptionDialog() {
        this.subscriptionsDetailView = false;
    }

    getSubscriptionStatus(dueDate) {
        let dueDateObj = new Date(dueDate);
        dueDateObj.setHours(0,0,0,0);
        let dateNow = new Date();
        dateNow.setHours(0,0,0,0);
        if(dueDateObj < dateNow) {
            return "Expired";
        }
        return "Active";
    }

    getSubscriptionConductedSessions(subscriptionId) {
        return 0;
    }

    getGroupedSubscriptionsByService() {
        if (!this.serviceSubscriptions || this.serviceSubscriptions.length === 0) {
            return [];
        }

        // Group subscriptions by serviceId
        const groupedMap = new Map();

        this.serviceSubscriptions.forEach(subscription => {
            const serviceId = subscription.serviceId;

            if (!groupedMap.has(serviceId)) {
                groupedMap.set(serviceId, {
                    serviceId: serviceId,
                    serviceName: subscription.name || 'N/A',
                    type: subscription.type,
                    subscriptions: [],
                    totalSessions: 0,
                    totalConductedSessions: 0,
                    totalNoShowSessions: 0,
                    remainingSessions: 0
                });
            }

            const group = groupedMap.get(serviceId);
            group.subscriptions.push(subscription);
            group.totalSessions += this.getSubscriptionDisplayedSessionCount(subscription);
        });

        return Array.from(groupedMap.values());
    }

    isMonthWiseOrSessionWise(serviceGroup: any): boolean {
        if (!serviceGroup || !serviceGroup.subscriptions) {
            return false;
        }

        // Check if subscriptions in the group are Month Wise or Session Wise
        return serviceGroup.subscriptions.some(subscription => {
            const packageType = this.getSubscriptionPackageType(subscription);
            return packageType === 'Month Wise' || packageType === 'Session Wise' || packageType === 'Hybrid';
        });
    }

    isMonthWiseSubscription(subscription: any): boolean {
        const packageType = subscription?.packageType || this.getSubscriptionPackageType(subscription);
        return packageType === 'Month Wise';
    }


    isSessionWiseSubscription(subscription: any): boolean {
        const packageType = subscription?.packageType || this.getSubscriptionPackageType(subscription);
        return packageType === 'Session Wise' || packageType === 'Hybrid';
    }

    getTrainerFeeForSubscription(subscription: any): any {
        if (!subscription || !this.Trainers) {
            return null;
        }
        const trainer = this.Trainers.find(t => t._id === subscription.trainerId);
        if (!trainer?.fees) {
            return null;
        }
        return trainer.fees.find(f => f._id === subscription.trainerPackageId)
            || trainer.fees.find(f => f._id === subscription.feeId)
            || null;
    }

    getSubscriptionDisplayedSessionCount(subscription: any): number {
        const stored = Number(subscription?.numberOfSessions);
        if (!isNaN(stored) && stored > 0) {
            return stored;
        }
        const feeSessions = Number(this.getTrainerFeeForSubscription(subscription)?.numberOfSessions);
        return !isNaN(feeSessions) && feeSessions > 0 ? feeSessions : 0;
    }

    getSubscriptionDisplayedRemainingSessions(subscription: any): number {
        if (subscription?.remainingSessions != null && subscription.remainingSessions !== '') {
            const remaining = Number(subscription.remainingSessions);
            if (!isNaN(remaining)) {
                return remaining > 0 ? remaining : 0;
            }
        }
        const total = this.getSubscriptionDisplayedSessionCount(subscription);
        const conducted = Number(subscription?.totalConductedSessions) || 0;
        const noShow = Number(subscription?.totalNoShowSessions) || 0;
        const computed = total - conducted - noShow;
        return computed > 0 ? computed : 0;
    }

    getAllServices() {
        this.SubscriptionPopupLoading = true;
      this.appServiceManager.get(`branches/${this.user.branch}/services`).subscribe(
        (res) => {
          if (res) {
            this.allSubscriptions = [];
            this.services = res.response;
            if(this.subscriptionsDetailView && this.serviceInDetailView) {
                const service: any = Array.isArray(this.serviceInDetailView) ? this.serviceInDetailView[0] : this.serviceInDetailView;
                if(service && service.type === 'selfService'){
                    this.prepareSelfServiceDetailData(service);
                }else{
                    this.prepareServiceDetailData(service);
                }
            }
            const grouped = this.subscriptions.reduce(
                (result: any, currentValue: any) => {
                    (result[currentValue['serviceId']] = result[currentValue['serviceId']] || []).push(currentValue);
                    return result;
                }, {});

            let servicesInSubscription = Object.keys(grouped);
            servicesInSubscription.forEach(servicesId => {
                let serviceObj = this.services.filter(s => s._id == servicesId)[0];
                let existingServiceObj = this.subscribedServices.filter(s => s._id == servicesId);
                if(existingServiceObj.length == 0){
                    this.subscribedServices.push(serviceObj);
                }
            });

            res.response.forEach(service => {
                let serviceObj = {
                    name: service.name,
                    id: service._id,
                    trainers: []
                };

                if(service.type === 'trainingService'){
                service.trainers.forEach(trainer => {
                    const trainerDb = this.Trainers.filter(t => t._id === trainer.userId)[0];

                    if(trainerDb === null || trainerDb === undefined) {
                        return;
                    }
                    if(trainerDb.fees === null || trainerDb.fees === undefined || trainerDb.fees.length <= 0) {
                        return;
                    }
                    let trainerObj = {
                        name : trainerDb.name,

                        fees:[]
                    }

                    trainerDb.fees.forEach(fee => {
                        if(fee === null || fee === undefined) {
                            return;
                        }
                        if(fee.services == null || fee.services == undefined || fee.services.length == 0) {
                            return;
                        }
                        let check = fee.services.filter(s => s == service._id);
                        if(check.length == 0 ) {
                            return;
                        }
                        let feeObj = {
                            feeName: fee.title,
                            feeId: fee._id,
                            trainerId: trainerDb._id,
                            serviceId: service._id
                        };
                        trainerObj.fees.push(feeObj);
                    });
                    serviceObj.trainers.push(trainerObj);
                });
             }else if(service.type === 'selfService'){
                 let EmptyObj = {
                     name: 'Package',
                     fees:[]
                 }
                serviceObj.trainers.push(EmptyObj);
                service.packages.forEach(Packages => {
                    let PackagesObj = {
                        name: Packages.name,
                        fees:[]
                    }
                        let eachPackageObj = {
                            feeName: Packages.name,
                            feeId: Packages._id,
                            serviceId: service._id
                        };
                        EmptyObj.fees.push(eachPackageObj);

                });
             }

                this.allSubscriptions.push(serviceObj);
            });


            this.SubscriptionPopupLoading = false;
          } else {
            this.SubscriptionPopupLoading = false;
          }
        },
        (error) => {
          this.SubscriptionPopupLoading = false;
          console.log(error);
        }
      );
    }

    deleteThisSubscription(subscriptionId) {
        if (!this.canDeleteSubscription()) {
            return;
        }
        this.openMemberConfirmation(
            'secondary',
            'Confirmation',
            'Are you sure you want to delete subscription? All the fees, sessions related to the subscription will be deleted.',
            'pi pi-exclamation-triangle',
            () => this.deleteSubscription(subscriptionId),
        );
    }

    deleteSubscription(subscriptionId) {
        this.appServiceManager.delete(`branches/${this.user.branch}/subscriptions/${subscriptionId}`)
            .subscribe((res) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Deleted',
                    detail: 'Subscription deleted successfully',
                });
                this.closeAddSubscriptionDialog();
                this.subscribedServices = [];
                this.getAllSubscriptions();
            },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete subscription',
                    });
                }
            );
    }

    initObjects() {
        this.member = new IMember();
        this.dbEmailIfCustomerHAve = undefined;
        this.company = new ICompany();
        this.branch = new IBranch();
        this.freezeMemberDetails = [];
        this.member.contactDetail = new IMemberContact();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.freezeDetail = new IMemberFreezeDetail();
        this.member.freezeRequest = [];
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.settings = new ISettings();
        this.member.customerstrainer = new Customerstrainer();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.member.customerstrainer.totalFees = "0";
        this.array = new Array("1", "2");
        this.difference = 0;
        this.fund.pay = 0;
        this.packageFee = 0;
        this.packageRegistrationFee = 0;
        this.fund.discountAmount = 0;


        this.feealreadypaid = false;
        this.feegreater = false;
        this.printAllFeeTotal = {
            totalRegistationFee: 0,
            totalDiscountFee: 0,
            totalFeeTax: 0,
            totalTrainerFee: 0,
            totalMonthlyFee: 0,
            totalFineFee: 0,
            feeGrandTotal: 0,
        }
        this.options = [
            { label: "Select Fee Type", value: null },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];
        this.fund.status = "Monthly Fee - Paid";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];
        this.referralOptions = [
            { label: "Select Referral Source", value: null },
            { label: "Social Media", value: "Social Media" },
            { label: "Corporate", value: "Corporate" },
            { label: "Walk-In", value: "Walk-In" },
            { label: "Referral", value: "Referral" },
            { label: "Other", value: "Other" }
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];
        this.trainerOptions = [{ label: "Select Trainer", value: null }];
        this.packagesDropDown = [{ label: "Select Package", value: null }];
    }
    onIdentityTypeChange() {
        if (this.selectedIdentityType == "Passport" ) {
            this.errorMessage = this.setLabel("passport8DigitsErrorLabel");

        } else {
            this.errorMessage = this.setLabel("cNIC13DigitsErrorLabel");
        }
    }
    onCNICChange(){
        this.errorMessage = "";
    }
    getBranchByID() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.member.password = this.branch.appPassword;
        }

        if(!this.branch){
            this.appServiceManager.get("branches/" + this.user.branch).subscribe(
                (res: any) => {
                    if (res) {
                        this.member.password = res.appPassword;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );

        }
    }

    getPackages() {
        this.packages = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/package-builders"
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    res= res.filter(x => !x.isDelete);
                    this.setPackages(res);
                    this.packageToShowName = res;
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    setPackages(packages) {
        this.packagesDropDown = this.buildChangePackageOptions(packages);
        this.customerPackageId = this.member.packageId;
    }

    buildChangePackageOptions(packages: any[]): any[] {
        const secondaryIds = (this.member?.secondaryPackages || []).map((p) => String(p.packageId));
        const options = [{ label: "Select Package", value: null }];
        (packages || []).forEach((data: any) => {
            if (!data || secondaryIds.indexOf(String(data._id)) !== -1) {
                return;
            }
            options.push({ label: data.packageName, value: data._id });
        });
        return options;
    }


    isInvalidPackage(): boolean {
        return (
            !this.member.packageId ||
            this.member.packageId === 'Select Package'
        );
    }

    togglePasswordType1() {
        if (this.passwordType1 === "password") {
            this.passwordType1 = "text";
        } else {
            this.passwordType1 = "password";
        }
    }

    togglePasswordType2() {
        if (this.passwordType2 === "password") {
            this.passwordType2 = "text";
        } else {
            this.passwordType2 = "password";
        }
    }
    togglePasswordType3() {
        if (this.passwordType3 === "password") {
            this.passwordType3 = "text";
        } else {
            this.passwordType3 = "password";
        }
    }
    // feeChange() {
    //     this.showTrainerFeeError = false;
    //     this.showRegistrationFeeError = false;
    //     this.showMonthlyFeeError = false;
    //     this.checkFeePaid(this.fund.month, this.fund.year);
    //     this.array[0] = this.member._id;
    //     this.array[1] = this.fund;
    //     this.member.monthFee = this.packageFee;
    //     this.trainerNotSelected = false;
    //     if (this.fund.status === "Trainer Fee - Paid") {
    //         this.appServiceManager
    //             .post("customers/specificTrainermonthFee", this.array)
    //             .subscribe(
    //                 (response) => {
    //                     this.difference =
    //                         parseInt(this.member.customerstrainer.totalFees) -
    //                         response;

    //                     if (this.member.question3 === 'YES') {
    //                         if (parseInt(this.member.customerstrainer.totalFees) != 0) {
    //                             if (this.difference <= 0) {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 let pay = parseInt(this.member.monthFee);
    //                                 let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
    //                                 let numberOfDays: any = '';
    //                                 if (pay != parseInt(this.member.monthFee)) {
    //                                     numberOfDays = (percentagePaid / 100) * 30;
    //                                 } else {
    //                                     numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
    //                                     numberOfDays = numberOfDays.daysInMonth();
    //                                     console.log("numberOfDays", numberOfDays)
    //                                 }
    //                                 numberOfDays = Math.floor(numberOfDays);

    //                                 let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //                                 this.fund.dueDate = new Date(futureDateTrainer);
    //                                 //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //                                 if (this.isFeeMessageVisible && !this.monthlyPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Trainer fee already paid.Please check monthly fee.",
    //                                     });
    //                                 }
    //                                 else if (this.monthlyPaid && this.registrationPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 }

    //                                 this.feealreadypaid = true;
    //                             } else {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 this.fundInvoice.pay = this.difference;
    //                                 let pay = parseInt(this.member.monthFee);
    //                                 let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
    //                                 let numberOfDays: any = '';
    //                                 if (pay != parseInt(this.member.monthFee)) {
    //                                     numberOfDays = (percentagePaid / 100) * 30;
    //                                 } else {
    //                                     numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
    //                                     numberOfDays = numberOfDays.daysInMonth();
    //                                     console.log("numberOfDays", numberOfDays)
    //                                 }
    //                                 numberOfDays = Math.floor(numberOfDays);

    //                                 let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //                                 this.fund.dueDate = new Date(futureDateTrainer);
    //                                 //this.fund.dueDate = this.member.customerstrainer.dueDate;
    //                                 //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //                                 this.feealreadypaid = false;
    //                             }
    //                         }

    //                     } else {
    //                         this.fund.pay = this.difference;
    //                         if (this.fund.pay < 0) {
    //                             this.fund.pay = 0;
    //                         }
    //                         this.feealreadypaid = false;
    //                         this.trainerNotSelected = true;
    //                     }
    //                 },
    //                 (error) => {
    //                     this.loading = false;
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: error,
    //                     });
    //                 }
    //             );
    //     } else if (this.fund.status === "Registration Fee - Paid") {
    //         this.appServiceManager
    //             .post("customers/specificregistrationFee", this.array)
    //             .subscribe(
    //                 (response) => {
    //                     this.member.registerationFee = this.packageRegistrationFee;
    //                     this.difference =
    //                         parseInt(this.member.registerationFee) -
    //                         response;
    //                     if (this.difference <= 0) {
    //                         this.fund.pay = this.difference;
    //                         //this.fund.dueDate = this.member.settings.dueDate;
    //                         //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                         if (this.isFeeMessageVisible && !this.monthlyPaid && !this.trainerPaid && this.member.question3 == "YES") {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration fee already paid.Please check monthly fee and trainer fee.",
    //                             });
    //                         } else if (this.monthlyPaid && this.member.question3 == "YES" && !this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration fee already paid.Please check trainer fee.",
    //                             });
    //                         } else if (!this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration Fee already paid.Please check monthly fee.",
    //                             });
    //                         } else if (this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Fee already paid.",
    //                             });
    //                         } else if (this.member.question3 == "NO" && this.monthlyPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Fee already paid.",
    //                             });
    //                         }
    //                         this.feealreadypaid = true;
    //                     } else {
    //                         this.fund.pay = this.difference;
    //                         this.fundInvoice.pay = this.difference;
    //                         //this.fund.dueDate = this.member.settings.dueDate;
    //                         //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                         this.feealreadypaid = false;
    //                     }
    //                 },
    //                 (error) => {
    //                     this.loading = false;
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: error,
    //                     });
    //                 }
    //             );
    //     } else if (this.fund.status === "Monthly Fee - Paid") {
    //         if (parseInt(this.member.monthFee) >= 0) {
    //             this.appServiceManager
    //                 .post("customers/specificmonthFee", this.array)
    //                 .subscribe(
    //                     (response) => {
    //                         if (this.packageFee == "0") {
    //                             this.member.monthFee = this.packageFee;
    //                             this.difference =
    //                                 parseInt(this.member.monthFee) - response;

    //                             this.fund.pay = this.difference;
    //                             if (this.fund.pay < 0) {
    //                                 this.fund.pay = 0;
    //                             }
    //                             //this.fund.dueDate = this.member.settings.dueDate;
    //                             //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                             if (this.isFeeMessageVisible) {
    //                                 if (this.member.question3 == "YES" && !this.trainerPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Please check trainer fee.",
    //                                     });
    //                                 } else if (this.member.question3 == "YES" && this.trainerPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 } else if (this.member.question3 == "NO") {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 }
    //                             }
    //                             this.fund.pay = this.difference;
    //                             this.fund.pay *= this.numOfMonths;
    //                             if (this.fund.pay < 0) {
    //                                 this.fund.pay = 0;
    //                             }
    //                             this.fundInvoice.pay = this.difference;
    //                             //this.fund.dueDate = this.member.settings.dueDate;
    //                             //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                             this.feealreadypaid = false;

    //                         }
    //                         else {
    //                             this.member.monthFee = this.packageFee;
    //                             this.difference =
    //                                 parseInt(this.member.monthFee) - response;
    //                             if (this.difference <= 0) {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 //this.fund.dueDate = this.member.settings.dueDate;
    //                                 //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                                 if (this.isFeeMessageVisible) {
    //                                     if (!this.registrationPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check registration fee.",
    //                                         });
    //                                     }
    //                                     else if (this.member.question3 == "YES" && !this.registrationPaid && !this.trainerPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check registration fee and trainer fee.",
    //                                         });
    //                                     } else if (!this.trainerPaid && this.member.question3 == "YES") {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check trainer fee.",
    //                                         });
    //                                     } else if (this.registrationPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Fee already paid.",
    //                                         });
    //                                     } else if (this.member.question3 == "NO") {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Fee already paid.",
    //                                         });
    //                                     }
    //                                 }
    //                                 this.feealreadypaid = true;
    //                             } else {
    //                                 this.fund.pay = this.difference;
    //                                 this.fund.pay *= this.numOfMonths;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 this.fundInvoice.pay = this.difference;
    //                                 //this.fund.dueDate = this.member.settings.dueDate;
    //                                 //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                                 this.feealreadypaid = false;
    //                             }
    //                         }
    //                     },
    //                     (error) => {
    //                         this.loading = false;
    //                         this.messageService.clear();
    //                         this.messageService.add({
    //                             severity: "error",
    //                             summary: "Error Message",
    //                             detail: error,
    //                         });
    //                     }
    //                 );
    //         } else {
    //             this.messageService.clear();
    //             this.messageService.add({
    //                 severity: "error",
    //                 summary: "Error Message",
    //                 detail: "Month Fee should be a positive value",
    //             });
    //         }

    //     } else if (this.fund.status === "Fine Fee - Paid") {
    //         this.fund.pay = 0;
    //         this.feealreadypaid = false;
    //         this.fund.dueDate = new Date();
    //         this.fund.day = new Date().getDate().toString();
    //     } else {
    //         this.fund.pay = 0;
    //     }
    // }

    calculateTotalForSinglePrint(fee, tax, discount,taxType) {
        if(tax === undefined || tax === null) {
            tax = 0;
        }
        if(discount === undefined || discount === null) {
            discount = 0;
        }
        if(taxType === 'WITH_TAX') {
            let total= (parseFloat(fee) + parseFloat(tax)) - parseFloat(discount);
            return total.toLocaleString('en-US' ,{minimumFractionDigits:0});
        }
        else {
            let total= parseFloat(fee) - parseFloat(discount);
            return total.toLocaleString('en-US' ,{minimumFractionDigits:0});

        }
    }

    getFeeTaxType(fee: any): string {
        return fee?.taxCalculationType || fee?.taxType || this.taxType || '';
    }

    hasPrintDiscount(discount: number): boolean {
        return +(discount || 0) > 0;
    }

    hasFeeTax(fee: any): boolean {
        return this.getFeeTaxType(fee) !== 'NO_TAX';
    }

    getPrintSubtotalLabelColspan(discount: number, fee?: any): number {
        return this.hasPrintDiscount(discount) || this.hasFeeTax(fee) ? 4 : 3;
    }

    getSplitPaymentModeLines(paymentMode?: string): SplitPaymentModeLine[] {
        return parseSplitPaymentModeLines(
            paymentMode ?? this.fundInvoice?.paymentMode,
        );
    }

    isMultiPaymentModeOnInvoice(paymentMode?: string): boolean {
        return isMultiPaymentModeReceipt(
            paymentMode ?? this.fundInvoice?.paymentMode,
        );
    }

    getInvoicePaymentModeHeader(paymentMode?: string): string {
        return getReceiptPaymentModeHeader(
            paymentMode ?? this.fundInvoice?.paymentMode,
            this.setLabel('multiplePaymentModesLabel'),
        );
    }

    /** Fee Details: "Split 1/2" chip when fee is part of a multi-mode payment. */
    getFeeSplitPartLabel(fee: any): string | null {
        return getSplitPartLabel(
            fee,
            this.customerFees,
            this.setLabel('splitPartLabel'),
        );
    }

    /** Fee Details: "Partial" chip on each fee whose own balance is still open. */
    isPartialFee(fee: any): boolean {
        const balance = Number(fee?.balance);
        return Number.isFinite(balance) && balance > 0;
    }

    getPartialFeeTooltip(fee: any): string {
        const balance = Math.round(Number(fee?.balance) || 0);
        const amount = balance.toLocaleString('en-US', {
            maximumFractionDigits: 0,
        });
        return String(this.setLabel('partialFeeTooltipLabel') || '').replace(
            '{balance}',
            amount,
        );
    }

    getPrintSubtotalValueColspan(discount: number, fee?: any): number {
        const extra = (this.hasPrintDiscount(discount) ? 1 : 0) + (this.hasFeeTax(fee) ? 1 : 0);
        return extra || 1;
    }

    getPrintMonthlySubtotalLabelColspan(discount: number, fee?: any): number {
        const totalCols = 4
            + (this.hasPrintDiscount(discount) ? 1 : 0)
            + (this.hasFeeTax(fee) ? 1 : 0);
        return totalCols - this.getPrintSubtotalValueColspan(discount, fee) - 1;
    }

    dropdownChange() {
        var data = this.Trainers.filter(
            (x) => x._id === this.member.customerstrainer.trainerId
        );
        if (data.length > 0) {
            this.member.customerstrainer.trainerId = data[0]._id;
            this.member.customerstrainer.name = data[0].name;
            this.member.customerstrainer.totalFees = data[0].totalFees
                ? data[0].totalFees
                : 0;
            this.member.customerstrainer.trainerShare = data[0].trainerShare
                ? data[0].trainerShare
                : 0;
            this.member.customerstrainer.gymShare = data[0].gymShare
                ? data[0].gymShare
                : 0;
            // Set trainer due date to today's date when trainer is selected
            this.member.customerstrainer.dueDate = new Date();
        }
    }
    // checkfeegreater() {
    //     //this.previousDueDate=this.member.settings.dueDate
    //     // let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
    //     // let numberOfDays :any = '';
    //     // if (this.fund.pay != parseInt(this.member.monthFee)) {
    //     //      numberOfDays = (percentagePaid / 100) * 30;
    //     // } else {
    //     //     numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
    //     //     numberOfDays = numberOfDays.daysInMonth();
    //     //     console.log("numberOfDays",numberOfDays)
    //     // }
    //     // numberOfDays = Math.floor(numberOfDays);
    //     // let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
    //     // this.fund.dueDate = new Date(futureDate);
    //     // if (this.fund.status === 'Fine Fee - Paid') {
    //     //     this.feegreater = false;
    //     // }
    //     // } else if (this.fund.pay > this.difference) {
    //     //     this.messageService.clear();
    //     //     this.messageService.add({
    //     //         severity: "error",
    //     //         summary: "You cannot pay more than actual fees",
    //     //     });
    //     //     this.feegreater = true;
    //     // } else {
    //     //     this.feegreater = false;
    //     // }
    // }
    getTrainers() {
        this.Trainers = [];
        this.loading = true;
        this.appServiceManager.get('branches/' + this.user.branch + '/users/actions/trainers').subscribe(
            (res) => {
                if (res.length > 0) {
                    this.setTrainerData(res);
                } else {
                    this.Trainers = [];
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    clearPasswordFeilds() {
        this.newPassword = null;
        this.newConfirmPassword = null;
        this.passwordType1 = "password";
    }
    setTrainerData(Trainers) {
        var sortedTrainers = [];
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == false) {
                sortedTrainers.push(Trainers[i]);
            }
        }
        sortedTrainers.sort(function (a, b) {
            if (
                a.name.substring(0, 1).toLowerCase() <
                b.name.substring(0, 1).toLowerCase()
            ) {
                return -1;
            } else if (
                a.name.substring(0, 1).toLowerCase() >
                b.name.substring(0, 1).toLowerCase()
            ) {
                return 1;
            }
            return 0;
        });
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == true) {
                sortedTrainers.push(Trainers[i]);
            }
        }
        this.Trainers = sortedTrainers;
        this.Trainers = [...this.Trainers];
        this.Trainers.forEach((trainer) => {
            this.trainerOptions.push({
                label: trainer.name,
                value: trainer._id,
            });
        });
    }
    getCompany() {
        this.company = AuthService.getLoggedInCompanyBranch();
        if(!this.company){
        this.appServiceManager.get("companies/current").subscribe(
            (res) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
     }
    }
    // Custom comparison function based on day, month, and year
    compareByDate(a, b) {
        const dateA: any = new Date(`${a.year}-${a.month}-${a.day}`);
        const dateB: any = new Date(`${b.year}-${b.month}-${b.day}`);
        return dateB - dateA;
    }
    getPackagesByID() {
        this.loading = true;
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/package-builders/" +
                this.member.packageId
            )
            .subscribe(
                (res) => {
                    this.packageName = res.packageName;
                    this.numOfMonths = res.noOfMonths;
                    this.packageFee = res.packageFee;
                    this.member.monthFee = this.packageFee;
                    this.numberOfMembers = res.noOfMembers;
                    this.packageRegistrationFee = res.registerationFee;
                    this.selectedMemberPackage = res;
                    this.checkMemberAgeAgainstPackage(res);
                    if (this.allowDialog) {
                        // this.showDialog();
                        this.allowDialog = false;
                        this.isDialogVisible = true;
                    }
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );

    }

    checkMemberAgeAgainstPackage(packageData: IPackageBuider) {
        const validation = AppUtils.validateMemberAgeAgainstPackage(this.member, packageData);
        if (validation.isValid) {
            return;
        }

        const detail = validation.isTooYoung
            ? "Member is below the allowed age limit for this package."
            : "Member exceeds the allowed age limit for this package.";

        this.messageService.add({
            severity: "error",
            summary: "Age Validation",
            detail: detail,
        });
    }
    getCustomerByID() {
        this.appServiceManager.get("branches/" + this.user.branch + "/customers/" + this.memberID).subscribe(
            (res: any) => {
                if (res) {
                    this.member = res;
                    this.originalMemberSnapshot = JSON.parse(JSON.stringify(res));
                    this.selectedIdentityType = 'CNIC';
                    this.refreshMemberPortalInviteSendCount();

                    if (this.member.bloodGroup) {
                        this.member.bloodGroup = this.member.bloodGroup.toUpperCase();
                    }
                    if(this.member.CNIC){
                        if(this.member.CNIC.length !== 13){
                            this.selectedIdentityType = 'Passport';
                        }else{
                            this.selectedIdentityType = 'CNIC';
                        }
                    }
                     // Check the CNIC value
                     if (/^\d{13}$/.test(this.member.CNIC)) {
                        this.selectedIdentityType = 'CNIC'; // Exactly 13 digits
                    // } else if (/^[A-Za-z0-9]{1,9}$/.test(this.member.CNIC)) {
                    } else if (/^[A-Za-z0-9]$/.test(this.member.CNIC)) {
                        this.selectedIdentityType = 'Passport'; // 9 or fewer alphanumeric characters
                    }
                    this.member.oldDate = this.member.settings.dueDate;
                    this.member.oldValue = this.member.packageName;
                    this.member.currentUserData = this.currentUserData;
                    let currentDate=new Date();
                    let joinDate=new Date(this.member.joiningDate);
                    if (joinDate.getMonth() === currentDate.getMonth() && joinDate.getFullYear() === currentDate.getFullYear()) {
                        this.welcomeMsg = true;
                      } else {
                        this.welcomeMsg = false;
                      }
                    this.dbEmailIfCustomerHAve = this.member.email && this.member.email.length > 0 ? this.member.email : undefined;
                    this.getCustomerFees();
                    this.getPackagesByID();
                    this.validateMember(res);
                    this.setDate(res);
                    this.getFreezeReport();
                    this.getAllSubscriptions();
                    this.breadcrumbService.setItems([
                        { label: "Member Management" },
                        { label: "All Members", routerLink: "/members" },
                        { label: this.member.name },
                    ]);
                    if (!this.member.password) {
                        this.getBranchByID();
                    }
                    //this.member.profile = this.config.Server + this.member.profile;
                    this.getCompany();
                    this.calculateTotal();
                    if (res.customerstrainer.name)
                        this.memberTrainer = res.customerstrainer.name;
                    else
                        this.memberTrainer = "Not Assigned";
                    if (this.openFeeDialog === "true") {
                        this.allowDialog = true;
                        // this.showDialog();
                    }
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    getCustomerFees() {
        this.loading = true;
        this.appServiceManager
        .get("branches/" + this.user.branch + "/customer-fees/customers/" + this.memberID).subscribe(
            (res: any) => {
              if (res && res.length > 0) {
                this.customerFees = res.reverse();
                this.feeDetailsSource = JSON.stringify(
                    this.customerFees
                  );
                this.getTotalForAllReciptPrint();

                this.calculateTotal();
                this.refreshMinManualDueDate();
              } else {
                // Last fee deleted: API returns [] — must clear the table or the
                // previous last row stays visible until a full page refresh.
                this.customerFees = [];
                this.feeDetailsSource = JSON.stringify([]);
                this.getTotalForAllReciptPrint();
                this.calculateTotal();
                this.refreshMinManualDueDate();
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Customer fee Record Found",
                });
              }
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error.error.message,
              });
            }
          );
      }
    // checkFeePaid(month: any, year: any) {
    //     this.getCustomerByID();

    //     this.registrationPaid = false;
    //     this.monthlyPaid = false;
    //     this.trainerPaid = false;

    //     // Check if there is at least one entry with 'Registration Fee - Paid'
    //     const hasRegistrationFeePaid = this.member.feeDetails.some((fee) => {
    //         return fee.status === 'Registration Fee - Paid';
    //     });

    //     if (hasRegistrationFeePaid) {
    //         this.registrationPaid = true;
    //     }

    //     for (const fee of this.member.feeDetails) {
    //         if (fee.month == month && fee.year == year) {
    //             if (fee.status == 'Monthly Fee - Paid') {
    //                 this.monthlyPaid = true;
    //             } else if (this.member.question3 == 'YES' && fee.status == 'Trainer Fee - Paid') {
    //                 this.trainerPaid = true;customerFees
    //             }
    //         }
    //     }
    // }

    printAllZeroValues() {
        this.printAllFeeTotal.totalRegistationFee = 0;
        this.printAllFeeTotal.totalDiscountFee = 0;
        this.printAllFeeTotal.totalFeeTax= 0;
        this.printAllFeeTotal.grandTotalFeeTax= 0;
        this.printAllFeeTotal.totalTrainerFee = 0;
        this.printAllFeeTotal.totalMonthlyFee = 0;
        this.printAllFeeTotal.totalFineFee = 0;
        this.printAllFeeTotal.feeGrandTotal = 0;
    }

    getTotalForAllReciptPrint() {
        let memberFeeDetails = [];
        this.printAllZeroValues();
        memberFeeDetails = JSON.parse(this.feeDetailsSource);
        memberFeeDetails.map(memberFee => {
            if (memberFee.status === "Registration Fee - Paid") {
                this.printAllFeeTotal.totalRegistationFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Trainer Fee - Paid") {
                this.printAllFeeTotal.totalTrainerFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Monthly Fee - Paid") {
                this.printAllFeeTotal.totalMonthlyFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Fine Fee - Paid") {
                this.printAllFeeTotal.totalFineFee += parseFloat(memberFee.pay);
            }
            if (memberFee.tax !== undefined && memberFee.tax !== null) {
                if (memberFee.taxCalculationType !== "INCLUDING_TAX")
                    this.printAllFeeTotal.grandTotalFeeTax += parseFloat(memberFee.tax);
                this.printAllFeeTotal.totalFeeTax += parseFloat(memberFee.tax);
            }
            this.printAllFeeTotal.totalDiscountFee += parseFloat(memberFee.discount);
            this.printAllFeeTotal.feeGrandTotal += parseFloat(memberFee.pay);
        });

        // Round final results to integers
        this.printAllFeeTotal.totalRegistationFee = Math.round(this.printAllFeeTotal.totalRegistationFee);
        this.printAllFeeTotal.totalTrainerFee = Math.round(this.printAllFeeTotal.totalTrainerFee);
        this.printAllFeeTotal.totalMonthlyFee = Math.round(this.printAllFeeTotal.totalMonthlyFee);
        this.printAllFeeTotal.totalFineFee = Math.round(this.printAllFeeTotal.totalFineFee);
        this.printAllFeeTotal.grandTotalFeeTax = Math.round(this.printAllFeeTotal.grandTotalFeeTax);
        this.printAllFeeTotal.totalFeeTax = Math.round(this.printAllFeeTotal.totalFeeTax);
        this.printAllFeeTotal.totalDiscountFee = Math.round(this.printAllFeeTotal.totalDiscountFee);
        this.printAllFeeTotal.feeGrandTotal = Math.round(this.printAllFeeTotal.feeGrandTotal);
    }

    get packageHistoryRows() {
        const rows = this.member?.packageHistory || [];
        return [...rows].sort((a, b) => {
            const aTime = a?.startDate ? new Date(a.startDate).getTime() : 0;
            const bTime = b?.startDate ? new Date(b.startDate).getTime() : 0;
            return bTime - aTime;
        });
    }

    // print report Api Get
    getFreezeReport() {
        this.freezeMemberDetails = [];
        this.appServiceManager
            .put(
                `branches/${this.user.branch}/customers/actions/freeze-details-by-id-company-branch/${this.member.tagNumber}`,
                {},
            )
            .subscribe(
                (res: any) => {
                    if (res) {
                        this.freezeMemberDetails = res;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    validateMember(res) {
        if (!this.member.freezeRequest) {
            this.member.freezeRequest = [];
        }
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            var dueDate = JSON.stringify(res.settings.dueDate);
            var DD = JSON.parse(dueDate).split("/");
            if (DD.length === 1) {
                this.member.settings.dueDate = new Date(DD);
            } else {
                var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
                if (newDDate) {
                    this.member.settings.dueDate = new Date(newDDate);
                }
            }
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
        this.resetOperatorDueDateTracking();
    }

    validateMemberTrainer() {
        if (
            this.member.question3 === "YES" &&
            parseInt(this.member.customerstrainer.totalFees) >= 0 &&
            this.member.customerstrainer.dueDate != null &&
            this.member.customerstrainer.trainerId != null
        ) {
            return true;
        } else if (this.member.question3 === "NO") {
            return true;
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Complete Fields Properly",
            });
            return false;
        }
    }

    isOperatorRole(): boolean {
        return (this.user?.role || this.role?.name || "").toLowerCase() === "operator";
    }

    /** Operators may set due date to today or any past date; future dates are limited to 2 days ahead. */
    private getOperatorDueDateFutureLimit(): Date | null {
        if (!this.isOperatorRole()) {
            return null;
        }
        return moment().add(2, "days").startOf("day").toDate();
    }

    private isMemberSettingsDueDateAllowedForOperator(date: Date): boolean {
        const futureLimit = this.getOperatorDueDateFutureLimit();
        if (!futureLimit || !date) {
            return true;
        }
        return moment(date).startOf("day").isSameOrBefore(moment(futureLimit).startOf("day"));
    }

    private isSameMemberDueDate(a: Date | null | undefined, b: Date | null | undefined): boolean {
        if (!a && !b) {
            return true;
        }
        if (!a || !b) {
            return false;
        }
        return moment(a).startOf("day").isSame(moment(b).startOf("day"));
    }

    private resetOperatorDueDateTracking(): void {
        const dueDate = this.member.settings?.dueDate;
        this.memberDueDateSnapshotAtLoad = dueDate ? new Date(dueDate) : null;
        this.operatorDueDateEdited = false;
        this.refreshMinManualDueDate();
    }

    private refreshMinManualDueDate(): void {
        this.minManualDueDate = getMinAllowedManualDueDate(
            (this.customerFees ?? []) as Array<Record<string, unknown>>,
        );
        if (!this.minManualDueDate) {
            this.dueDateBillingError = null;
        }
    }

    private getDueDateBeforePaidPeriodMessage(paidThrough: Date): string {
        const dateLabel = formatPaidThroughLabel(paidThrough);
        const template =
            this.setLabel("dueDateBeforePaidPeriodError") ||
            "Can't set this date. Member is paid until {date}. Delete the last fee (LIFO) to correct billing.";
        return template.replace("{date}", dateLabel);
    }

    private revertMemberDueDateToSnapshot(): void {
        this.member.settings.dueDate = this.memberDueDateSnapshotAtLoad
            ? new Date(this.memberDueDateSnapshotAtLoad)
            : null;
    }

    onDueDateChange(newDate: Date) {
        if (this.isOperatorRole() && newDate && !this.isMemberSettingsDueDateAllowedForOperator(newDate)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Invalid Date",
                detail: "Operators can set due date to today or a past date, but not more than 2 days in the future.",
            });
            this.revertMemberDueDateToSnapshot();
            return;
        }
        const paidPeriodCheck = isManualDueDateBeforePaidPeriod(
            newDate,
            (this.customerFees ?? []) as Array<Record<string, unknown>>,
        );
        if (newDate && paidPeriodCheck.blocked && paidPeriodCheck.paidThrough) {
            const detail = this.getDueDateBeforePaidPeriodMessage(
                paidPeriodCheck.paidThrough,
            );
            this.dueDateBillingError = detail;
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary:
                    this.setLabel("dueDateBeforePaidPeriodSummary") ||
                    "Invalid due date",
                detail,
            });
            this.revertMemberDueDateToSnapshot();
            return;
        }
        this.dueDateBillingError = null;
        if (!this.isSameMemberDueDate(newDate, this.memberDueDateSnapshotAtLoad)) {
            this.operatorDueDateEdited = true;
            this.updateMemberSettingFlag = true;
        }
    }
    openUpdateBodySpecDialog(bodySpec: any) {
        this.showBodySpecPopup=true
  this.bodySpec = { ...bodySpec }; // clone to avoid direct mutation
  this.updateBodySpecDialogVisible = true;
}
    getBodySpecification() {
        if (!this.memberID) {
            this.getBodySpecs = [];
            return;
        }
        this.appServiceManager.get('branches/' + this.user.branch + '/customers/vitals/' + this.memberID).subscribe(
            (res) => {
                if (res && res.data) {
                    this.getBodySpecs = res.data;
                } else {
                    this.getBodySpecs = [];
                }
            },
            (error) => {
                if (error?.status === 404) {
                    this.getBodySpecs = [];
                    return;
                }
                this.getBodySpecs = [];
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Failed to fetch Body Specification."
                });
            }
        );
    }
    openUpdateBodySpecPopup(entry: any) {
        this.showBodySpecPopup = true
        this.bodySpec = {
            totalBodyWater: entry.totalBodyWater ?? null,
            protein: entry.protein ?? null,
            mineral: entry.mineral ?? null,
            bodyFatMass: entry.bodyFatMass ?? null,
            weight: entry.weight ?? null,
            sMM: entry.sMM ?? null,
            bMI: entry.bMI ?? null,
            pBF: entry.pBF ?? null,
            waistHipRatio: entry.waistHipRatio ?? null,
            visceralFatLevel: entry.visceralFatLevel ?? null,
            height: entry.height ?? null,
            _id: entry._id ?? null,
        };
    }

    updateBodySpec(bodySpec: any) {
        const updatedData = buildUpdateCustomerVitalsPayload(
            this.bodySpec as Record<string, unknown>,
            this.memberID,
        );
        this.appServiceManager.put(
            'branches/' + this.user.branch + '/customers/vitals',
            updatedData
        ).subscribe(
            (res) => {
                if (res?.status !== false) {
                    this.updateBodySpecDialogVisible = false;
                    this.showBodySpecPopup = false;
                    this.getBodySpecification();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Body Specification updated successfully."
                    });
                    // Optionally reset the form
                    this.bodySpec = {
                        totalBodyWater: 0,
                        protein: 0,
                        mineral: 0,
                        bodyFatMass: 0,
                        weight: 0,
                        sMM: 0,
                        bMI: 0,
                        pBF: 0,
                        waistHipRatio: 0,
                        visceralFatLevel: 0,
                        height: 0,
                        _id: 0,
                    };
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Failed to update Body Specification."
                });
            }
        );
    }
    onBloodGroupChange($event) {
        this.member.bloodGroup = $event.value;
    }
    getUpdatedTrainerValues(){
            var data = this.Trainers.filter(
            (x) => x._id === this.member.customerstrainer.trainerId
        );
         if (data.length > 0) {
            this.member.customerstrainer.gymSharePercentage = data[0].gymSharePercentage ?? 0;
            this.member.customerstrainer.trainerSharePercentage = data[0].trainerSharePercentage ?? 0;

         }
    }
    
private getChangedMemberFields(): string[] {
  if (!this.originalMemberSnapshot || !this.member) {
    return ['unknown'];
  }

  const original = this.originalMemberSnapshot;
  const current = this.member;

  const ignoredFields = new Set([
    'oldDate',
    'oldValue',
    'currentUserData',
    'memberSettingFlag'
  ]);

  const normalize = (value: any): any => {
    if (value instanceof Date) {
      return value.toISOString();
    }
    return value;
  };

  const changes: string[] = [];

  const compare = (before: any, after: any, path: string) => {
    if (ignoredFields.has(path)) return;

    if (path === 'settings.dueDate') {
      const oldDate = before ? new Date(before).toISOString().slice(0, 10) : '';
      const newDate = after ? new Date(after).toISOString().slice(0, 10) : '';
      if (oldDate !== newDate) changes.push(path);
      return;
    }

    if (before && after && typeof before === 'object' &&
        typeof after === 'object' &&
        !(before instanceof Date) && !(after instanceof Date)) {
      const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
      keys.forEach(key => compare(before[key], after[key], path ? `${path}.${key}` : key));
      return;
    }

    if (JSON.stringify(normalize(before)) !== JSON.stringify(normalize(after))) {
      changes.push(path);
    }
  };

  compare(original, current, '');
  return changes;
}

    update(form: any) {
        if (this.member.question3 === 'YES' && (!this.member.customerstrainer.trainerId || this.member.customerstrainer.trainerId === '')) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a trainer.",
            });
            return;
        }
        if (this.member.question3 === 'YES' && this.member.customerstrainer?.trainerId) {
            const selectedTrainerFee = parseFloat(this.member.customerstrainer.totalFees);
            if (isNaN(selectedTrainerFee) || selectedTrainerFee <= 0) {
                this.trainerFeeErrorDialogMessage = "The Trainer Fee Is Not Correct.";
                this.trainerFeeErrorDialogVisible = true;
                return;
            }
        }
        if (form.valid) {
            if (
                this.isOperatorRole() &&
                this.operatorDueDateEdited &&
                this.member.settings?.dueDate &&
                !this.isMemberSettingsDueDateAllowedForOperator(this.member.settings.dueDate)
            ) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Invalid Date",
                    detail: "Operators can set due date to today or a past date, but not more than 2 days in the future.",
                });
                return;
            }
            // var check1 = this.checkUserPass();
            // var check2 = this.checkPassLength();
            // if (check1) {
            const dueDateChanging = this.isMemberDueDateChanging();
            const sameHistoryDueDateMessage =
                dueDateChanging && this.getSameHistoryGroupConfirmMessage('dueDate');
            this.openMemberConfirmation(
                'secondary',
                'Update member?',
                sameHistoryDueDateMessage || 'Are you sure you want to update member ?',
                'pi pi-save',
                async () => {
                    this.member.company = this.user.company;
                    this.member.branch = this.user.branch;
                    if(this.isPackageUpdated){
                        this.member.type = '';
                        const selectedPackagename = this.packagesDropDown.find(package1 => package1.value === this.member.packageId);
                        this.member.scope = 'Member';
                        this.member.initiatedFrom = 'Add Member';
                        this.member.packageName = selectedPackagename.label;
                        this.updateMemberSettingFlag = true;
                        this.isPackageUpdated = false;

                    }else{
                    this.member.type = '';
                    this.member.scope = 'Member';
                    this.member.initiatedFrom = 'Add Member';
                    this.updateMemberSettingFlag = true;
                    }

                    // Legacy behavior: when question3 === 'NO', clear trainer info
                    if (this.member.question3 === 'NO' && this.member.customerstrainer) {
                        this.member.customerstrainer.name = '';
                        this.member.customerstrainer.sessionCount = '0';
                        this.member.customerstrainer.remainingSessionCount = 0;
                        this.member.customerstrainer.trainerId = '';
                        this.member.customerstrainer.totalFees = '0';
                    }

                    if (this.sessionCountChanged) {
                        this.member.customerstrainer.remainingSessionCount = parseInt(this.member.customerstrainer.sessionCount);
                    }
                    this.member.memberSettingFlag = this.updateMemberSettingFlag;
                    if (this.member.customerstrainer.name) {
                        this.memberTrainer = this.member.customerstrainer.name;
                    }
                    else
                        this.memberTrainer = "Not Assigned";
                    this.getUpdatedTrainerValues();
                    const updatePayload = buildMemberUpdatePayload(this.member, {
                        modifiedBy: this.currentUserData?.name,
                        includeCustomerTrainer: this.member.question3 === 'YES',
                    });
                    const shouldIncludeDueDate = this.isOperatorRole()
                        ? this.operatorDueDateEdited
                        : this.updateMemberSettingFlag;
                    if (shouldIncludeDueDate) {
                        const dueDate = asDateString(this.member.settings?.dueDate);
                        if (dueDate) {
                            updatePayload.settings = { dueDate };
                        }
                    }
                    if (this.member.question3 === 'YES') {
                        const trainerPayload =
                            buildCustomerTrainerPayload(this.member.customerstrainer) ?? {};
                        const trainerDueDate = asDateString(
                            this.member.customerstrainer?.dueDate,
                        );
                        if (trainerDueDate) {
                            trainerPayload.dueDate = trainerDueDate;
                        }
                        if (Object.keys(trainerPayload).length > 0) {
                            updatePayload.customerstrainer = trainerPayload;
                            updatePayload.question3 = this.member.question3;
                        }
                    }
                    this.appServiceManager
                        .put(customerUpdateUrl(this.user.branch, this.member._id), updatePayload)
                        .subscribe(
                            (res: any) => {
                                if (res) {
                                    if (this.sessionCountChanged) {
                                        const url = `trainingAttendance/updateSessionCount/${this.member._id}`;
                                        const body = { sessionCount: this.member.customerstrainer.sessionCount, flag: false };
                                        this.appServiceManager.put(url, body).subscribe((res: any) => {
                                            this.sessionCountChanged = false;
                                        },
                                            (error) => {
                                                // Handle the error
                                                console.error('Update failed', error);
                                            }
                                        );
                                    }

                                    if (this.uploadProfile && this.member.profile) {
                                        const file = AppUtils.base64ToFile(this.uploadProfile, `${this.member.name}.png` + ":" + this.companySessionStorage + ":" + this.branchSessionStorage);
                                        this.uploadCustomerImage(file, this.member._id, true);
                                    }
                                    else if (this.oldMemberImage && !this.member.profile) {
                                        this.appServiceManager.delete(`customers/profileimages/${this.member._id}`).subscribe((res: any) => {
                                            if (res.message == "Profile image deleted successfully") {
                                                this.messageService.clear();
                                                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Profile Image Deleted Please Reload' });
                                            }
                                        });
                                    }
                                    //this.member = res.customer;
                                    this.feeDetailsSource = JSON.stringify(
                                        this.customerFees
                                    );
                                    this.validateMember(res.customer);
                                    const cacheUpdated = this.memberListCache.updateMember(
  String(this.user.branch),
  String(this.member._id),
  res.customer
);

if (!cacheUpdated) {
  this.memberListCache.clear();
}
                                    this.fund.pay = parseInt(
                                        this.member.monthFee
                                    );
                                    this.setDate(res.customer);
                                    this.member.oldDate = this.member.settings?.dueDate;
                                    this.dueDateBillingError = null;
                                    this.getCompany();
                                    this.calculateTotal();

                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "success",
                                        summary: "Success Message",
                                        detail: "Member Successfully Updated",
                                    });
                                    this.clearPasswordFeilds();
                                } else {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "info",
                                        summary: "Info Message",
                                        detail: "Something Went Wrong",
                                    });
                                }
                            },
                            (error) => {
                                this.messageService.clear();
                                const detail =
                                    error?.error?.message ??
                                    error?.message ??
                                    'Something went wrong while updating the member.';
                                if (
                                    !this.isSameMemberDueDate(
                                        this.member.settings?.dueDate,
                                        this.memberDueDateSnapshotAtLoad,
                                    )
                                ) {
                                    this.revertMemberDueDateToSnapshot();
                                }
                                if (
                                    typeof detail === 'string' &&
                                    /paid period end/i.test(detail)
                                ) {
                                    this.dueDateBillingError = detail;
                                }
                                this.operatorDueDateEdited = false;
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail,
                                });
                            },
                            this.updateMemberSettingFlag = false
                        );

                }
            );
        }
        else {
            //  // Form validation error handling
            Object.keys(form.controls).forEach(controlName => {
                const control = form.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please fill the member details.",
            });
        }
        // }
    }

    checkDateOfBirth(){
        const currentDate = new Date();
        if(this.member.dateOfBirth && new Date(this.member.dateOfBirth) > currentDate){
            this.dateOfBirthError = true;
        }else{
            this.dateOfBirthError = false;
        }
    }

    checkUserPass() {
        if (this.newPassword !== "") {
            if (
                this.newPassword === this.newConfirmPassword &&
                this.newPassword.length >= 4
            ) {
                this.member.password = this.newPassword;
                return true;
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "User New Password and Confirm Password doesn't match",
                });
                return false;
            }
        }
        return true;
    }
    checkPassLength() {
        if (this.newPassword !== "") {
            if (this.newPassword.length >= 4) {
                return true;
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Password is less than 4 characters",
                });
                return false;
            }
        }
        return true;
    }
    // checkUserPass() {
    //     if (this.oldPassword !== "" && this.oldPassword !== undefined) {
    //         if (this.oldPassword === this.member.password) {
    //             if (this.newPassword !== "") {
    //                 if (this.newPassword === this.newConfirmPassword) {
    //                     this.member.password = this.newPassword;
    //                     return true;
    //                 } else {
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: "User New Password and Confirm Password doesn't match",
    //                     });
    //                     return false;
    //                 }
    //             } else {
    //                 this.messageService.clear();
    //                 this.messageService.add({
    //                     severity: "error",
    //                     summary: "Error Message",
    //                     detail: "Please Enter New Password",
    //                 });
    //                 return false;
    //             }
    //         } else {
    //             this.messageService.clear();
    //             this.messageService.add({
    //                 severity: "error",
    //                 summary: "Error Message",
    //                 detail: "User password and Old password doesn't match",
    //             });
    //             return false;
    //         }
    //     }
    //     return true;
    // }
    isExcludedActivityType(activityType: string): boolean {
        // Define a regular expression pattern to match excluded property paths
        const excludedPatterns = [
          /^packageId$/,
          /^customerstrainer\.dueDate$/,
          /^oldDate$/,
          /^oldValue$/,
          /^currentUserData$/,
          /^type$/,
          /^scope$/,
          /^initiatedFrom$/,
          /^memberSettingFlag$/,
          /^modifiedBy$/,
          /^activityBy$/,
          /^attendance(\..*)?$/
      ];
        // Check if the activity type matches any of the excluded patterns
        return excludedPatterns.some(pattern => pattern.test(activityType));
    }

    formatOldValues(requestor) {
        let formattedOldValues = '';
        let counter = 1;
        requestor.updatedValues.forEach((updatedValue) => {
          if (!this.isExcludedActivityType(updatedValue.subjectType)) {
            if (formattedOldValues !== '') {
              formattedOldValues += '; ';
            }
            formattedOldValues += `${counter}. ${this.formatValue(updatedValue.oldValue)}`;
            counter++;
          }
        });
        return formattedOldValues;
      }


      formatNewValues(requestor) {
        let formattedNewValues = '';
        let counter = 1;

        requestor.updatedValues.forEach((updatedValue) => {
          // Check if the subjectType is 'profile'
          if (updatedValue.subjectType === 'profile') {
            updatedValue.newValue = 'profile changed';
            updatedValue.oldValue = 'profile changed';
          }

          // Exclude activity types as per existing logic
          if (!this.isExcludedActivityType(updatedValue.subjectType)) {
            if (formattedNewValues !== '') {
              formattedNewValues += '; ';
            }
            // Format and add the updated value
            formattedNewValues += `${counter}. ${this.formatValue(updatedValue.newValue)}`;
            counter++;
          }
        });

        return formattedNewValues;
            }

        formatValue(value) {
            if (this.isDate(value)) {
                return new Date(value).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
            }
            return value;
        }

        isDate(value) {
            return !isNaN(Date.parse(value));
        }

        getCollectFeeDueDate(requestor: any): Date | null {
            if (!requestor?.newValue) {
                return null;
            }

            const datePortion = requestor.newValue.split(' (Final Amount:')[0]?.trim();
            if (datePortion && this.isDate(datePortion)) {
                return new Date(datePortion);
            }
            return null;
        }

        getCollectFeeFinalAmount(requestor: any): string {
            if (!requestor?.newValue) {
                return '';
            }
            const match = requestor.newValue.match(/Final Amount:\s*([^)]+)/i);
            return match ? match[1].trim() : '';
        }

    getFeeTypeDisplay(status?: string): string {
        return getFeeTypeDisplayLabel(status);
    }

    formatFeeBillingPeriod(fee: IMemberFeeDetails): string {
        return formatFeeBillingPeriodLabel(fee);
    }

    formatFeeInvoicePeriodStart(fee: IMemberFeeDetails = this.fundInvoice): string {
        return formatFeeInvoicePeriodStart(fee);
    }

    formatFeeInvoicePeriodEnd(fee: IMemberFeeDetails = this.fundInvoice): string {
        return formatFeeInvoicePeriodEnd(fee);
    }

    canDeleteMemberFee(fee: IMemberFeeDetails): boolean {
        return canDeleteFeeLifo(
            this.customerFees as unknown as Record<string, unknown>[],
            String(fee._id),
        );
    }

    deletememberFees(fee: IMemberFeeDetails) {
        if (!this.canDeleteMemberFee(fee)) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail:
                    fee.status === 'Trainer Fee - Paid'
                        ? this.setLabel('deleteTrainerFeeLifoErrorLabel') ||
                          'Only the most recent trainer fee payment can be deleted'
                        : this.setLabel('deleteFeeLifoErrorLabel') ||
                          'Only the most recent monthly fee payment can be deleted',
            });
            return;
        }

        const openDeleteConfirm = () => {
            const memberCount =
                this.relatedMembersGroup?.members?.length ??
                (this.member?.relatedMembersId ? 2 : 0);
            const useSameHistory =
                this.isSameHistoryActive() &&
                !!this.member?.relatedMembersId &&
                fee.status === 'Monthly Fee - Paid';

            this.openMemberConfirmation(
                'secondary',
                'Confirmation',
                getFeeDeleteConfirmationMessage(
                    fee as unknown as Record<string, unknown>,
                    this.customerFees as unknown as Record<string, unknown>[],
                    {
                        single: this.setLabel('deleteFeeConfirmLabel'),
                        split: this.setLabel('splitFeeDeleteConfirmLabel'),
                        sameHistory: this.setLabel(
                            'sameHistoryFeeDeleteConfirmLabel',
                        ),
                        sameHistoryMemberCount: memberCount,
                        useSameHistory,
                    },
                ),
                'pi pi-exclamation-triangle',
                () => {
                this.loading = true;
                fee.currentUserData = this.currentUserData;
                fee.type = 'Delete Fee';
                fee.scope = 'Member';
                fee.initiatedFrom = 'Add Member';
                fee.name = this.member.name;
                fee.tagNumber = this.member.tagNumber;
                const branchId = AuthService.getLoggedInBranch() || this.user.branch;
                this.appServiceManager
                    .post(deleteFeeUrl(branchId), buildDeleteFeePayload(fee as unknown as Record<string, unknown>))
                    .subscribe(
                        (response: any) => {
                            this.loading = false;
                            this.getCustomerByID();
                            this.getCustomerFees();

                            const deletedCount = Number(response?.deletedCount) || 1;
                            const sameHistoryGroupDelete =
                                useSameHistory && deletedCount > 1;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: sameHistoryGroupDelete
                                    ? this.setLabel(
                                          'sameHistoryFeeDeletedSuccessLabel',
                                      ).replace(/\{count\}/g, String(deletedCount))
                                    : deletedCount > 1
                                      ? this.setLabel('splitFeeDeletedSuccessLabel').replace(
                                            /\{count\}/g,
                                            String(deletedCount),
                                        )
                                      : this.setLabel('feeDeletedSuccessLabel'),
                            });
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error Message',
                                detail:
                                    error?.error?.message ??
                                    'Failed to delete fee',
                            });
                        }
                    );
                },
            );
        };

        if (
            this.isSameHistoryActive() &&
            this.member?.relatedMembersId &&
            fee.status === 'Monthly Fee - Paid' &&
            !this.relatedMembersGroup
        ) {
            this.fetchRelatedMembersGroup()
                .then(() => openDeleteConfirm())
                .catch(() => openDeleteConfirm());
            return;
        }

        openDeleteConfirm();
    }

    getFormattedDueDate(dueDate: any): string {
        if (!dueDate) return 'N/A';

        const date = new Date(dueDate);
        if (isNaN(date.getTime())) return 'N/A';

        return this.getPackageValidityData(date.toISOString());
    }

    getPackageValidityData(dueDate: string): string {
        const dueDateMoment = moment(dueDate).startOf('day');
        const todayMoment = moment().startOf('day');

        if (dueDateMoment.isBefore(todayMoment)) {
            const text = dueDateMoment.fromNow();
            return `Package expired ${text}.`;
        } else if (dueDateMoment.isAfter(todayMoment)) {
            const daysLeft = dueDateMoment.diff(todayMoment, 'days');
            return `Package will expire in ${daysLeft} days.`;
        } else if (this.branch?.permissions?.expireMemberPriorOneDay) {
            return `Package has expired today.`;
        } else {
            return `Package will expire today.`;
        }
    }

    getPackgeDays(dueDate: Date): number {
        const dueDateMoment = moment(dueDate).startOf('day');;
        const todayMoment = moment().startOf('day');
        const daysLeft = dueDateMoment.diff(todayMoment, 'days');
        return daysLeft;

    }


    setDate(res) {
        if (
            res.dateOfBirth === "null" ||
            res.dateOfBirth === null ||
            res.dateOfBirth === undefined
        ) {
            this.member.dateOfBirth = null;
        } else {
            var dateOfBirth = JSON.stringify(res.dateOfBirth);
            var DOB = JSON.parse(dateOfBirth).split("/");
            if (DOB.length === 1) {
                this.member.dateOfBirth = new Date(DOB);
            } else {
                var newDOBDate = DOB[1] + "/" + DOB[0] + "/" + DOB[2];
                if (newDOBDate) {
                    this.member.dateOfBirth = new Date(newDOBDate);
                }
            }
        }
        if (
            res.joiningDate === "null" ||
            res.joiningDate === null ||
            res.joiningDate === undefined
        ) {
            this.member.joiningDate = null;
        } else {
            var joiningDate = JSON.stringify(res.joiningDate);
            var JD = JSON.parse(joiningDate).split("/");
            if (JD.length === 1) {
                this.member.joiningDate = new Date(JD);
            } else {
                var newJDate = JD[1] + "/" + JD[0] + "/" + JD[2];
                if (newJDate) {
                    this.member.joiningDate = new Date(newJDate);
                }
            }
        }
        if (
            res.customerstrainer.dueDate === "" ||
            res.customerstrainer.dueDate === "null" ||
            res.customerstrainer.dueDate === null ||
            res.customerstrainer.dueDate === undefined
        ) {
            this.member.customerstrainer.dueDate = null;
        } else {
            var trainerDueDate = JSON.stringify(res.customerstrainer.dueDate);
            var TDD = JSON.parse(trainerDueDate).split("/");
            if (TDD.length === 1) {
                this.member.customerstrainer.dueDate = new Date(TDD);
            } else {
                var newTDDate = TDD[1] + "/" + TDD[0] + "/" + TDD[2];
                if (newTDDate) {
                    this.member.customerstrainer.dueDate = new Date(newTDDate);
                }
            }
        }
    }
    clearProfile($event) {
        this.member.profile = "";
    }
    uploadCustomerImage(file: any, memberId: string | Blob, isAddMode = false) {
        let formData: FormData = new FormData();
        if (file) {


            formData.append("customerImage", file, file.name);
            formData.append("isThumb", "true");
            formData.append("memberId", memberId);
            formData.append("company", this.companySessionStorage);
            formData.append("branch", this.branchSessionStorage);
            formData.append("isAddMode", isAddMode.toString());

            this.appServiceManager.post('branches/' + this.user.branch + '/customers/upload', formData)
                .subscribe(
                    (res: any) => {
                        this.memberProfileImage= res.data;
                    },
                    (error: any) => {
                        this.messageService.clear();
                        this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                    }
                );
        }
    }

    openWhatsAppProfile(member): string {

        let reciever = member.contactDetail.contact;
        if (member.contactDetail.contact) {
            let date = new Date(member.settings.dueDate);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();

            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.profileMessage;
            msg = msg.replace("{0}", member.name);
            msg = msg.replace("{1}", member._id);
            msg = msg.replace("{2}", this.user.company);
            msg = msg.replace("{3}", this.user.branch);
            msg = msg.replace("{4}", name);
            const profileToken = AppUtils.encodePublicQueryToken({
                memberid: member._id,
                company: this.user.company,
                branch: this.user.branch,
            });
            msg = msg.replace("{6}", profileToken);

            if (this.whatsAppCommunityLink) {
                msg = msg.replace("{5}", this.whatsAppCommunityLinkMessage);
              } else {
                msg = msg.replace("{5}", "");
              }


            const message = encodeURIComponent(msg);


                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';

        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }
    }

    openWhatsAppMemberPortalInvite(member): void {
        const receiver = member?.contactDetail?.contact;
        if (!receiver) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'This user does not have a phone number',
            });
            return;
        }
        if (!member?._id || !this.user?.branch) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Member or branch is missing',
            });
            return;
        }

        const url = customerCreateOnlineBookingInviteUrl(this.user.branch, member._id);
        this.appServiceManager.post(url, {}).subscribe({
            next: (res: any) => {
                if (!res?.status || !res?.inviteUrl) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: res?.error || res?.message || 'Could not create portal invite',
                    });
                    return;
                }

                if (typeof res.sendCount === 'number') {
                    this.memberPortalInviteSendCount = res.sendCount;
                }

                let msg =
                    (typeof res.whatsappMessage === 'string' && res.whatsappMessage.trim()) ||
                    this.config.memberPortalInviteMessage
                        .replace('{0}', member.name || 'Member')
                        .replace('{1}', res.inviteUrl);

                const encoded = encodeURIComponent(msg);
                const link = document.createElement('a');
                link.href = `https://wa.me/${receiver}?text=${encoded}`;
                link.target = '_blank';
                link.click();
            },
            error: (err: any) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail:
                        err?.error?.message ||
                        err?.message ||
                        'Could not create portal invite',
                });
            },
        });
    }

    refreshMemberPortalInviteSendCount(): void {
        const customerId = this.member?._id || this.memberID;
        if (!customerId || !this.user?.branch) {
            this.memberPortalInviteSendCount = 0;
            return;
        }
        const url = customerOnlineBookingInviteStatusUrl(this.user.branch, customerId);
        this.appServiceManager.get(url).subscribe({
            next: (res: any) => {
                this.memberPortalInviteSendCount =
                    typeof res?.sendCount === 'number' ? res.sendCount : 0;
            },
            error: () => {
                this.memberPortalInviteSendCount = 0;
            },
        });
    }


    // showDialog() {
    //     this.selectedFileName = "";
    //     this.trainerSessions = this.member.customerstrainer.sessionCount;
    //     this.showTrainerFeeError = false;
    //     this.showRegistrationFeeError = false;
    //     this.showMonthlyFeeError = false;
    //     this.openFeeDialog = false;
    //     this.discountAmount = 0;
    //     this.previousDueDate = this.member.settings.dueDate;
    //     var date = new Date();
    //     this.fund.status = "Monthly Fee - Paid";
    //     if (this.member.settings.dueDate) {
    //         this.member.monthFee = this.packageFee;
    //         this.fund.pay = parseInt(this.member.monthFee) * this.numOfMonths;
    //         let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
    //         let numberOfDays: any = '';
    //         if (this.numOfMonths < 2) {
    //             if (this.fund.pay != parseInt(this.member.monthFee)) {
    //                 numberOfDays = (percentagePaid / 100) * 30;
    //             } else {
    //                 numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
    //                 numberOfDays = numberOfDays.daysInMonth();
    //                 console.log("numberOfDays", numberOfDays)
    //             }
    //             numberOfDays = Math.floor(numberOfDays);
    //         }
    //         else {
    //             let months = [];
    //             months[0] = moment(this.member.settings.dueDate);
    //             months[0] = months[0].daysInMonth();
    //             let futureDate = moment(this.member.settings.dueDate)
    //             for (let i = 0; i < this.numOfMonths - 1; i++) {
    //                 futureDate = moment(futureDate).add(months[i], 'days');
    //                 months[i + 1] = futureDate.daysInMonth();
    //                 console.log("monthss:", months[i + 1]);
    //                 numberOfDays += Math.floor(months[i]);
    //                 numberOfDays = Math.floor(numberOfDays);
    //             }
    //             numberOfDays += Math.floor(months[this.numOfMonths - 1]);
    //             numberOfDays = Math.floor(numberOfDays);
    //         }

    //         let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
    //         let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //         console.log("futureDate", futureDate)

    //         if (this.fund.status == "Trainer Fee - Paid") {
    //             this.fund.dueDate = new Date(futureDateTrainer);
    //             this.fund.day = new Date(futureDateTrainer).getDate().toString();
    //         } else if (this.fund.status == "Fine Fee - Paid") {
    //             this.fund.dueDate = new Date();
    //             this.fund.day = new Date().getDate().toString();
    //         } else {
    //             this.fund.dueDate = new Date(futureDate);
    //             this.fund.day = new Date(futureDate).getDate().toString();
    //         }
    //         this.fund.date = new Date();

    //         this.fund.month = date.getMonth() + 1;
    //         this.fund.year = date.getFullYear();
    //         this.fundInvoice.pay = parseInt(this.member.monthFee);
    //         this.fundInvoice.date = new Date();
    //         this.dialogVisibility = this.isDialogVisible;
    //         var obj = {
    //             index: 1,
    //         };
    //         this.handleChange(obj);
    //         this.feeChange();
    //     } else {
    //         this.messageService.clear();
    //         this.messageService.add({
    //             severity: "error",
    //             summary: "Error Message",
    //             detail: "Please Set Due Date in Member Setting!",
    //         });
    //     }
    // }
    sessionCountChange() {
        this.sessionCountChanged = true;
    }
    // validateDiscount() {
    //     if (this.fund.status === 'Monthly Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showMonthlyFeeError = true;
    //     } else if (this.fund.status === 'Registration Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showRegistrationFeeError = true;
    //     } else if (this.fund.status === 'Trainer Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showTrainerFeeError = true;
    //     } else {
    //         this.showTrainerFeeError = false;
    //         this.showRegistrationFeeError = false;
    //         this.showMonthlyFeeError = false;
    //     }
    // }

    onSubscriptionPaymentModeChange(value: string) {
        this.onPaymentModeChange(value);
    }

    onFreezePaymentModeChange(value: string) {
        this.selectedPaymentMode = value;
    }

    /** Same reverse/non-reverse tax base as feeCollection-signup / add-fee. */
    private calculateSubscriptionTax(
        baseAmount: number,
        discount: number,
        taxRate: number,
    ): number {
        if (!taxRate || baseAmount <= 0) {
            return 0;
        }
        if (this.isDiscountFormulaReverse) {
            if (discount >= baseAmount) {
                return 0;
            }
            return (baseAmount * taxRate) / 100.0;
        }
        if (discount >= baseAmount) {
            return 0;
        }
        return ((baseAmount - discount) * taxRate) / 100.0;
    }

    onPaymentModeChange(value: string) {
        this.paymentMode = value;
        if (!value || !value.includes("-")) {
            this.taxType = 'NO_TAX';
            this.taxRate = 0;
            this.subscriptionTax = 0;
            if (this.subscriptionMultiplePaymentModesEnabled) {
                this.recalculateSubscriptionSplitRows();
            }
            return;
        }
        const name = value.split("-")[1];
        const type = value.split("-")[0];
        const selectedPaymentMode = this.allPaymentOptions.filter(option => option.type === type && option.name === name)[0];
        if (!selectedPaymentMode?.taxSettings) {
            this.taxType = 'NO_TAX';
            this.taxRate = 0;
            this.subscriptionTax = 0;
            if (this.subscriptionMultiplePaymentModesEnabled) {
                this.recalculateSubscriptionSplitRows();
            }
            return;
        }
        this.taxType = selectedPaymentMode.taxSettings.taxCalculationType;
        this.taxRate = selectedPaymentMode.taxSettings.taxRate;
        this.subscriptionTax = this.calculateSubscriptionTax(
            this.subscriptionFee || 0,
            this.subscriptionDiscount || 0,
            this.taxRate,
        );
        if(this.taxRemovalOnSubscription){
            this.subscriptionTax= 0;
        }
        if (this.subscriptionMultiplePaymentModesEnabled) {
            this.recalculateSubscriptionSplitRows();
        }
    }

    onDiscountChange(){
        if (this.subscriptionMultiplePaymentModesEnabled) {
            this.recalculateSubscriptionSplitRows();
            return;
        }
        if (!this.paymentMode || !this.paymentMode.includes("-")) {
            this.subscriptionTax = 0;
            return;
        }
        const name = this.paymentMode.split("-")[1];
        const type = this.paymentMode.split("-")[0];
        const selectedPaymentMode = this.allPaymentOptions.filter(option => option.type === type && option.name === name)[0];
        this.taxRate = selectedPaymentMode?.taxSettings?.taxRate || 0;
        this.subscriptionTax = this.calculateSubscriptionTax(
            this.subscriptionFee || 0,
            this.subscriptionDiscount || 0,
            this.taxRate,
        );
        if (this.taxRemovalOnSubscription) {
            this.subscriptionTax = 0;
        }
    }

    onSubscriptionSplitToggle(enabled: boolean) {
        this.subscriptionMultiplePaymentModesEnabled = enabled;
        this.subscriptionSplitValidationMessage = '';
        if (!enabled) {
            this.subscriptionPaymentSplits = [];
            this.onPaymentModeChange(this.paymentMode);
            return;
        }
        this.initializeSubscriptionSplitRows();
        this.recalculateSubscriptionSplitRows();
    }

    initializeSubscriptionSplitRows() {
        const allModes = (this.paymentOptions ?? []).map((option) => option.value);
        const firstMode = this.paymentMode || allModes[0] || '';
        const secondMode = getFirstUnusedSplitPaymentMode(allModes, [firstMode]);
        this.subscriptionPaymentSplits = [
            createEmptySplitRow(firstMode),
            createEmptySplitRow(secondMode),
        ];
        this.subscriptionPaymentSplits.forEach((row) => {
            if (row.paymentMode) {
                applyTaxSettingsToRow(row, this.branch?.payments, row.paymentMode);
            }
        });
    }

    addSubscriptionSplitRow() {
        const allModes = (this.paymentOptions ?? []).map((option) => option.value);
        const usedModes = this.subscriptionPaymentSplits.map((row) => row.paymentMode);
        const nextMode = getFirstUnusedSplitPaymentMode(allModes, usedModes);
        const row = createEmptySplitRow(nextMode);
        if (nextMode) {
            applyTaxSettingsToRow(row, this.branch?.payments, nextMode);
        }
        this.subscriptionPaymentSplits = [...this.subscriptionPaymentSplits, row];
        this.recalculateSubscriptionSplitRows();
    }

    getSubscriptionSplitPaymentOptionsForRow(rowId: string) {
        return getSplitPaymentOptionsForRow(
            this.paymentOptions ?? [],
            this.subscriptionPaymentSplits,
            rowId,
        );
    }

    isSubscriptionSubscribeDisabled(): boolean {
        if (this.subscriptionDiscount > this.subscriptionFee || this.subscriptionFee === 0) {
            return true;
        }
        if (this.subscriptionMultiplePaymentModesEnabled) {
            return !!this.subscriptionSplitValidationMessage;
        }
        return false;
    }

    removeSubscriptionSplitRow(rowId: string) {
        if (this.subscriptionPaymentSplits.length <= 2) {
            return;
        }
        this.subscriptionPaymentSplits = this.subscriptionPaymentSplits.filter((row) => row.id !== rowId);
        this.recalculateSubscriptionSplitRows();
    }

    trackSubscriptionSplitRowById(_index: number, row: PaymentSplitRow): string {
        return row.id;
    }

    onSubscriptionSplitModeChange(row: PaymentSplitRow, mode: string) {
        applyTaxSettingsToRow(row, this.branch?.payments, mode);
        this.recalculateSubscriptionSplitRows();
    }

    onSubscriptionSplitAmountChange() {
        this.recalculateSubscriptionSplitRows();
    }

    onSubscriptionSplitPayChange(row: PaymentSplitRow, value: number | string | null) {
        if (value === '' || value === null || value === undefined) {
            row.pay = null;
        } else {
            row.pay = Math.round(Number(value) || 0);
        }
        this.recalculateSubscriptionSplitRows();
    }

    get allocatedSubscriptionSplitTotal(): number {
        return sumSplitPays(this.subscriptionPaymentSplits);
    }

    getSubscriptionSplitAllocationTarget(): number {
        return getSplitAllocationTarget(this.subscriptionFee || 0, this.subscriptionDiscount || 0);
    }

    isSubscriptionSplitAllocationValid(): boolean {
        return isSplitAllocationValid(
            this.subscriptionPaymentSplits,
            this.getSubscriptionSplitAllocationTarget(),
        );
    }

    recalculateSubscriptionSplitRows() {
        if (!this.subscriptionMultiplePaymentModesEnabled || !Array.isArray(this.subscriptionPaymentSplits)) {
            return;
        }
        const grossRows = convertNetSplitsToGross(
            this.subscriptionPaymentSplits,
            this.subscriptionFee || 0,
            this.subscriptionDiscount || 0,
        );
        let derivedTaxType = 'NO_TAX';
        this.subscriptionPaymentSplits = this.subscriptionPaymentSplits.map((row, index) => {
            const grossPay = Number(grossRows[index]?.pay) || 0;
            const lineDiscount = proportionalLineDiscount(
                grossPay,
                this.subscriptionFee || 0,
                this.subscriptionDiscount || 0,
            );
            const taxRow = { ...row, pay: grossPay };
            recalculateRowTax(taxRow, lineDiscount, {
                fundPay: this.subscriptionFee || 0,
                fundDiscount: this.subscriptionDiscount || 0,
                isDiscountFormulaReverse: this.isDiscountFormulaReverse,
            });
            if (this.taxRemovalOnSubscription) {
                taxRow.tax = 0;
                taxRow.includedTax = 0;
            }
            const lineTotal = calculateSplitRowTotal(taxRow, lineDiscount);
            if (taxRow.taxType === 'WITH_TAX') {
                derivedTaxType = 'WITH_TAX';
            } else if (derivedTaxType !== 'WITH_TAX' && taxRow.taxType === 'INCLUDING_TAX') {
                derivedTaxType = 'INCLUDING_TAX';
            }
            return {
                ...row,
                tax: Number(taxRow.tax) || 0,
                includedTax: Number(taxRow.includedTax) || 0,
                lineDiscount,
                lineTotal,
            };
        });
        this.subscriptionTax = this.taxRemovalOnSubscription ? 0 : sumSplitTax(this.subscriptionPaymentSplits);
        this.taxType = derivedTaxType;
        this.subscriptionSplitValidationMessage = this.getSubscriptionSplitValidationMessage();
    }

    getSubscriptionSplitValidationMessage(): string {
        if (!this.subscriptionMultiplePaymentModesEnabled) {
            return '';
        }
        if (this.subscriptionDiscount > this.subscriptionFee) {
            return this.setLabel("feeExceedLabel");
        }
        const allocationTarget = this.getSubscriptionSplitAllocationTarget();
        if (allocationTarget <= 0) {
            return this.setLabel("splitAmountGreaterThanZeroLabel");
        }
        if (this.subscriptionPaymentSplits.some((row) => !row.paymentMode)) {
            return this.setLabel("splitPaymentModeRequiredLabel");
        }
        if (hasDuplicateSplitPaymentModes(this.subscriptionPaymentSplits)) {
            return this.setLabel("splitPaymentModesMustDifferLabel");
        }
        if (this.subscriptionPaymentSplits.some((row) => row.pay == null || Number(row.pay) <= 0)) {
            return this.setLabel("splitAmountPerRowRequiredLabel");
        }
        if (!isSplitAllocationValid(this.subscriptionPaymentSplits, allocationTarget)) {
            return this.setLabel("splitAmountMustEqualTargetLabel").replace("{amount}", String(allocationTarget));
        }
        return '';
    }

    buildSubscriptionSplitFeePayload(): any {
        const grossRows = convertNetSplitsToGross(
            this.subscriptionPaymentSplits,
            this.subscriptionFee || 0,
            this.subscriptionDiscount || 0,
        );
        const splits = this.subscriptionPaymentSplits.map((row, index) => {
            const grossPay = Number(grossRows[index]?.pay) || 0;
            const lineDiscount = proportionalLineDiscount(
                grossPay,
                this.subscriptionFee || 0,
                this.subscriptionDiscount || 0,
            );
            const taxRow = { ...row, pay: grossPay };
            recalculateRowTax(taxRow, lineDiscount, {
                fundPay: this.subscriptionFee || 0,
                fundDiscount: this.subscriptionDiscount || 0,
                isDiscountFormulaReverse: this.isDiscountFormulaReverse,
            });
            if (this.taxRemovalOnSubscription) {
                taxRow.tax = 0;
            }
            return {
                paymentMode: row.paymentMode,
                pay: grossPay,
                tax: Number(taxRow.tax) || 0,
                taxRate: Number(row.taxRate) || 0,
                taxType: row.taxType || 'NO_TAX',
                transactionNumber: row.transactionNumber || '',
                feeReceiptImageUrl: row.feeReceiptImageUrl || '',
            };
        });
        const feeTax = this.taxRemovalOnSubscription ? 0 : splits.reduce((sum, row) => sum + (Number(row.tax) || 0), 0);
        return {
            paymentMode: 'Split',
            taxType: this.taxType,
            taxRate: 0,
            tax: feeTax,
            fee: this.subscriptionFee,
            discount: this.subscriptionDiscount,
            description : this.description,
            isSplitPayment: true,
            splits,
        };
    }

    calculateTotalForNewSubscription() {
        if (this.subscriptionMultiplePaymentModesEnabled) {
            return calculateSplitGrandTotal(this.subscriptionPaymentSplits);
        }
        let total = 0;
        let tax = 0;
        if(!this.subscriptionFee){
            this.subscriptionFee=0;
        }
        if(this.taxType === 'WITH_TAX') {
            tax = this.subscriptionTax || 0;
        }
        if(this.subscriptionFee >= this.subscriptionDiscount){
            total = (this.subscriptionFee + tax) - this.subscriptionDiscount;
            return total ;
        }
        else {
            return 0;
        }

    }
    onUploadButtonClick(): void {
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.click();
    }
    onAcknowledgeUploadButtonClick(): void {
        const fileInput = document.getElementById('acknowledgeFileInput') as HTMLInputElement;
        fileInput.click();
    }

    async ChangeEvent(event: any): Promise<void> {
        const file: File = event.target.files[0];
        this.selectedFileName = file.name;
        this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
        const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
        this.selectedFile = modifiedFile;

        if (this.selectedFile) {
            const formData: FormData = new FormData();
            formData.append('acknowledgedImage', this.selectedFile, this.selectedFile.name);
            try {
                await this.uploadAcknowledgeImage(formData);
            } catch (error) { }
        }
    }
    uploadAcknowledgeImage(formData: FormData): Observable<any> {

        return this.appServiceManager.post('branches/' + this.user.branch + '/customers/upload/acknowledged-image-only', formData).toPromise()
            .then((res: any) => {
                this.member.acknowledgedImage = res.data.acknowledgedImageUrl;
            })
            .catch(error => {
                // Handle errors if needed
            });
    }
    // onUploadButtonClick(): void {
    //     const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    //     fileInput.click();
    // }

    // fileChangeEvent(event: any): void {
    //     const file: File = event.target.files[0];
    //     this.selectedFileName = file.name;
    //     this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
    //     const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
    //     this.selectedFile = modifiedFile;
    // }

    // uploadReceipt(formData: FormData): Observable<any> {

    //     return this.appServiceManager.post("customers/upload/feereceiptOnly", formData).toPromise()
    //         .then((res: any) => {
    //             this.selectedFileName = res.data.feeReceiptImageUrl;
    //         })
    //         .catch(error => {
    //             // Handle errors if needed
    //         });
    // }

    // addFund() {
    //     this.fund.discountAmount = this.discountAmount;
    //     this.dialogVisibility = false;
    //     var terminDate: Date;
    //     var dateInLoop: Date;
    //     if (this.fund.status == "Trainer Fee - Paid") {
    //         this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //         this.numOfMonths = 1;
    //     }
    //     if (this.fund.status == 'Monthly Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add monthly fee ?';
    //     }
    //     else if (this.fund.status == 'Trainer Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add trainer fee ?';
    //     }
    //     else if (this.fund.status == 'Registration Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add registration fee ?';
    //     }
    //     else if (this.fund.status == 'Fine Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add fine fee ?';
    //     }
    //     this.confirmationService.confirm({
    //         message: this.confirmationBoxMessage,
    //         accept: async () => {
    //             if (this.fund.pay !== null && this.fund.pay >= 0) {

    //                 let counterCheck = 0;
    //                 let addFeeMonths = this.numOfMonths;
    //                 if (this.fund.status == "Registration Fee - Paid") {

    //                     addFeeMonths = 1;
    //                 }
    //                 this.fund.pay = Math.round(this.fund.pay / addFeeMonths);
    //                 for (let ind = 0; ind <= addFeeMonths - 1; ind++) {
    //                     this.fundCollectiveInvoice[ind] = new IMemberFeeDetails;
    //                     counterCheck = counterCheck + 1;

    //                     terminDate = new Date(this.member.settings.dueDate);

    //                     dateInLoop = new Date(this.member.settings.dueDate);
    //                     if (this.fund.status == "Trainer Fee - Paid") {
    //                         terminDate = new Date(this.member.customerstrainer.dueDate);
    //                         dateInLoop = terminDate;

    //                     }
    //                     dateInLoop.setDate(1);
    //                     dateInLoop.setMonth(terminDate.getMonth() + ind);
    //                     this.fundInvoice.pay = this.fund.pay;
    //                     this.fundCollectiveInvoice[ind].pay = this.fund.pay;
    //                     var paydate: any = this.datePipe.transform(
    //                         this.fund.date,
    //                         "MM/dd/yyyy,  h:mm a"
    //                     );
    //                     this.fund.date = paydate;
    //                     this.fund.day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundInvoice.day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundCollectiveInvoice[ind].day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundInvoice.month = this.fund.month;
    //                     this.fundInvoice.year = this.fund.year;
    //                     if (this.fund.status == "Monthly Fee - Paid") {
    //                         this.fundInvoice.discount = Math.round(this.discountAmount / this.numOfMonths);
    //                         this.fund.discount = Math.round(this.discountAmount / this.numOfMonths);

    //                     }
    //                     else {
    //                         this.fundInvoice.discount = this.discountAmount;
    //                         this.fund.discount = this.discountAmount;

    //                     }
    //                     this.fundInvoice.status = this.fund.status;
    //                     this.fundCollectiveInvoice[ind].month = this.fund.month;
    //                     this.fundCollectiveInvoice[ind].year = this.fund.year;
    //                     this.fundCollectiveInvoice[ind].status = this.fund.status;
    //                     this.fund.memberId = this.memberID;
    //                     this.fundInvoice.description = this.fund.description;
    //                     this.fundCollectiveInvoice[ind].description = this.fund.description;
    //                     this.fund.isDelete = this.member.isDelete;
    //                     this.fund.isSynced = this.member.isSynced;
    //                     this.fund.isDefaulter = this.member.isDefaulter;
    //                     this.fund.type = 'Add Fee';
    //                     this.fund.scope = 'Member';
    //                     this.fund.initiatedFrom = 'Add Member';
    //                     this.fund.currentUserData = this.currentUserData;
    //                     this.fund.oldDate = this.member.oldDate;
    //                     this.fund.createdBy = this.currentUserData.name;
    //                     const currentDate = new Date();
    //                     const currentMonth = currentDate.getMonth() + 1;
    //                     const currentYear = currentDate.getFullYear();
    //                     this.fund.invoice = AppUtils.generateInvoiceNo(this.member.tagNumber, this.member.feeDetails, currentYear, currentMonth, false, counterCheck);
    //                     let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
    //                     if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
    //                         this.fund.day = lastDayOfMonthInLoop.getDate();
    //                         this.fund.month = dateInLoop.getMonth() + 1;
    //                         this.fund.year = dateInLoop.getFullYear();
    //                     }
    //                     else {
    //                         terminDate.setMonth(terminDate.getMonth() + ind);
    //                         this.fund.day = this.fund.day;
    //                         this.fund.month = terminDate.getMonth() + 1;
    //                         this.fund.year = terminDate.getFullYear();
    //                     }
    //                     this.fund.date = new Date();
    //                     this.fund.paymentMode = this.paymentMode;
    //                     if (this.selectedFile) {
    //                         const formData: FormData = new FormData();
    //                         formData.append('feeReceiptImage', this.selectedFile, this.selectedFile.name);
    //                         try {
    //                             await this.uploadReceipt(formData);
    //                             this.fund.feeReceiptImageUrl = this.selectedFileName;
    //                         } catch (error) { }
    //                     }
    //                     //this.fundCollectiveInvoice[ind]=this.fundInvoice;
    //                     this.fundInvoice.invoice = this.fund.invoice;
    //                     if (ind === 0) {
    //                         this.fundCollectiveInvoice[ind].invoice = this.fund.invoice;
    //                         this.firstInvoice = this.fund.invoice;
    //                     }
    //                     if (this.fund.status == "Trainer Fee - Paid") {
    //                         this.fund.remainingSessionCount = parseInt(this.trainerSessions);
    //                         this.fund.sessionCount = this.trainerSessions;
    //                         const url = `trainingAttendance/updateSessionCount/${this.member._id}`;
    //                         const body = { sessionCount: this.trainerSessions, flag: true };
    //                         this.appServiceManager.put(url, body).subscribe((res: any) => {
    //                             console.log('Update successful', res);
    //                         },
    //                             (error) => {
    //                                 // Handle the error
    //                                 console.error('Update failed', error);
    //                             }
    //                         );
    //                     }
    //                     // this.member.feeDetails.push({ ...this.fund });
    //                     this.appServiceManager
    //                         .post("customers/payFund", this.fund)
    //                         .subscribe(
    //                             (res: any) => {
    //                                 let flag = false;
    //                                 if (res.status) {

    //                                     this.getCustomerByID();
    //                                     if (addFeeMonths == 1) {
    //                                         this.printInvoice();
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "success",
    //                                             summary: "Success Message",
    //                                             detail: "Member Fee Submitted",
    //                                         });
    //                                         flag = true;
    //                                     }
    //                                     if (ind == addFeeMonths - 1 && flag === false) {
    //                                         this.printMultipleInvoices();
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "success",
    //                                             summary: "Success Message",
    //                                             detail: "Member Fee Submitted",
    //                                         });
    //                                     }

    //                                     this.dataService.refreshDefaulter("refreshDefaulters");
    //                                     if (this.member.isDelete || this.member.freezeDetail.isFreeze) {
    //                                         this.showActiceFreezeBox = true;
    //                                     }

    //                                 } else if (res.status == false) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Info Message",
    //                                         detail: res.error,
    //                                     });
    //                                 } else {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "info",
    //                                         summary: "Info Message",
    //                                         detail: "Something Went Wrong",
    //                                     });
    //                                 }
    //                             },
    //                             (error) => {
    //                                 this.messageService.clear();
    //                                 this.messageService.add({
    //                                     severity: "error",
    //                                     summary: "Error Message",
    //                                     detail: error,
    //                                 });
    //                             }
    //                         );
    //                 }
    //             }
    //             else {
    //                 this.messageService.clear();
    //                 this.messageService.add({
    //                     severity: "warn",
    //                     summary: "Warning Message",
    //                     detail: "Monthly Fee Must be greater then -1.",
    //                 });
    //             }
    //         },
    //     });
    // }

    showAddProfileImage(type) {
        this.addProfileImage = type; // Upload | Cam
        this.isShowAddProfileImage = true;
    }
    removeProfileImage() {
        this.oldMemberImage = this.member.profile;
        this.uploadProfile = '';
        this.member.profile = '';
    }
    calculateTotal() {
        this.feeTotal = 0;
        this.feeTotalDiscount = 0;
        this.feeTotalTax = 0;
        if (this.customerFees) {
            if (this.customerFees.length > 0) {
                this.customerFees.forEach((record) => {
                    const pay = parseFloat(record.pay.toString());
                    let tax = 0;
                    if(record.tax === undefined || record.tax === null) {
                        tax = 0;
                    } else {
                        if(record.taxCalculationType !== "INCLUDING_TAX")
                            tax = parseFloat(record.tax.toString());
                    }
                    let discount = 0;
                    if(record.discount === undefined || record.discount === null) {
                        discount = 0;
                    } else {
                        discount = parseFloat(record.discount.toString());
                    }
                    this.feeTotal += pay;
                    this.feeTotalTax += (tax);
                    this.feeTotalDiscount += discount;
                });

                // Round final results to integers
                this.feeTotal =(this.feeTotal);
                this.feeTotalTax =(this.feeTotalTax);
                this.feeTotalDiscount =(this.feeTotalDiscount);
            }
        }
    }
    getRemainingBalance(invoiceNumber) {
        let remainingBalance = 0;
        let tax=0;
        let taxCalculationType = '';
        let taxRate = 0;

        // Combined split reprint uses base invoice (no -1/-2). Prefer balance
        // already prepared on fundInvoice (from first split row).
        if (
            this.fundInvoice &&
            this.fundInvoice.invoice === invoiceNumber &&
            this.fundInvoice.balance != null &&
            this.fundInvoice.balance !== ''
        ) {
            remainingBalance = parseFloat(String(this.fundInvoice.balance) || '0');
            taxCalculationType = this.fundInvoice.taxCalculationType || '';
            taxRate = Number(this.fundInvoice.taxRate) || 0;
            if (taxCalculationType === 'WITH_TAX') {
                tax = remainingBalance * taxRate / 100;
                remainingBalance += tax;
            }
            if (remainingBalance < 0) {
                remainingBalance = 0;
            }
            return remainingBalance.toLocaleString('en-US', {minimumFractionDigits:0});
        }

        if (this.customerFees) {
            if (this.customerFees.length > 0) {
                this.customerFees.forEach((record) => {
                    const recordInvoice = String(record.invoice || '');
                    const isExact = recordInvoice === invoiceNumber;
                    const isSplitChild =
                        !!invoiceNumber &&
                        recordInvoice.startsWith(String(invoiceNumber) + '-') &&
                        (record.isSplitPayment || record.splitGroupId != null);
                    if (isExact || (isSplitChild && Number(record.splitIndex) === 1)) {
                        remainingBalance = parseFloat(record.balance || '0') ;
                        if(record.taxCalculationType == "WITH_TAX")
                        {
                            tax = remainingBalance * record.taxRate/100;
                            remainingBalance+=tax;
                        }

                    }
                });
            }
        }
        if (remainingBalance < 0) {
            remainingBalance = 0;
        }
        return remainingBalance.toLocaleString('en-US', {minimumFractionDigits:0});
    }

    refreshFeeDetails() {
        if (this.seletedStatus === "All") {
            let data = JSON.parse(this.feeDetailsSource);
            this.customerFees = data;
        } else {
            let data = JSON.parse(this.feeDetailsSource);
            let check = data.filter((x) => x.status === this.seletedStatus);
            this.customerFees = check;
        }
    }
    captureImageDialogShow() {
        if (this.dialogVisible == true) {
            this.dialogVisible = false;
        } else {
            this.dialogVisible = true;
        }
    }
    activateMember() {
        this.openMemberConfirmation(
            'secondary',
            'Confirmation',
            'Are you sure you want to Activate member?',
            'fa fa-user-plus',
            () => {
                this.loading = true;
                const activatePayload = buildMemberUpdatePayload(this.member, {
                    modifiedBy: this.currentUserData?.name,
                    type: 'Activate',
                });
                const branchId = this.user.branch;
                const customerId = this.member._id;
                this.appServiceManager
                    .delete(customerActivateMemberUrl(branchId, customerId))
                    .subscribe(
                        () => {
                            this.appServiceManager
                                .put(customerUpdateUrl(branchId, customerId), activatePayload)
                                .subscribe(
                                    (res: any) => {
                                        if (res.status === true) {
                                            this.member = res.customer;
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "success",
                                                summary: "Success Message",
                                                detail: "Successfully Activated",
                                            });
                                        } else {
                                            this.messageService.clear();
                                            this.messageService.add({
                                                severity: "info",
                                                summary: "Info Message",
                                                detail: "Something Went Wrong",
                                            });
                                        }
                                        this.loading = false;
                                    },
                                    (error) => {
                                        this.loading = false;
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Error Message",
                                            detail: error,
                                        });
                                    }
                                );
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
            'Slide to Activate',
            'Activating...'
        );
    }
    isFreezeDisabled(member: any):boolean {
        return this.isFreezeDisabledNoFreezingDays(member) || this.isPackageExpired(member);
      }
    isFreezeDisabledNoFreezingDays(member: any): boolean {
        const hasPendingFreezeRequest = (member.freezeRequest || []).some(
            (request: IFreezeRequest) => request?.status === 'Scheduled',
        );
        return (
            this.branch.permissions?.complimentaryFreezingDays &&
            (!member.freezeDetail?.totalFreezingDays || member.freezeDetail.totalFreezingDays < 1 || hasPendingFreezeRequest)
        );
        }
    isPackageExpired(member: any): boolean {
        return new Date(member.settings.dueDate) < new Date();
     }

    canShowComplimentaryFreezeTab(): boolean {
        return this.mode === "edit" && !!this.branch?.permissions?.complimentaryFreezingDays;
    }

    /** New trainer module book tab — branch.permissions.trainerModule.enabled */
    get isTrainerModuleEnabled(): boolean {
        return !!this.branch?.permissions?.trainerModule?.enabled;
    }

    getAvailableComplimentaryFreezingDays(): number {
        return Number(this.member?.freezeDetail?.totalFreezingDays || 0);
    }

    openComplimentaryFreezeRequestDialog(): void {
        this.complimentaryFreezeStartDate = null;
        this.complimentaryFreezeEndDate = null;
        this.complimentaryFreezeSelectedDays = 0;
        this.complimentaryFreezeDialogVisible = true;
    }

    onComplimentaryFreezeDateChange(): void {
        if (!this.complimentaryFreezeStartDate || !this.complimentaryFreezeEndDate) {
            this.complimentaryFreezeSelectedDays = 0;
            return;
        }
        this.complimentaryFreezeSelectedDays = this.getFreezeDaySpan(
            this.complimentaryFreezeStartDate,
            this.complimentaryFreezeEndDate
        );
    }

    getComplimentaryFreezeEndMinDate(): Date {
        return this.complimentaryFreezeStartDate || this.minComplimentaryFreezeDate;
    }

    canCancelComplimentaryFreezeRequest(request: IFreezeRequest): boolean {
        return !!request?._id && request?.status === 'Scheduled';
    }

    cancelComplimentaryFreezeRequest(request: IFreezeRequest): void {
        if (!this.canCancelComplimentaryFreezeRequest(request)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Only scheduled freeze requests can be cancelled.",
            });
            return;
        }

        this.confirmationService.confirm({
            message:
                this.getSameHistoryGroupConfirmMessage('cancelScheduleFreeze') ||
                'Are you sure you want to cancel this freeze request?',
            accept: () => {
                this.loading = true;
                const payload = buildCancelFreezeSchedulePayload(
                    this.currentUserData?.name || this.user?.name,
                );
                this.appServiceManager
                    .put(
                        customerCancelFreezeScheduleUrl(
                            this.user.branch,
                            this.member._id,
                            request._id,
                        ),
                        payload,
                    )
                    .subscribe(
                        (res: any) => {
                            this.loading = false;
                            if (res?.freezeRequest) {
                                this.member.freezeRequest = res.freezeRequest;
                            } else {
                                const index = (this.member.freezeRequest || []).findIndex(
                                    (x: IFreezeRequest) => String(x._id) === String(request._id)
                                );
                                if (index > -1) {
                                    this.member.freezeRequest[index].status = "Cancelled";
                                }
                            }

                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Freeze request cancelled successfully.",
                            });
                        },
                        (error: any) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error?.error?.message || "Unable to cancel freeze request.",
                            });
                        }
                    );
            },
        });
    }

    submitComplimentaryFreezeRequest(): void {
        if (!this.branch?.permissions?.complimentaryFreezingDays) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Complimentary freezing is not enabled for this branch.",
            });
            return;
        }

        if (!this.complimentaryFreezeStartDate || !this.complimentaryFreezeEndDate) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Please select start and end date.",
            });
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const start = new Date(this.complimentaryFreezeStartDate);
        start.setHours(0, 0, 0, 0);
        const end = new Date(this.complimentaryFreezeEndDate);
        end.setHours(0, 0, 0, 0);
        const packagedueDate = new Date(this.member.settings.dueDate);
        if (packagedueDate < start) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Freeze start date cannot be after package due date.",
            });
            return;
        }
        if ( (this.member.freezeRequest || []).some((request: IFreezeRequest) => {
                if (request?.status !== 'Scheduled') {
                    return false;
                }
                const existingStart = new Date(request.startDate);
                const existingEnd = new Date(request.endDate);
                return start <= existingEnd && end >= existingStart;
            })) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Selected date range overlaps with an existing freeze request.",
            });
            return;
        }

        if (start < today) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Freeze start date cannot be in the past.",
            });
            return;
        }

        if (
            start.getTime() === today.getTime() &&
            (this.member.isFreeze || this.member.freezeDetail?.isFreeze)
        ) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Member is already frozen. Unfreeze before scheduling from today.",
            });
            return;
        }

        if (end < start) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "End date cannot be before start date.",
            });
            return;
        }

        const requestedDays = this.getFreezeDaySpan(start, end);
        const totalFreezingDays = this.getAvailableComplimentaryFreezingDays();

        if (requestedDays <= 0) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: "Selected date range is invalid.",
            });
            return;
        }

        if (requestedDays > totalFreezingDays) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: `Selected freeze days (${requestedDays}) cannot exceed total complimentary days (${totalFreezingDays}).`,
            });
            return;
        }
        const totalUsedDays = (this.member.freezeRequest || [])
            .filter((req: IFreezeRequest) => req?.status === 'Scheduled')
            .reduce((sum, req: IFreezeRequest) => sum + this.getFreezeRequestDayCount(req), 0);
        if (totalUsedDays + requestedDays > totalFreezingDays) {
            this.messageService.clear();
            this.messageService.add({
             severity: "warn",
            summary: "Warning",
            detail: "Total freeze days exceed available complimentary days."
            });
            return;
        }
        this.confirmationService.confirm({
            message:
                this.getSameHistoryGroupConfirmMessage('scheduleFreeze') ||
                'Are you sure you want to submit this complimentary freeze request?',
            accept: () => {
                this.complimentaryFreezeSubmitting = true;
                this.appServiceManager
                    .put(
                        customerCreateFreezeScheduleUrl(this.user.branch, this.member._id),
                        buildCreateFreezeSchedulePayload({
                            days: requestedDays.toString(),
                            startDate: start.toISOString(),
                            endDate: end.toISOString(),
                        }),
                    )
                    .subscribe(
                        (res: any) => {
                            this.complimentaryFreezeSubmitting = false;
                            if (res?.status === false) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail:
                                        res?.error ||
                                        res?.message ||
                                        "Unable to submit freeze request.",
                                });
                                return;
                            }
                            if (!this.member.freezeRequest) {
                                this.member.freezeRequest = [];
                            }
                            if (res?.freezeRequest) {
                                this.member.freezeRequest = res.freezeRequest;
                            }
                            this.complimentaryFreezeDialogVisible = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: res?.frozenImmediately
                                    ? "Member frozen from today."
                                    : "Complimentary freeze request submitted successfully.",
                            });
                            if (res?.frozenImmediately) {
                                this.getCustomerByID();
                                this.getFreezeReport();
                            }
                        },
                        (error:any) => {
                            this.complimentaryFreezeSubmitting = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error?.error?.message || "Unable to submit freeze request.",
                            });
                        }
                    );
            },
        });
    }

    /** Days the member stays frozen. From the 11th to the 12th is 1 day. */
    getFreezeDaySpan(start: Date, end: Date): number {
        const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
        const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
        return Math.max(0, Math.floor((endUtc - startUtc) / (1000 * 60 * 60 * 24)));
    }

    getFreezeRequestDayCount(request: IFreezeRequest): number {
        if (!request?.startDate || !request?.endDate) {
            return Number(request?.days || 0);
        }
        return this.getFreezeDaySpan(new Date(request.startDate), new Date(request.endDate));
    }

    freezeMember(member: IMember) {
        let message =
            this.getSameHistoryGroupConfirmMessage('freeze') ||
            'Are you sure you want to Freeze member?';

        if (!this.getSameHistoryGroupConfirmMessage('freeze') && this.branch.permissions?.complimentaryFreezingDays &&
            (!member.freezeDetail.totalFreezingDays || member.freezeDetail.totalFreezingDays < 1)) {
                message = "No complimentary freezing days left. Do you still want to Freeze the member?";
        }
        else if (
            !this.getSameHistoryGroupConfirmMessage('freeze') &&
            this.branch.permissions?.complimentaryFreezingDays &&
            member.freezeDetail.totalFreezingDays >= 1
        ) {
             message = "Freezing days left for this customer: " + member.freezeDetail.totalFreezingDays + ".\nAre you sure you want to Freeze Member?";
        }
        this.confirmationService.confirm({
            message: message,
            accept: () => {
                this.loading = true;
                member.freezeDetail.daysLeft = this.getPackgeDays(member.settings.dueDate);
                this.member.freezeDetail.isFreeze = true;
                const freezePayload = buildFreezeMemberPayload(member, this.currentUserData);
                this.appServiceManager
                    .put(customerFreezeMemberUrl(this.user.branch, this.member._id), freezePayload)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Freezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }
    defreezeMember(member: IMember) {
        const message =
            this.getSameHistoryGroupConfirmMessage('defreeze') ||
            'Are you sure you want to DeFreeze member ?';
        this.confirmationService.confirm({
            message: message,
            accept: () => {
                this.loading = true;
                member.freezeDetail.isFreeze = false;
                var checkDay = parseInt(member.freezeDetail.daysLeft.toString());
                let currentDate = new Date()
                let calculatedDate = moment(currentDate).add(checkDay, 'days').toISOString();
                member.settings.dueDate = new Date(calculatedDate);
                member.type = 'DeFreeze';
                member.scope = 'Member';
                member.initiatedFrom = 'Add Member';
                const defreezePayload = buildDefreezeMemberPayload(member, this.currentUserData);
                this.appServiceManager
                    .put(customerDefreezeMemberUrl(this.user.branch, this.member._id), defreezePayload)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.validateMember(this.member);
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully unfrozen",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }

    openPhoto(imageUrl: any) {
        this.imgPreview = true;
        const base = String(this.config.Server || '').replace(/\/+$/, '');
        const file = String(imageUrl ?? '').replace(/^\/+/, '');
        this.imgPreviewImg = `${base}/${this.config.feereceiptImagePath}/${file}`;
    }

    openAcknowledgePhoto(imageUrl: any) {
        this.imgPreview = true;
        const base = String(this.config.Server || '').replace(/\/+$/, '');
        const file = String(imageUrl ?? '').replace(/^\/+/, '');
        this.imgPreviewImg = `${base}/${this.config.memberImagePath}/${file}`;
    }

    closePhotoPreview() {
        this.imgPreview = false;
        this.imgPreviewImg = "";
    }

    hideAddProfileImage() {
        this.isShowAddProfileImage = false
    }

    showPackageDialog(){
        if (this.isInRelatedMembersGroup() && !this.isEligibleForGroupPackageChange()) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: this.setLabel("relatedMembersGroupPackageChangeWarningLabel"),
            });
            return;
        }
        this.packagesDropDown = this.buildChangePackageOptions(
            (this.packages || []).filter((x) => !x.isDelete),
        );
        this.isPackageDialogVisible = true;
        this.selectedPackageId = undefined;
    }

    get assignedSecondaryPackages(): any[] {
        return this.member?.secondaryPackages || [];
    }

    get secondaryPackageAssignOptions(): any[] {
        const assignedIds = (this.assignedSecondaryPackages || []).map((p) => String(p.packageId));
        const primaryId = this.member?.packageId ? String(this.member.packageId) : '';
        return (this.packages || [])
            .filter((pkg) => {
                if (!pkg || pkg.isDelete) return false;
                const id = String(pkg._id);
                if (id === primaryId || assignedIds.indexOf(id) !== -1) return false;
                if (Number(pkg.noOfMembers || 0) > 1) return false;
                if (pkg.groupFeePayByOnePerson) return false;
                return true;
            })
            .map((pkg) => {
                const fee = Math.round(Number(pkg.packageFee) || 0);
                return {
                    label: fee ? pkg.packageName + '  ·  ' + fee : pkg.packageName,
                    value: pkg._id,
                };
            });
    }

    secondaryPackageFeeAmount(pkg: any): number | null {
        const id = pkg?.packageId != null ? String(pkg.packageId) : '';
        if (!id) {
            return null;
        }
        const found = (this.packages || []).find((item) => String(item._id) === id);
        if (!found) {
            return null;
        }
        return Math.round(Number(found.packageFee) || 0);
    }

    assignSecondaryPackage() {
        if (!this.member?._id || !this.selectedSecondaryToAdd) {
            return;
        }
        this.secondaryPackageSaving = true;
        this.appServiceManager
            .post(
                "branches/" + this.user.branch + "/customers/" + this.member._id + "/actions/secondary-packages",
                { packageId: this.selectedSecondaryToAdd },
            )
            .subscribe(
                (res: any) => {
                    this.secondaryPackageSaving = false;
                    if (res && res.status) {
                        this.member.secondaryPackages = res.response || [];
                        this.selectedSecondaryToAdd = null;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: this.setLabel("secondaryPackageAssignedLabel"),
                        });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: res && res.error ? res.error : "Failed to assign secondary package",
                        });
                    }
                },
                (error: any) => {
                    this.secondaryPackageSaving = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error,
                    });
                },
            );
    }

    removeSecondaryPackage(pkg: any) {
        if (!this.member?._id || !pkg?.packageId) {
            return;
        }
        this.confirmationService.confirm({
            message: this.setLabel("removeSecondaryPackageConfirmLabel"),
            accept: () => {
                this.secondaryPackageSaving = true;
                this.appServiceManager
                    .delete(
                        "branches/" + this.user.branch + "/customers/" + this.member._id +
                        "/actions/secondary-packages/" + pkg.packageId,
                    )
                    .subscribe(
                        (res: any) => {
                            this.secondaryPackageSaving = false;
                            if (res && res.status) {
                                this.member.secondaryPackages = res.response || [];
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success",
                                    detail: this.setLabel("secondaryPackageRemovedLabel"),
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error",
                                    detail: res && res.error ? res.error : "Failed to remove secondary package",
                                });
                            }
                        },
                        (error: any) => {
                            this.secondaryPackageSaving = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: error,
                            });
                        },
                    );
            },
        });
    }

    isInRelatedMembersGroup(): boolean {
        return !!this.member?.relatedMembersId;
    }

    isEligibleForGroupPackageChange(): boolean {
        return !!(
            this.member?.relatedMembersId &&
            this.selectedMemberPackage?.groupFeePayByOnePerson === true &&
            this.selectedMemberPackage?.noOfMembers > 1
        );
    }

    canChangeGroupToPackage(targetPackage: IPackageBuider, groupSize: number): boolean {
        const requiredMin = Math.max(
            groupSize,
            this.selectedMemberPackage.noOfMembers ?? 0,
        );
        const targetPackGroupFeeCanBePayByOnePerson = targetPackage.groupFeePayByOnePerson;
        const targetPackIsGreaterthanNoOfMembers = targetPackage.isGreaterthanNoOfMembers;

        if (!targetPackage || !this.selectedMemberPackage) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: this.setLabel("packageNotSelectedLabel"),
            });
            return false;
        }
        if ((targetPackage.noOfMembers ?? 0) === 1) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: this.setLabel("changeGroupPackagetoSinglePersonPackageNotAllowedLabel"),
            });
            return false;
        }
        if(!targetPackGroupFeeCanBePayByOnePerson){
            this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning",
                        detail: this.setLabel("GroupPackageChangeFromisGroupPayByOnePersonToCantPayByOnePersonNotAllowedLabel"),
                    });
            return false;
        }


        if ((((targetPackage.noOfMembers ?? 0) < requiredMin) && !targetPackIsGreaterthanNoOfMembers)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: this.setLabel("relatedMembersGroupPackageInsufficientMembersLabel"),
            });
            return false;
        }
        if ((targetPackage.isGreaterthanNoOfMembers && targetPackGroupFeeCanBePayByOnePerson) || ((targetPackage.noOfMembers ?? 0) >= requiredMin)) {
            return true;
        }
    }

    fetchRelatedMembersGroup(forceReload = false): Promise<any> {
        if (!this.member?.relatedMembersId) {
            return Promise.resolve(null);
        }
        if (this.relatedMembersGroup && !forceReload) {
            return Promise.resolve(this.relatedMembersGroup);
        }
        this.relatedMembersLoading = true;
        return this.appServiceManager
            .get(
                'branches/' +
                    this.user.branch +
                    '/customers/actions/related-members-group/' +
                    this.member.relatedMembersId,
            )
            .toPromise()
            .then((res: any) => {
                if (res?.status && res.response) {
                    this.relatedMembersGroup = res.response;
                    return res.response;
                }
                const message =
                    res?.error?.message ||
                    res?.message ||
                    'Failed to load related members group';
                throw new Error(message);
            })
            .finally(() => {
                this.relatedMembersLoading = false;
            });
    }

    updatePackage() {
        const selectedPackage: IPackageBuider = this.packages.find(
            (x) => x._id === this.member.packageId,
        );
        if (!selectedPackage) {
            return;
        }

        if (this.isEligibleForGroupPackageChange()) {
            this.isPackageDialogVisible = false;
            this.updateGroupPackage(selectedPackage);
            return;
        }

        if (this.isInRelatedMembersGroup()) {
            this.messageService.clear();
            this.messageService.add({
                severity: "warn",
                summary: "Warning",
                detail: this.setLabel("relatedMembersGroupPackageChangeWarningLabel"),
            });
            this.isPackageDialogVisible = false;
            return;
        }

        this.runSingleMemberPackageUpdate(selectedPackage);
    }

    updateGroupPackage(selectedPackage: IPackageBuider) {
        this.fetchRelatedMembersGroup()
            .then((group) => {
                const groupSize = group?.members?.length ?? 0;
                if (!group || groupSize === 0) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "warn",
                        summary: "Warning",
                        detail: this.setLabel("relatedMembersGroupLengthZeroLabel"),
                    });
                    return;
                }

                if (!this.canChangeGroupToPackage(selectedPackage, groupSize)) {
                    // this.messageService.clear();
                    // this.messageService.add({
                    //     severity: "error",
                    //     summary: "Error Message",
                    //     detail: this.setLabel("relatedMembersGroupPackageInsufficientMembersLabel"),
                    // });
                    return;
                }

                const confirmMessage = this.setLabel(
                    "relatedMembersGroupPackageChangeConfirmLabel",
                ).replace("{count}", String(groupSize));

                this.openMemberConfirmation(
                    'secondary',
                    'Confirmation',
                    confirmMessage,
                    'pi pi-exclamation-triangle',
                    () => {
                        const payload = {
                            packageId: selectedPackage._id,
                            modifiedBy: this.currentUserData?.name,
                        };
                        this.appServiceManager
                            .put(
                                'branches/' +
                                    this.user.branch +
                                    '/customers/actions/related-members-group/' +
                                    this.member.relatedMembersId +
                                    '/package',
                                payload,
                            )
                            .subscribe(
                                (res: any) => {
                                    if (res?.status && res.response) {
                                        this.relatedMembersGroup = res.response;
                                        this.clearBranchMembersOptionsCache();
                                        this.getCustomerByID();
                                        this.getPackagesByID();
                                        this.loadPackages();
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "success",
                                            summary: "Success Message",
                                            detail: this.setLabel(
                                                "relatedMembersGroupPackageChangeSuccessLabel",
                                            ),
                                        });
                                    } else {
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "error",
                                            summary: "Error Message",
                                            detail:
                                                res?.message ||
                                                (typeof res?.error === 'string'
                                                    ? res.error
                                                    : res?.error?.message) ||
                                                this.setLabel(
                                                    "relatedMembersGroupPackageChangeFailedLabel",
                                                ),
                                        });
                                    }
                                },
                                (error) => {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail:
                                            error?.error?.message ||
                                            error?.message ||
                                            this.setLabel(
                                                "relatedMembersGroupPackageChangeFailedLabel",
                                            ),
                                    });
                                },
                            );
                    },
                );
            })
            .catch((error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error?.message || this.setLabel("relatedMembersGroupLoadFailedLabel"),
                });
            });
    }

    runSingleMemberPackageUpdate(selectedPackage: IPackageBuider) {
        const selectedPackagename = this.packagesDropDown.find(
            (package1) => package1.value === this.member.packageId,
        );
        this.openMemberConfirmation(
            'secondary',
            'Confirmation',
            'Are you sure you want to update package?',
            'pi pi-exclamation-triangle',
            () => {

                this.member.company = this.user.company;
                this.member.branch = this.user.branch;
                this.member.type = 'Update Package';
                this.member.scope = 'Member';
                this.member.initiatedFrom = 'Add Member';
                this.updateMemberSettingFlag = true;
                this.member.memberSettingFlag = this.updateMemberSettingFlag;
                this.member.packageName = selectedPackagename.label;
                this.member.packageType = selectedPackage.packageType;
                this.member.monthFee = String(
                    Math.round(Number(selectedPackage.packageFee) || 0),
                );
                if (selectedPackage.registerationFee != null) {
                    this.member.registerationFee =
                        selectedPackage.registerationFee.toString();
                }
                const packagePayload = buildMemberUpdatePayload(this.member, {
                    modifiedBy: this.currentUserData?.name,
                    type: 'Update Package',
                    includeCompanyBranch: true,
                });
                this.appServiceManager
                    .put(customerUpdateUrl(this.user.branch, this.member._id), packagePayload)
                    .subscribe(
                        (res: any) => {
                            if (res) {
                                this.member = res.customer;
                                this.clearBranchMembersOptionsCache();
                                this.relatedMembersGroup = null;
                                this.feeDetailsSource = JSON.stringify(
                                    this.customerFees
                                );
                                this.validateMember(res.customer);
                                this.fund.pay = parseInt(
                                    this.member.monthFee
                                );
                                this.setDate(res.customer);
                                this.getCompany();
                                this.calculateTotal();
                                this.allowDialog = true;
                                this.loadPackages();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Successfully Updated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        },
                        this.updateMemberSettingFlag = false
                    );
            },
        );
        this.isPackageDialogVisible = false;
    }

    getWalletByMemberId(memberId: string) {
        if (!memberId) {
            this.walletAmount = 0;
            this.walletDetails = [];
            return;
        }
        this.appServiceManager
            .get(`branches/${this.user.branch}/wallets/members/${memberId}`)
            .subscribe(
                (res: any) => {
                    if (res && res.status === true) {
                        this.walletAmount = res.customer.walletAmount;
                        this.walletDetails = res.customer.walletDetail;
                    } else {
                        this.walletAmount = 0;
                        this.walletDetails = [];
                    }
                },
                () => {
                    this.walletAmount = 0;
                    this.walletDetails = [];
                }
            );
    }


    addAmountDialog() {
        this.isWalletDialogVisible = true
    }
    addWalletAmount() {
        this.confirmationService.confirm({
            message: "Are you sure you want to update Wallet Amount?",
            accept: () => {
                const payload = buildUpdateWalletAmountPayload({
                    memberId: this.member._id,
                    customerName: this.member.name,
                    membershipNo: this.member.tagNumber,
                    updateWalletAmount: this.newWalletAmount,
                    previousBalance: this.walletAmount,
                    createdBy: this.user.name,
                });

                this.appServiceManager
                    .post(walletUpdateAmountUrl(this.user.branch), payload)
                    .subscribe(
                        (res: any) => {
                            this.messageService.clear();
                            if (res && res.status == true) {
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success",
                                    detail: res.message || "Payment Updated Successfully",
                                });
                                this.getWalletByMemberId(this.memberID);
                                this.isWalletDialogVisible = false
                            } else {
                                this.messageService.add({
                                    severity: "warn",
                                    summary: "Warning",
                                    detail: res.message || "Payment could not be updated",
                                });
                            }
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: "Failed to update payment",
                            });
                        }
                    );
            }
        });
    }

    loadPackages() {
        this.getPackages();
        this.getPackagesByID();
    }


    updatePaymentMode(selectedPayment) {
        if (!this.canEditCollectedFeePaymentMode(this.currentSelectedFee)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: this.setLabel("paymentModeEditNotAllowedLabel"),
            });
            return;
        }

        if (!selectedPayment) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: this.setLabel("selectPaymentModeErrorLabel"),
            });
            return;
        }

        const currentMode = this.currentSelectedFee?.paymentMode || "Cash-Reception";
        const modeChanged = selectedPayment !== currentMode;
        const hasReceiptFile =
            !!this.paymentModeReceiptFile &&
            this.paymentModeNeedsReceipt(selectedPayment) &&
            this.canManageFeeReceipt();

        if (!modeChanged && !hasReceiptFile) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: this.setLabel("selectDifferentPaymentModeErrorLabel"),
            });
            return;
        }

        if (modeChanged) {
            const siblingModes = getSplitGroupFees(
                this.getMemberFeeDetailsList(),
                this.currentSelectedFee,
            )
                .filter(
                    (row) =>
                        String(row?._id) !== String(this.currentSelectedFee?._id),
                )
                .map((row) => String(row.paymentMode || '').trim());

            if (siblingModes.includes(String(selectedPayment).trim())) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: this.setLabel("splitPaymentModeDuplicateErrorLabel"),
                });
                return;
            }
        }

        const confirmMessage = modeChanged
            ? this.setLabel("changePaymentModeConfirmLabel")
            : this.setLabel("reuploadReceiptTooltipLabel");

        this.confirmationService.confirm({
            message: confirmMessage,
            accept: async () => {
                this.isUpdatingPaymentModeReceipt = true;
                this.loading = true;
                try {
                    if (modeChanged) {
                        const payload = {
                            id: this.currentSelectedFee._id,
                            paymentMode: selectedPayment,
                        };
                        const res: any = await this.appServiceManager
                            .patch(
                                `branches/${this.user.branch}/customer-fees/actions/update-payment-mode`,
                                payload,
                            )
                            .toPromise();

                        if (res?.status === false) {
                            throw new Error(
                                res?.error || "Failed to update payment mode",
                            );
                        }
                    }

                    if (hasReceiptFile) {
                        await this.uploadAndSavePaymentModeReceipt(
                            this.currentSelectedFee._id,
                        );
                    }

                    this.isChangePaymentModeDialogVisible = false;
                    this.clearPaymentModeReceiptSelection();
                    this.getCustomerFees();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: modeChanged
                            ? this.setLabel("changePaymentModeSuccessLabel")
                            : this.setLabel("reuploadReceiptSuccessLabel"),
                    });
                } catch (error: any) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail:
                            error?.message ||
                            (hasReceiptFile && !modeChanged
                                ? this.setLabel("reuploadReceiptFailedLabel")
                                : this.setLabel("changePaymentModeFailedLabel")),
                    });
                } finally {
                    this.isUpdatingPaymentModeReceipt = false;
                    this.loading = false;
                }
            },
        });
    }
    updateInvoiceDate(selectedDate) {
        if (!this.canEditInvoiceDate()) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "You are not allowed to edit invoice date",
            });
            return;
        }

        if (!selectedDate) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select an invoice date",
            });
            return;
        }

        const currentDate =
            this.invoiceDateEditTarget === 'subscriptionFee'
                ? this.currentSelectedFee?.createdDate ||
                  this.currentSelectedFee?.date
                : this.currentSelectedFee?.date;

        if (this.isSameInvoiceDate(currentDate, selectedDate)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select an invoice date different from the current date",
            });
            return;
        }

        const isoDate = selectedDate.toISOString();
        const invoiceDateConfirmMessage =
            this.invoiceDateEditTarget === 'memberFee' &&
            this.splitInvoiceDateGroupCount > 1
                ? this.setLabel('splitInvoiceDateConfirmLabel').replace(
                      /\{count\}/g,
                      String(this.splitInvoiceDateGroupCount),
                  )
                : this.setLabel('changeInvoiceDateConfirmLabel');

        this.confirmationService.confirm({
            message: invoiceDateConfirmMessage,
            accept: () => {
                if (this.invoiceDateEditTarget === 'subscriptionFee') {
                    this.appServiceManager
                        .put(
                            `branches/${this.user.branch}/subscription-fees/${this.currentSelectedFee._id}/actions/invoice-date`,
                            { newInvoiceDate: isoDate },
                        )
                        .subscribe(
                            (res: any) => {
                                if (res?.status === false) {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail:
                                            res?.error ||
                                            res?.message ||
                                            "Failed to update invoice date",
                                    });
                                    return;
                                }
                                this.isChangeInvoiceDateDialogVisible = false;
                                this.getAllSubscriptions();
                                this.getAllSubscriptionFee();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Invoice Date Updated Successfully",
                                });
                            },
                            (error) => {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail: "Failed to update invoice date",
                                });
                            },
                        );
                    return;
                }

                const payload = {
                    id: this.currentSelectedFee._id,
                    newInvoiceDate: isoDate,
                };
                this.appServiceManager
                    .put(
                        "branches/" +
                            this.user.branch +
                            "/customers/actions/update-invoice-date",
                        payload,
                    )
                    .subscribe(
                        (res: any) => {
                            if (res?.status === false) {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail:
                                        res?.error ||
                                        "Failed to update invoice date",
                                });
                                return;
                            }
                            this.isChangeInvoiceDateDialogVisible = false;
                            this.getCustomerFees();
                            this.messageService.clear();
                            const successDetail =
                                this.splitInvoiceDateGroupCount > 1
                                    ? this.setLabel(
                                          'splitInvoiceDateSuccessLabel',
                                      ).replace(
                                          /\{count\}/g,
                                          String(
                                              this.splitInvoiceDateGroupCount,
                                          ),
                                      )
                                    : this.setLabel(
                                          'changeInvoiceDateSuccessLabel',
                                      );
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: successDetail,
                            });
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: this.setLabel("changeInvoiceDateFailedLabel"),
                            });
                        },
                    );
            },
        });
    }

    updateSubscriptionPaymentMode(selectedPayment) {
        if (!this.canEditCollectedFeePaymentMode(this.currentSelectedFee)) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "You are not allowed to edit payment mode",
            });
            return;
        }

        if (!selectedPayment) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a payment mode",
            });
            return;
        }

        const currentMode = this.currentSelectedFee?.paymentMode || "Cash-Reception";
        if (selectedPayment === currentMode) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a payment mode different from the current one",
            });
            return;
        }

        this.confirmationService.confirm({
            message: "Are you sure you want to change Payment Mode?",
            accept: () => {
                const payload = {
                    id: this.currentSelectedFee._id,
                    paymentMode: selectedPayment,
                };

                this.appServiceManager
                    .put(`branches/${this.user.branch}/subscription-fees/${payload.id}/actions/payment-mode`, {
                        paymentMode: payload.paymentMode,
                    })
                    .subscribe(
                        (res: any) => {
                            this.isChangePaymentModeDialogVisible = false;
                            this.getAllSubscriptions();
                            this.getAllSubscriptionFee();
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Payment Mode Updated Successfully",
                            });
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: "Failed to update payment mode",
                            });
                        },
                    );
            },
        });
    }
    activityLogs(member) {
        member.currentUserData = this.currentUserData;
        member.type = 'Deactivate';
        member.scope = 'Member';
        member.initiatedFrom = 'Add Member';
        // Make an API call to log the activity
        this.appServiceManager.post(`system/branches/${AuthService.getLoggedInBranch()}/activity-logs`, buildActivityLogPayload(member)).subscribe((logRes: any) => {
            // Handle the logging response here
        });
    }
    deActivateMember() {
        const inRelatedGroup = !!this.member?.relatedMembersId;
        const message = inRelatedGroup
            ? 'This member belongs to a related group. Deactivating will remove them from the group. Are you sure you want to continue?'
            : 'Are you sure you want to deactivate member?';
        this.openMemberConfirmation(
            'secondary',
            'Deactivate member?',
            message,
            'fa fa-user-times',
            () => this.confirmDeactivateMember(),
            'Slide to Deactivate',
            'Deactivating...'
        );
    }

    private openMemberConfirmation(
        variant: 'secondary',
        heading: string,
        message: string,
        iconClass: string,
        action: () => void | Promise<void>,
        slideText = 'Slide to confirm',
        doneText = 'Confirmed',
        actionText = 'Yes',
        actionIconClass = 'pi pi-check'
    ) {
        this.memberConfirmVariant = variant;
        this.memberConfirmHeading = heading;
        this.memberConfirmMessage = message;
        this.memberConfirmIconClass = iconClass;
        this.memberConfirmSlideText = slideText;
        this.memberConfirmDoneText = doneText;
        this.memberConfirmCancelText = 'No';
        this.memberConfirmCancelIconClass = 'pi pi-times';
        this.memberConfirmSlideIconClass = 'fa fa-angle-double-right';
        this.memberConfirmConfirmText = actionText;
        this.memberConfirmConfirmIconClass = actionIconClass;
        this.pendingMemberConfirmation = action;
        this.memberConfirmVisible = true;
    }

    cancelMemberConfirmation() {
        this.memberConfirmVisible = false;
        this.pendingMemberConfirmation = null;
    }

    runMemberConfirmation() {
        const action = this.pendingMemberConfirmation;
        this.memberConfirmVisible = false;
        this.pendingMemberConfirmation = null;
        if (action) void action();
    }

    confirmDeactivateMember() {
        this.loading = true;
        this.appServiceManager
            .delete("branches/" + this.user.branch + "/customers/" + this.member._id)
            .subscribe(
                (res: any) => {
                    if (res.status === true) {
                        this.activityLogs(this.member);
                        this.getCustomerByID();

                        this.messageService.clear();
                        this.loading = false;
                        this.messageService.add({
                            severity: "success",
                            summary: "Success Message",
                            detail: "Successfully Deactivated",
                        });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    IsSyncedMember(member) {
        this.openMemberConfirmation('secondary', 'Sync member?', 'Are you sure you want to Sync again?', 'fa fa-spinner', () => {
                this.loading = true;
                let payload = {
                    isSynced: false
                };
                this.appServiceManager.put(customerIsSyncedUrl(this.user.branch, member._id), payload).subscribe((res: any) => {
                    if (res.status === true) {
                        // this.DeleteMember(member);

                        this.messageService.clear();
                        this.loading = false;
                        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Sync process has been started' });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                    }

                },
                    (error) => {
                        this.loading = false;
                        this.messageService.clear();
                        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                    });
            }
        );
    }
    addVitailspopup(){
    this.addVitalsDialog=true;
    this.showBodySpecPopup=true;
}

    payFee(){
        if (!AuthService.getLoggedInUser() || !localStorage.getItem('token')) {
            this.router.navigateByUrl('/login');
            return;
        }
        this.feeInvoiceDialog=true;
        this.dialogVisibility=true;

      }

      closeFeeCollectionDialog() {
        this.getCustomerByID();
        this.getCustomerFees();
        this.dialogVisibility = false;
        this.feeInvoiceDialog = false;

      }

    addFreezingDays(){
         this.extendFreezeDaysDialog = true;
         this.fund.status== "Fine Fee - Paid";
    }
    closeAddFreezingDaysDialog(){
        this.extendFreezeDaysDialog = false;
        this.getCustomerByID();
        this.fund.status== "";
    }

    addFreezingFeeAndDays(memberObj: any) {
         if (!this.freezeDays || !this.freezeAmount || !this.selectedPaymentMode) {
            this.messageService.add({ severity: 'warn', summary: 'Warning', detail: ' Please fill all fields before proceeding.' });
            return;
        }
        this.fund.status = "Fine Fee - Paid";
        this.fund.scope = "Member";
        this.fund.type = "Extend Freeze";
        this.fund.initiatedFrom = "Add Member";
        this.fund.description = this.freezeFeeDescription;
        this.fund.createdBy = this.currentUserData.name;
        this.fund.date = new Date();
        this.fund.paymentMode = this.paymentMode;
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        this.fund.pay = this.freezeAmount * this.freezeDays;
        this.fund.totalFeePaid = this.fund.pay;
        this.fund.dueDate = memberObj.settings.dueDate;
        this.fund.month = currentMonth;
        this.fund.year = currentYear;
        this.fund.day = currentDate.getDate().toString();
        this.fund.invoice = AppUtils.generateInvoiceNo(
            memberObj.tagNumber,
            this.customerFees,
            currentYear,
            currentMonth,
        );

        const requestBody = {
            fund: {
                invoice: this.fund.invoice,
                pay: this.fund.pay,
                totalFeePaid: this.fund.totalFeePaid,
                discount: this.fund.discount || 0,
                tax: this.fund.tax || 0,
                status: this.fund.status,
                month: this.fund.month,
                year: this.fund.year,
                day: this.fund.day,
                description: this.fund.description,
                paymentMode: this.fund.paymentMode,
                createdBy: this.fund.createdBy,
                dueDate: this.fund.dueDate,
                scope: this.fund.scope,
                type: this.fund.type,
                initiatedFrom: this.fund.initiatedFrom,
            },
            customer: {
                _id: memberObj._id,
                name: memberObj.name,
                company: memberObj.company,
                branch: memberObj.branch,
                tagNumber: memberObj.tagNumber,
                packageName: memberObj.packageName,
                packageId: memberObj.packageId,
                contactDetail: memberObj.contactDetail,
                extendedFreezingDays: this.freezeDays,
            },
            activity: {
                oldValue: memberObj.freezeDetail.totalFreezingDays || 0,
                newValue: memberObj.freezeDetail?.totalFreezingDays || 0 + this.freezeDays
            },

        };

  const branchId = AuthService.getLoggedInBranch() || memberObj.branch;
  this.appServiceManager
    .post(addFreezingFeeAndDaysUrl(branchId), requestBody)
    .subscribe((res: any) => {
      if (res.status) {
       this.fund=res.data.fee;
       this.member=res.data.customer;
       this.closeAddFreezingDaysDialog();
       this.printSelected(this.fund);
      }
    });
}


    collectFreezeFee() {
     const total = (this.freezeDays || 0) * (this.freezeAmount || 0);

    }


    handleImage(webcamImage: WebcamImage) {
        this.webcamImage = webcamImage;
        if (webcamImage) {
            this.uploadProfile = this.webcamImage;
            this.member.profile = this.webcamImage.imageAsDataUrl;
            this.webcamImage = null;
        }
    }

    handleImagefromNewProfile(webcamImage) {
        if (webcamImage) {
            this.uploadProfile = webcamImage;
            this.member.profile = webcamImage;
            this.webcamImage = null;
            this.hideAddProfileImage();
        }
    }

    cancelFreeze(freeze: IMemberFreezeDetail) {
        this.confirmationService.confirm({
            message:
                this.getSameHistoryGroupConfirmMessage('cancelFreeze') ||
                'Are you sure you want to cancel freeze?',
            accept: () => {
                this.loading = true;
                this.member.freezeDetail.daysLeft = 0;
                const cancelPayload = buildCancelFreezePayload(
                    this.member,
                    this.currentUserData,
                );
                this.appServiceManager
                    .put(
                        customerCancelFreezeUrl(this.user.branch, this.member._id),
                        cancelPayload,
                    )
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.validateMember(this.member);
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Cancelled the freezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }

    //   printing member details
    printMemberDetails(value) {
        this.member = new IMember();
        this.member = value;
        setTimeout(() => {
            this.printMemberDetailInvoice();
        }, 300);
    }

    printSelected(value) {
        this.fundInvoice = new IMemberFeeDetails();
        this.fundInvoice = prepareFeeInvoiceForPrint(value, this.customerFees);
        if (!this.fundInvoice.packageName && this.member?.packageName) {
            this.fundInvoice.packageName = this.member.packageName;
        }
        if (!this.fundInvoice.taxCalculationType) {
            this.fundInvoice.taxCalculationType =
                value?.taxType || this.taxType || '';
        }
        void this.prepareFundFbrThenPrint();
    }

    private async prepareFundFbrThenPrint(): Promise<void> {
        const ids = collectFbrInvoiceIds(this.fundInvoice);
        this.fbrItems = await fbrQrItems(ids);
        this.fbrLogoUrl = this.fbrItems.length ? fbrDiLogoAbsoluteUrl() : '';
        setTimeout(() => {
            this.printInvoice();
        }, 300);
    }

    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById("ID-card").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Gym ID Card</title>
        <style>
            .ID-card {
                width: 400px;
                height: 250px;
                margin: auto;
                position: relative;
                padding: 20px;
                border-radius: 10px;
                background-image: url("https://i.ibb.co/NL188dQ/white-wood.png");
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.35);
                z-index: 10;
                filter: opacity(95%);
            }

            .top-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 0;
            }

            .flag {
                height: 10px;
                margin-right: 5px;
            }

            .card-title,
            .card-title-en {
                line-height: 100%;
            }

            .name,
            .name-en,
            .ID-number {
                font-weight: normal;
            }

            .card-title-en {
                margin-left: auto;
            }

            .middle-row {
                margin-top: 30px;
                display: inline-block;
            }

            .bottom-row {
                position: absolute;
                bottom: 20px;
            }

            .ID-photo {
                display: block;
                width: 100px;
                height: 128px;
                background-repeat: no-repeat;
                background-position: -90px center;
                background-size: 250px;
                position: absolute;
                top: 60px;
                right: 20px;
            }

            .series-number {
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                position: absolute;
                right: -20px;
                bottom: 66px;
                z-index: 10;
            }

            .signature-title {
                position: absolute;
                bottom: 20px;
                right: 20px;
            }

            .signature {
                font-family: "Liu Jian Mao Cao", cursive;
                font-weight: 100;
                position: absolute;
                right: 40px;
                bottom: 35px;
            }

            .ID-number {
                line-height: 100%;
                margin-top: 5px;
            }

            .title {
                text-align: center;
                margin: 16px;
                font-weight: normal;
                font-size: 16px;
                width: 100%;
                position: absolute;
                bottom: 20px;
                z-index: 10;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    // PRINTING MEMBER DETAIL INVOICE
    printMemberDetailInvoice(): void {
        let printContents, popupWin;
        printContents = document.getElementById("memberinvoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Member Detail Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    printInvoice(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name
        printContents = document.getElementById("invoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }
    printMultipleInvoices(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name
        printContents = document.getElementById("multipleInvoices").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    getBranchById() {
        this.loading = true;
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.branchName = this.branch.name;
            this.invoiceData = this.branch.invoiceData;
            this.whatsAppCommunityLink = this.branch.whatsappCommunityInvitationLink;
            this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
            this.allPaymentOptions = this.branch.payments;
            this.isWalletAllowed = this.branch.permissions?.isAllowWallet ?? false;
            this.isDiscountFormulaReverse = !!this.branch.permissions?.isDiscountFormulaReverse;
            this.taxRemovalOnSubscription = !!this.branch.permissions?.taxRemovalOnSubscription;
            if (Array.isArray(this.branch.payments)) {
                this.branch.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
            }
            this.onPaymentModeChange(this.paymentMode);
            this.loading = false;
        }
        if(!this.branch){
            this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
                if (res) {
                    this.branchName = res.name;
                    this.invoiceData = res.invoiceData;
                    this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
                    this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
                    this.allPaymentOptions = res.payments;
                    this.isWalletAllowed = res.permissions?.isAllowWallet ?? false;
                    this.isDiscountFormulaReverse = !!res.permissions?.isDiscountFormulaReverse;
                    this.taxRemovalOnSubscription = !!res.permissions?.taxRemovalOnSubscription;
                    res.payments.forEach(payment => {
                        const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                        if (!existingBank) {
                            this.paymentOptions.push({
                                label: `${payment.type} - ${payment.name}`,
                                value: `${payment.type}-${payment.name}`
                            });
                        }
                    });

                    this.onPaymentModeChange(this.paymentMode);
                } else {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Branch Record Found' });
                }
                this.loading = false;
            },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                });
        }
    }

    openDialog(fee) {
        if (fee.description) {
            this.dialogDescription = fee.description;
        } else {
            this.dialogDescription = "No Comments";
        }
        this.showCommentDialog = true;
        document.body.classList.add('showCommentDialog');
    }

    openSubscriptionDialog(subscription) {
        if (subscription.description) {
            this.dialogDescription = subscription.description;
        } else {
            this.dialogDescription = "No Comments";
        }
        this.showCommentDialog = true;
        document.body.classList.add('showCommentDialog');
    }
    closeDialog() {
        this.showCommentDialog = false;
        document.body.classList.remove('showCommentDialog');
    }
    closeAddBodyVitalsDialog() {
        this.addVitalsDialog = false;
        this.getBodySpecification();
    }

    openWhatsApp(fee) {
        let reciever = this.member.contactDetail.contact;
        if (this.member.contactDetail.contact) {
            // Split payment: share combined invoice/amount (same as print), not one row.
            const shareFee = prepareFeeInvoiceForPrint(fee, this.customerFees);
            let invoice = shareFee.invoice;
            invoice = encodeURIComponent(invoice);
            invoice = invoice.replace(/^Inv%/, "Inv#");
            let pay = parseInt(shareFee.pay);
            let tax = parseInt(shareFee.tax);
            const feeTaxType =
                shareFee.taxCalculationType || shareFee.taxType || this.taxType;
            if(feeTaxType === "WITH_TAX") {
                if(tax !== undefined && tax !== null && tax > 0) {
                    pay = pay + tax;
                }
            }
            let discount = parseInt(shareFee.discount);
            if(discount !== null && discount !== undefined && discount > 0) {
                pay = pay - discount;
            }
            let status = shareFee.status;
            let dueDate = status === "Trainer Fee - Paid"
    ? this.member.customerstrainer?.dueDate
    : this.member.settings.dueDate;
            const formatteddueDate = dueDate ? new Date(dueDate).toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            }) : '';

            if(pay <= 0) {
                pay = 0;
            }

            let date = new Date(shareFee.date);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();
            let day = date.getDate();
            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.invoiceMessage;
            msg = msg.replace("{0}", this.member.name);
            msg = msg.replace("{1}", monthName);
            msg = msg.split("{2}").join(year.toString());
            msg = msg.replace("{3}", day.toString());
            msg = msg.replace("{4}", monthName.toString());
            msg = msg.replace("{5}", year.toString());
            msg = msg.replace("{6}", invoice);
            msg = msg.replace("{7}", pay.toString());
            if (!this.hideTaxInfo) {
                msg = msg.replace("{13}", "\n*Tax:* "+ shareFee.tax);
            }else{
                msg = msg.replace("{13}", "");
            }
            msg = msg.replace("{8}", status);
            msg = msg.replace("{9}", formatteddueDate);
            msg = msg.replace("{10}", this.member.tagNumber);
            msg = msg.replace("{11}", this.branchName);

            if(this.whatsAppCommunityLink){
                msg = msg.replace("{12}", this.whatsAppCommunityLinkMessage);
            }else{
                msg = msg.replace("{12}", '');
            }
            const message = encodeURIComponent(msg);

                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';

        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }

    }

    openWhatsAppWelcome(): string {
        let reciever = this.member.contactDetail.contact;
        if (this.member.contactDetail.contact) {
          let sessionData = localStorage.getItem('currentCompany');
          let parsedData = JSON.parse(sessionData);
          let name = parsedData.name;
          let msg =  this.config.welcomeMessage;

          msg = msg.replace("{0}", this.member.name);
          msg = msg.replace("{1}", name);
          msg = msg.replace("{3}", name);

          if(this.whatsAppCommunityLink){
          msg = msg.replace("{4}", this.whatsAppCommunityLinkMessage);
          }else{
          msg = msg.replace("{4}", '');
          }

          const message = encodeURIComponent(msg);

            const link = document.createElement('a');
            link.href = `https://wa.me/${reciever}?text=${message}`;
            link.target = '_blank';
            link.click();
            return '';

        } else {
          // Show error message here
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: 'This user does not have a phone number',
          });
          return '';
        }
      }
    printAllInvoice(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name + " " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        printContents = document.getElementById("allInvoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    openAllReceiptEmailConfirmation() {
        this.closeEmailConfirmation();
        this.showEmailReceiptConfirmationBox = true;
        this.email.to = this.member.email;
        this.email.subject = this.branch.name + ' | ' + 'All Invoices Receipt' + ' | ' + 'Date:' + this.datePipe.transform(new Date(), 'dd-MMM-yy');
        this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is a receipt of all invoices of your<i> Gym Fee</i>, The receipt details are as under:</p>' + this.getAllReceiptEmailBodyHtml();
    }

    openSingleReceiptEmailConfirmation(value) {
        this.closeEmailConfirmation();
        this.showEmailSingleReceiptConfirmationBox = true;
        this.fundInvoice = new IMemberFeeDetails();
        this.fundInvoice = value;
        setTimeout(() => {
            this.getSingleInvoicesHtml();
        }, 300);
        this.email.to = this.member.email;
        this.email.subject = this.branch.name + ' | ' + 'Invoice Receipt' + ' | ' + 'Invoice Date:' + this.datePipe.transform(new Date(value.date), 'dd-MMM-yy');
        setTimeout(() => {
            let singleHtmlBody: any = this.getSingleReceiptEmailBodyHtml();
            this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is an invoice receipt of your<i> Gym Fee</i>, The receipt details are as under:</p>' + singleHtmlBody;
        }, 100);

    }

    closeEmailConfirmation() {
        if (this.showEmailReceiptConfirmationBox) {
            this.showEmailReceiptConfirmationBox = false;

        } else if (this.showEmailSingleReceiptConfirmationBox) {
            this.showEmailSingleReceiptConfirmationBox = false;
        }
    }
    getAllInvoicesHtml() {
        let printContents;
        printContents = document.getElementById('allInvoice').innerHTML;
        let htmlToPdf = `<html>
		<head>
			 <title>Gym Invoice</title>
			 <style>
				  .invoice-box {
						max-width: 800px;
						margin: auto;
						padding: 30px;
						border: 1px solid #eee;
						box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
						font-size: 16px;
						line-height: 24px;
						font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
						color: #555;
				  }

				  .invoice-box table {
						width: 100%;
						line-height: inherit;
						text-align: left;
				  }

				  .invoice-box table td {
						padding: 5px;
						vertical-align: top;
				  }

				  .invoice-box table tr td:nth-child(n + 2) {
						text-align: right;
				  }

				  .invoice-box table tr.top table td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.top table td.title {
						font-size: 45px;
						line-height: 45px;
						color: #333;
				  }

				  .invoice-box table tr.information table td {
						padding-bottom: 40px;
				  }

				  .invoice-box table tr.heading td {
						background: #eee;
						border-bottom: 1px solid #ddd;
						font-weight: bold;
				  }

				  .invoice-box table tr.details td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.item td {
						border-bottom: 1px solid #eee;
				  }
				  .invoice-box table tr.item.last td {
						border-bottom: none;
				  }
				  .invoice-box table tr.item input {
						padding-left: 5px;
				  }
				  .invoice-box table tr.item td:first-child input {
						margin-left: -5px;
						width: 100%;
				  }
				  .invoice-box table tr.total td:nth-child(2) {
						border-top: 2px solid #eee;
						font-weight: bold;
				  }
				  .invoice-box input[type="number"] {
						width: 60px;
				  }
				  @media only screen and (max-width: 600px) {
						.invoice-box table tr.top table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}

						.invoice-box table tr.information table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}
				  }
				  .rtl {
						direction: rtl;
						font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
							 sans-serif;
				  }
				  .rtl table {
						text-align: right;
				  }
				  .rtl table tr td:nth-child(2) {
						text-align: left;
				  }
			 </style>
		</head>
		<body>${printContents}</body>
		</html>`

        return htmlToPdf;
    }

    getSingleInvoicesHtml() {
        let printContents;
        printContents = document.getElementById('invoice').innerHTML;
        let htmlToPdf = `<html>
		<head>
			 <title>Gym Invoice</title>
			 <style>
				  .invoice-box {
						max-width: 800px;
						margin: auto;
						padding: 30px;
						border: 1px solid #eee;
						box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
						font-size: 16px;
						line-height: 24px;
						font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
						color: #555;
				  }

				  .invoice-box table {
						width: 100%;
						line-height: inherit;
						text-align: left;
				  }

				  .invoice-box table td {
						padding: 5px;
						vertical-align: top;
				  }

				  .invoice-box table tr td:nth-child(n + 2) {
						text-align: right;
				  }

				  .invoice-box table tr.top table td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.top table td.title {
						font-size: 45px;
						line-height: 45px;
						color: #333;
				  }

				  .invoice-box table tr.information table td {
						padding-bottom: 40px;
				  }

				  .invoice-box table tr.heading td {
						background: #eee;
						border-bottom: 1px solid #ddd;
						font-weight: bold;
				  }

				  .invoice-box table tr.details td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.item td {
						border-bottom: 1px solid #eee;
				  }
				  .invoice-box table tr.item.last td {
						border-bottom: none;
				  }
				  .invoice-box table tr.item input {
						padding-left: 5px;
				  }
				  .invoice-box table tr.item td:first-child input {
						margin-left: -5px;
						width: 100%;
				  }
				  .invoice-box table tr.total td:nth-child(2) {
						border-top: 2px solid #eee;
						font-weight: bold;
				  }
				  .invoice-box input[type="number"] {
						width: 60px;
				  }
				  @media only screen and (max-width: 600px) {
						.invoice-box table tr.top table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}

						.invoice-box table tr.information table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}
				  }
				  .rtl {
						direction: rtl;
						font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
							 sans-serif;
				  }
				  .rtl table {
						text-align: right;
				  }
				  .rtl table tr td:nth-child(2) {
						text-align: left;
				  }
			 </style>
		</head>
		<body>${printContents}</body>
		</html>`

        return htmlToPdf;
    }

    sendInvoiceEmailAsPdf() {
        if (this.showEmailReceiptConfirmationBox) {
            let htmlToPdf = this.getAllInvoicesHtml();
            this.confirmationService.confirm({
                message: "Are you sure you want to proceed?",
                accept: () => {
                    this.loader.show();
                    this.loading = true;
                    this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
                        {
                            data: htmlToPdf,
                            invoiceDay: this.fundInvoice.date,
                            subject: this.email.subject,
                            body: this.email.body,
                            to: this.email.to,
                            company: this.company.name

                        }).subscribe((res) => {
                            this.loading = false;
                            this.loader.hide();
                            this.showEmailReceiptConfirmationBox = false;
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
                        },
                            (error) => {
                                this.loading = false;
                                this.loader.hide();
                                this.showEmailReceiptConfirmationBox = false;
                                this.messageService.clear();
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                            }
                        )
                }
            });

        } else if (this.showEmailSingleReceiptConfirmationBox) {
            let htmlToPdf = this.getSingleInvoicesHtml();
            this.confirmationService.confirm({
                message: "Are you sure you want to proceed?",
                accept: () => {
                    this.loader.show();
                    this.loading = true;
                    this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
                        {
                            data: htmlToPdf,
                            invoiceDay: this.fundInvoice.date,
                            subject: this.email.subject,
                            body: this.email.body,
                            to: this.email.to,
                            company: this.company.name

                        }).subscribe((res) => {
                            this.loading = false;
                            this.loader.hide();
                            this.showEmailSingleReceiptConfirmationBox = false;
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
                        },
                            (error) => {
                                this.loading = false;
                                this.loader.hide();
                                this.showEmailSingleReceiptConfirmationBox = false;
                                this.messageService.clear();
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                            }
                        )
                }
            });
        }
    }

    getAllReceiptEmailBodyHtml() {
        let printContents;
        printContents = document.getElementById('allInvoiceHtmlBody').innerHTML;
        this.htmlToPdf = `<html>
		<body>${printContents}</body>
        </html>`

        return this.htmlToPdf;
    }

    getSingleReceiptEmailBodyHtml() {
        let printContents;
        printContents = document.getElementById('invoiceHtmlBody').innerHTML;
        this.htmlToPdf = `<html>
		<body>${printContents}</body>
		</html>`

        return this.htmlToPdf;
    }

    ShowCommentBox(fee) {
        if (fee.description != undefined) {
            this.showCommentBox = true;
            this.fund.description = fee.description;
        } else {
            return;
        }
    }

    handleSwitchChange() {
        let data = {
            company: this.user.company,
            branch: this.user.branch,
            isLocked: this.member.isLocked,
            modifiedBy: this.user._id
        }
        this.appServiceManager
            .put("customers/changeLockedStatus/" + this.member._id, data)
            .subscribe((res: any) => {
                if (res) {
                    this.member = res.customer;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Status Successfully changed",
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }


    getTrainerShare() {
        var x = parseInt(this.member.customerstrainer.totalFees) - parseInt(this.member.customerstrainer.gymShare);
        if (isNaN(x)) {
            this.member.customerstrainer.trainerShare = undefined;
            this.isGymShareMoreThanTrainerFee = true;

        } else {
            if (x >= 0) {
                this.member.customerstrainer.trainerShare = x.toString();
                this.isGymShareMoreThanTrainerFee = false;

            } else {
                this.member.customerstrainer.trainerShare = undefined;
                this.isGymShareMoreThanTrainerFee = true;
            }

        }
    }

    onChangeTrainerFee() {
        this.member.customerstrainer.trainerShare = '0';
        this.member.customerstrainer.gymShare = '0';
    }

    checkEmailExistence() {
        const normalizedEmail = (this.member.email || '').trim();
        if (normalizedEmail.length > 0) {
            this.isEmailLoader = true;
            const data: { email: string; memberId?: string } = { email: normalizedEmail };
            if (this.memberID) {
                data.memberId = this.memberID;
            }
            this.appServiceManager.post(
                'branches/' + AuthService.getLoggedInBranch() + '/customers/actions/check-email-existence',
                data,
            ).subscribe(
                (member: any) => {
                    this.isEmailExist = !!member.isEmailExist;
                    this.isEmailLoader = false;
                },
                () => {
                    this.isEmailLoader = false;
                }
            );
        }
    }
    isDateDisabled(): boolean {
        return this.role.name.toLowerCase() === 'operator' || this.role.name.toLowerCase() === 'trainer';
    }

    shouldHideFreezeMemberButton(): boolean {
        const permissions = this.branch?.permissions;
        const disableFreezePermissionExists = !!permissions && Object.prototype.hasOwnProperty.call(permissions, "disabledFreeze");
        const isOperator = (this.user?.role || this.role?.name || "").toLowerCase() === "operator";

        if (!disableFreezePermissionExists) {
            return false;
        }

        return (permissions as any)?.disabledFreeze === true && isOperator;
    }

    getInvoiceDateColor(fee: any): string {
        const dueDate = new Date(fee.year, fee.month - 1, fee.day);
        const invoiceDate = new Date(fee.date);

        if (dueDate > invoiceDate) {
            return 'green';
        }
        else if (dueDate.getDate() == invoiceDate.getDate() && dueDate.getMonth() + 1 == invoiceDate.getMonth() + 1 && dueDate.getFullYear() == invoiceDate.getFullYear()) {
            return 'green';
        }
        else {
            return 'red';
        }
    }
    getMonthName(month: number): string {
        return AppUtils.getMonthName(month);
    }
    checkEmailExistEvent(emailValue: string) {
        const currentEmail = (emailValue || '').trim().toLowerCase();
        const originalEmail = (this.dbEmailIfCustomerHAve || '').trim().toLowerCase();
        const isSameAsOriginalInEditMode = this.mode === "edit" && currentEmail === originalEmail;

        clearTimeout(this.timer);

        if (!currentEmail || isSameAsOriginalInEditMode) {
            this.isEmailExist = false;
            this.isEmailLoader = false;
            return;
        }

        this.isEmailLoader = true;
        this.isEmailExist = false;

        this.timer = setTimeout(() => {
            this.member.email = emailValue;
            this.checkEmailExistence();
        }, 500);
    }

    hotkeysMemberDetails($event) {
        if (($event.keyCode == 39 || $event.keyCode == 37) && this.mode == "edit") {
            var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
            var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
            var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
            if (confirmationBoxButtonExistLength > 0) {
                if (document.activeElement.tagName === "BODY") {
                    confirmationBoxButtonExist[0].focus();
                }
                else {
                    if (document.activeElement === confirmationBoxButtonExist[0]) {
                        confirmationBoxButtonExist[1].focus();
                    }
                    else if (document.activeElement === confirmationBoxButtonExist[1]) {
                        confirmationBoxButtonExist[0].focus();
                    }
                    else {
                        confirmationBoxButtonExist[0].focus();
                    }
                }
            }
        }
    }

    canShowMemberImage(): boolean {
        const role = this.currentUserData?.role;
        const gender = this.currentUserData?.gender;

        return (
            ['Super Admin', 'Admin', 'Trainer','MANAGER'].includes(role) ||
            (role === 'Operator' && (gender === 'F' || gender === 'M'))
        );
    }
    memberImageSrc(member: any): string {
        member = this.member;
        const role = this.currentUserData?.role;
        const userGender = this.currentUserData?.gender;

        // -------------------------
        // Operator Male restriction
        // -------------------------
        const isOperatorMale = role === 'Operator' && userGender === 'M';
        const isFemaleMember = member?.gender === 'F';

        // uploadProfile = true → local preview
        if (this.uploadProfile) {
            if (isOperatorMale && isFemaleMember) {
                return 'assets/layout/images/avatarGirlImage.png';
            }

            return (
                member?.profile ||
                (isFemaleMember
                    ? 'assets/layout/images/avatarGirlImage.png'
                    : 'assets/layout/images/avatarBoyImage.png')
            );
        }

        // uploadProfile = false → server image
        if (member?.profile && !(isOperatorMale && isFemaleMember)) {
            return (
                this.config.Server +
                this.config.memberImagePath +
                member.profile
            );
        }

        return isFemaleMember
            ? 'assets/layout/images/avatarGirlImage.png'
            : 'assets/layout/images/avatarBoyImage.png';
    }
    onImageError(event: Event) {
        (event.target as HTMLImageElement).src =
            'assets/layout/images/avatarBoyImage.png';
    }

    getMemberOpacity(member: any): string {
        return member?.isDelete || member?.freezeDetail?.isFreeze
            ? '0.3'
            : '1';
    }
    getRelatedMembersGroup() {
        if (!this.member.relatedMembersId) return;
        if (this.relatedMembersGroup) return;
        this.fetchRelatedMembersGroup().catch((error) => {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error?.message || this.setLabel("relatedMembersGroupLoadFailedLabel"),
            });
        });
    }

    openAddRelatedMemberDialog() {
        this.selectedMemberToAddId = '';

        if (!this.showRelatedMembersTab()) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('relatedMembersPackageNotEligibleLabel'),
            });
            return;
        }

        // Existing group: ensure loaded before capacity + options
        if (this.member?.relatedMembersId && !this.relatedMembersGroup) {
            this.fetchRelatedMembersGroup()
                .then(() => this.openAddRelatedMemberDialog())
                .catch((error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail:
                            error?.message ||
                            this.setLabel('relatedMembersGroupLoadFailedLabel'),
                    });
                });
            return;
        }

        if (!this.submitAddMemberCheck()) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('relatedMembersGroupPackageInsufficientMembersLabel'),
            });
            return;
        }

        const packageIdForOptions = this.resolvePackageIdForRelatedMemberOptions();
        if (!packageIdForOptions) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('packageNotSelectedLabel'),
            });
            return;
        }

        const cacheIsValid =
            this.branchMembersOptions.length > 0 &&
            this.branchMembersOptionsPackageId != null &&
            this.branchMembersOptionsPackageId === packageIdForOptions;

        if (cacheIsValid) {
            this.addRelatedMemberDialogVisible = true;
            return;
        }

        // Stale cache for a different package — reload
        this.clearBranchMembersOptionsCache();
        this.loadBranchMembersOptionsForDialog();
    }

    private resolvePackageIdForRelatedMemberOptions(): string | null {
        const packageId =
            this.relatedMembersGroup?.packageId ||
            this.member?.packageId ||
            this.selectedMemberPackage?._id;
        if (packageId == null || packageId === '' || packageId === 'Select Package') {
            return null;
        }
        return String(packageId);
    }

    private clearBranchMembersOptionsCache() {
        this.branchMembersOptions = [];
        this.memebrsOfBranchWithRelatedPackage = [];
        this.branchMembersOptionsPackageId = null;
        this.selectedMemberToAddId = '';
    }

    private loadBranchMembersOptionsForDialog() {
        const packageIdForOptions = this.resolvePackageIdForRelatedMemberOptions();
        if (!packageIdForOptions) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('packageNotSelectedLabel'),
            });
            return;
        }

        this.addRelatedMemberOptionsLoading = true;
        this.appServiceManager
            .get(
                'branches/' +
                    this.user.branch +
                    '/customers/actions/branch-members-options/' +
                    packageIdForOptions,
            )
            .subscribe(
                (res: any) => {
                    if (res.status && res.response && res.response.length > 0) {
                        const candidates = res.response.filter(
                            (m: any) => String(m._id) !== String(this.member._id),
                        );
                        if (candidates.length === 0) {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error Message',
                                detail: this.setLabel('relatedMembersNoEligibleCandidatesLabel'),
                            });
                            return;
                        }
                        this.branchMembersOptions = candidates.map((m) => ({
                            label: m.name + ' (' + m.tagNumber + ')',
                            value: m._id,
                        }));
                        this.memebrsOfBranchWithRelatedPackage = candidates;
                        this.branchMembersOptionsPackageId = String(packageIdForOptions);
                        this.addRelatedMemberDialogVisible = true;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error Message',
                            detail:
                                res?.message ||
                                (typeof res?.error === 'string' ? res.error : res?.error?.message) ||
                                this.setLabel('relatedMembersNoEligibleCandidatesLabel'),
                        });
                    }
                },
                (error) => {
                    this.addRelatedMemberOptionsLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: error.error?.message || error,
                    });
                },
                () => {
                    this.addRelatedMemberOptionsLoading = false;
                },
            );
    }

    removeFromRelatedMembersGroup() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to remove this member from this group?',
            accept: () => {
                this.appServiceManager
                .delete(
                    `branches/${this.user.branch}/customers/actions/related-members-group/${this.member.relatedMembersId}/members/${this.member._id}`)
                    .subscribe(
                        (res: any) => {
                            this.member.relatedMembersId = null;
                            this.relatedMembersGroup = null;
                            this.clearBranchMembersOptionsCache();
                            this.showRelatedMembersTab();
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Removed from group successfully.' });
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error?.message || error });
                        }
                    );
            }
        });
    }

    confirmAddRelatedMember() {
        this.addRelatedMemberDialogVisible = false;
        if (!this.selectedMemberToAddId) return;

        if (!this.showRelatedMembersTab()) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('relatedMembersPackageNotEligibleLabel'),
            });
            return;
        }

        if (!this.submitAddMemberCheck()) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('relatedMembersGroupPackageInsufficientMembersLabel'),
            });
            return;
        }

        const memberToAdd = this.memebrsOfBranchWithRelatedPackage.find(
            (m) => m._id === this.selectedMemberToAddId,
        );
        if (!memberToAdd) return;

        const groupOrMemberPackageId = this.resolvePackageIdForRelatedMemberOptions();
        if (!groupOrMemberPackageId) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('packageNotSelectedLabel'),
            });
            return;
        }
        if (String(memberToAdd.packageId) !== String(groupOrMemberPackageId)) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('relatedMembersSamePackageRequiredLabel'),
            });
            return;
        }

        if (this.member?.relatedMembersId) {
            this.addMemberToExistingRelatedGroup(memberToAdd);
        } else {
            this.createRelatedMembersGroupWithSelected(memberToAdd);
        }
    }

    private addMemberToExistingRelatedGroup(memberToAdd: any) {
        const payload: Record<string, unknown> = {
            memberId: memberToAdd._id,
            name: memberToAdd.name,
            phone: memberToAdd.contactDetail?.contact,
            tagNumber: memberToAdd.tagNumber,
        };
        if (this.isSameHistoryActive() && this.member?._id) {
            payload.anchorMemberId = this.member._id;
        }
        this.appServiceManager
            .put(
                'branches/' +
                    this.user.branch +
                    '/customers/actions/related-members-group/' +
                    this.member.relatedMembersId +
                    '/members',
                payload,
            )
            .subscribe(
                (res: any) => {
                    if (res?.status && res.response) {
                        this.relatedMembersGroup = res.response;
                        this.branchMembersOptions = this.branchMembersOptions.filter(
                            (option) => option.value !== this.selectedMemberToAddId,
                        );
                        this.selectedMemberToAddId = '';
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Member added to group successfully.',
                        });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error Message',
                            detail:
                                res?.message ||
                                (typeof res?.error === 'string'
                                    ? res.error
                                    : res?.error?.message) ||
                                'Failed to add member to group.',
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: error.error?.message || error,
                    });
                },
            );
    }

    private createRelatedMembersGroupWithSelected(memberToAdd: any) {
        const packageId = this.resolvePackageIdForRelatedMemberOptions();
        if (!packageId) {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: this.setLabel('packageNotSelectedLabel'),
            });
            return;
        }
        const payload = {
            packageId,
            members: [
                {
                    memberId: this.member._id,
                    name: this.member.name,
                    phone: this.member.contactDetail?.contact,
                    tagNumber: this.member.tagNumber,
                },
                {
                    memberId: memberToAdd._id,
                    name: memberToAdd.name,
                    phone: memberToAdd.contactDetail?.contact,
                    tagNumber: memberToAdd.tagNumber,
                },
            ],
            company: this.user.company,
            branch: this.user.branch,
        };

        this.appServiceManager
            .post(
                `branches/${this.user.branch}/customers/actions/create-related-members-group`,
                payload,
            )
            .subscribe(
                (res: any) => {
                    if (res?.status && res.response) {
                        this.relatedMembersGroup = res.response;
                        this.member.relatedMembersId = res.response._id;
                        this.branchMembersOptions = this.branchMembersOptions.filter(
                            (option) => option.value !== this.selectedMemberToAddId,
                        );
                        this.selectedMemberToAddId = '';
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.setLabel('relatedMembersGroupCreatedSuccessLabel'),
                        });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error Message',
                            detail:
                                res?.message ||
                                (typeof res?.error === 'string'
                                    ? res.error
                                    : res?.error?.message) ||
                                this.setLabel('relatedMembersGroupCreateFailedLabel'),
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail:
                            error.error?.message ||
                            error?.message ||
                            this.setLabel('relatedMembersGroupCreateFailedLabel'),
                    });
                },
            );
    }

    generateMemberAccessQr(): void {
        const memberId = this.member?._id || this.memberID;
        if (!memberId) {
            this.memberAccessQrStatus = 'Member ID is required';
            return;
        }

        this.memberAccessQrLoading = true;
        this.memberAccessQrStatus = 'Calling API…';
        this.clearMemberAccessQrBox();

        const base = String(this.config.Server || '').replace(/\/+$/, '');
        const url = `${base}/api/accesscontrol/generate-qr/${encodeURIComponent(memberId)}`;

        this._http.get<{ status?: boolean | string; qrPayload?: string; message?: string }>(url).subscribe({
            next: (res) => {
                if (res?.status !== true || !res.qrPayload) {
                    this.memberAccessQrLoading = false;
                    this.memberAccessQrStatus =
                        res?.message ||
                        (typeof res?.status === 'string' ? res.status : 'Failed to generate QR');
                    return;
                }

                this.renderMemberAccessQr(res.qrPayload)
                    .then(() => {
                        this.memberAccessQrStatus = 'QR generated';
                    })
                    .catch((err) => {
                        this.memberAccessQrStatus = err?.message || 'Failed to render QR';
                    })
                    .finally(() => {
                        this.memberAccessQrLoading = false;
                    });
            },
            error: (err) => {
                this.memberAccessQrLoading = false;
                this.memberAccessQrStatus =
                    err?.error?.message || err?.message || 'Failed to generate QR';
            },
        });
    }

    private clearMemberAccessQrBox(): void {
        const box = this.memberAccessQrBox?.nativeElement as HTMLElement;
        if (box) {
            box.innerHTML = '';
        }
    }

    private loadQrCodeLibrary(): Promise<any> {
        const existing = (window as any).QRCode;
        if (existing) {
            return Promise.resolve(existing);
        }
        if (this.qrCodeLibPromise) {
            return this.qrCodeLibPromise;
        }

        this.qrCodeLibPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'assets/js/qrcode.min.js';
            script.onload = () => {
                const lib = (window as any).QRCode;
                if (lib) {
                    resolve(lib);
                } else {
                    this.qrCodeLibPromise = null;
                    reject(new Error('QR library failed to load'));
                }
            };
            script.onerror = () => {
                this.qrCodeLibPromise = null;
                reject(new Error('QR library failed to load'));
            };
            document.body.appendChild(script);
        });

        return this.qrCodeLibPromise;
    }

    private renderMemberAccessQr(qrPayload: string): Promise<void> {
        return this.loadQrCodeLibrary().then((QRCodeLib) => {
            const box = this.memberAccessQrBox?.nativeElement as HTMLElement;
            if (!box) {
                throw new Error('QR container is not available');
            }
            box.innerHTML = '';
            new QRCodeLib(box, {
                text: qrPayload,
                width: 256,
                height: 256,
                correctLevel: QRCodeLib.CorrectLevel.M,
            });
        });
    }

    submitAddMemberCheck(): boolean {
        if (!this.selectedMemberPackage) {
            return false;
        }
        if (this.selectedMemberPackage.isGreaterthanNoOfMembers) {
            return true;
        }
        const currentSize = this.relatedMembersGroup?.members?.length
            ? this.relatedMembersGroup.members.length
            : 1; // current member only when creating a new group
        return currentSize < this.selectedMemberPackage.noOfMembers;
    }
}
